var b_ = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, ce = "1.9.0", So = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/, N_ = function(e) {
  var t = /* @__PURE__ */ new Set([e]), n = /* @__PURE__ */ new Set(), r = e.match(So);
  if (!r) return function() {
    return !1;
  };
  var o = +r[1], i = +r[2], a = +r[3];
  if (r[4] != null) return function(l) {
    return l === e;
  };
  function u(l) {
    return n.add(l), !1;
  }
  function c(l) {
    return t.add(l), !0;
  }
  return function(l) {
    if (t.has(l)) return !0;
    if (n.has(l)) return !1;
    var s = l.match(So);
    if (!s) return u(l);
    var p = +s[1], v = +s[2], g = +s[3];
    return s[4] != null || o !== p ? u(l) : o === 0 ? i === v && a <= g ? c(l) : u(l) : i <= v ? c(l) : u(l);
  };
}(ce), L_ = ce.split(".")[0], Ye = Symbol.for("opentelemetry.js.api." + L_), ze = b_;
function Ke(e, t, n, r) {
  var o;
  r === void 0 && (r = !1);
  var i = ze[Ye] = (o = ze[Ye]) !== null && o !== void 0 ? o : { version: ce };
  if (!r && i[e]) {
    var a = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
    return n.error(a.stack || a.message), !1;
  }
  return i.version !== ce ? (a = new Error("@opentelemetry/api: Registration of version v" + i.version + " for " + e + " does not match previously registered API v" + ce), n.error(a.stack || a.message), !1) : (i[e] = t, n.debug("@opentelemetry/api: Registered a global for " + e + " v" + ce + "."), !0);
}
function _e(e) {
  var t, n, r = (t = ze[Ye]) === null || t === void 0 ? void 0 : t.version;
  if (r && N_(r)) return (n = ze[Ye]) === null || n === void 0 ? void 0 : n[e];
}
function qe(e, t) {
  t.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + ce + ".");
  var n = ze[Ye];
  n && delete n[e];
}
var yt, C_ = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, w_ = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}, M_ = function() {
  function e(t) {
    this._namespace = t.namespace || "DiagComponentLogger";
  }
  return e.prototype.debug = function() {
    for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
    return Ie("debug", this._namespace, t);
  }, e.prototype.error = function() {
    for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
    return Ie("error", this._namespace, t);
  }, e.prototype.info = function() {
    for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
    return Ie("info", this._namespace, t);
  }, e.prototype.warn = function() {
    for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
    return Ie("warn", this._namespace, t);
  }, e.prototype.verbose = function() {
    for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
    return Ie("verbose", this._namespace, t);
  }, e;
}();
function Ie(e, t, n) {
  var r = _e("diag");
  if (r) return n.unshift(t), r[e].apply(r, w_([], C_(n), !1));
}
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(yt || (yt = {}));
var P_ = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, I_ = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}, Wt = function() {
  function e() {
    function t(r) {
      return function() {
        for (var o = [], i = 0; i < arguments.length; i++) o[i] = arguments[i];
        var a = _e("diag");
        if (a) return a[r].apply(a, I_([], P_(o), !1));
      };
    }
    var n = this;
    n.setLogger = function(r, o) {
      var i, a, u;
      if (o === void 0 && (o = { logLevel: yt.INFO }), r === n) {
        var c = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
        return n.error((i = c.stack) !== null && i !== void 0 ? i : c.message), !1;
      }
      typeof o == "number" && (o = { logLevel: o });
      var l = _e("diag"), s = function(v, g) {
        function b(H, P) {
          var N = g[H];
          return typeof N == "function" && v >= P ? N.bind(g) : function() {
          };
        }
        return v < yt.NONE ? v = yt.NONE : v > yt.ALL && (v = yt.ALL), g = g || {}, { error: b("error", yt.ERROR), warn: b("warn", yt.WARN), info: b("info", yt.INFO), debug: b("debug", yt.DEBUG), verbose: b("verbose", yt.VERBOSE) };
      }((a = o.logLevel) !== null && a !== void 0 ? a : yt.INFO, r);
      if (l && !o.suppressOverrideMessage) {
        var p = (u = new Error().stack) !== null && u !== void 0 ? u : "<failed to generate stacktrace>";
        l.warn("Current logger will be overwritten from " + p), s.warn("Current logger will overwrite one already registered from " + p);
      }
      return Ke("diag", s, n, !0);
    }, n.disable = function() {
      qe("diag", n);
    }, n.createComponentLogger = function(r) {
      return new M_(r);
    }, n.verbose = t("verbose"), n.debug = t("debug"), n.info = t("info"), n.warn = t("warn"), n.error = t("error");
  }
  return e.instance = function() {
    return this._instance || (this._instance = new e()), this._instance;
  }, e;
}(), D_ = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, U_ = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, k_ = function() {
  function e(t) {
    this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
  }
  return e.prototype.getEntry = function(t) {
    var n = this._entries.get(t);
    if (n) return Object.assign({}, n);
  }, e.prototype.getAllEntries = function() {
    return Array.from(this._entries.entries()).map(function(t) {
      var n = D_(t, 2);
      return [n[0], n[1]];
    });
  }, e.prototype.setEntry = function(t, n) {
    var r = new e(this._entries);
    return r._entries.set(t, n), r;
  }, e.prototype.removeEntry = function(t) {
    var n = new e(this._entries);
    return n._entries.delete(t), n;
  }, e.prototype.removeEntries = function() {
    for (var t, n, r = [], o = 0; o < arguments.length; o++) r[o] = arguments[o];
    var i = new e(this._entries);
    try {
      for (var a = U_(r), u = a.next(); !u.done; u = a.next()) {
        var c = u.value;
        i._entries.delete(c);
      }
    } catch (l) {
      t = { error: l };
    } finally {
      try {
        u && !u.done && (n = a.return) && n.call(a);
      } finally {
        if (t) throw t.error;
      }
    }
    return i;
  }, e.prototype.clear = function() {
    return new e();
  }, e;
}(), x_ = Symbol("BaggageEntryMetadata"), V_ = Wt.instance();
function B_(e) {
  return e === void 0 && (e = {}), new k_(new Map(Object.entries(e)));
}
function G_(e) {
  return typeof e != "string" && (V_.error("Cannot create baggage metadata from unknown type: " + typeof e), e = ""), { __TYPE__: x_, toString: function() {
    return e;
  } };
}
function xr(e) {
  return Symbol.for(e);
}
var rn, ae, H_ = function e(t) {
  var n = this;
  n._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), n.getValue = function(r) {
    return n._currentContext.get(r);
  }, n.setValue = function(r, o) {
    var i = new e(n._currentContext);
    return i._currentContext.set(r, o), i;
  }, n.deleteValue = function(r) {
    var o = new e(n._currentContext);
    return o._currentContext.delete(r), o;
  };
}, Zt = new H_(), Xn = [{ n: "error", c: "error" }, { n: "warn", c: "warn" }, { n: "info", c: "info" }, { n: "debug", c: "debug" }, { n: "verbose", c: "trace" }], MS = function() {
  function e(n) {
    return function() {
      for (var r = [], o = 0; o < arguments.length; o++) r[o] = arguments[o];
      if (console) {
        var i = console[n];
        if (typeof i != "function" && (i = console.log), typeof i == "function") return i.apply(console, r);
      }
    };
  }
  for (var t = 0; t < Xn.length; t++) this[Xn[t].n] = e(Xn[t].c);
}, Te = (rn = function(e, t) {
  return rn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
  }, rn(e, t);
}, function(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  function n() {
    this.constructor = e;
  }
  rn(e, t), e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}), j_ = function() {
  function e() {
  }
  return e.prototype.createGauge = function(t, n) {
    return Q_;
  }, e.prototype.createHistogram = function(t, n) {
    return J_;
  }, e.prototype.createCounter = function(t, n) {
    return q_;
  }, e.prototype.createUpDownCounter = function(t, n) {
    return $_;
  }, e.prototype.createObservableGauge = function(t, n) {
    return eh;
  }, e.prototype.createObservableCounter = function(t, n) {
    return th;
  }, e.prototype.createObservableUpDownCounter = function(t, n) {
    return nh;
  }, e.prototype.addBatchObservableCallback = function(t, n) {
  }, e.prototype.removeBatchObservableCallback = function(t) {
  }, e;
}(), Pn = function() {
}, F_ = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Te(t, e), t.prototype.add = function(n, r) {
  }, t;
}(Pn), Y_ = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Te(t, e), t.prototype.add = function(n, r) {
  }, t;
}(Pn), z_ = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Te(t, e), t.prototype.record = function(n, r) {
  }, t;
}(Pn), Z_ = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Te(t, e), t.prototype.record = function(n, r) {
  }, t;
}(Pn), Vr = function() {
  function e() {
  }
  return e.prototype.addCallback = function(t) {
  }, e.prototype.removeCallback = function(t) {
  }, e;
}(), X_ = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Te(t, e), t;
}(Vr), W_ = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Te(t, e), t;
}(Vr), K_ = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Te(t, e), t;
}(Vr), wi = new j_(), q_ = new F_(), Q_ = new z_(), J_ = new Z_(), $_ = new Y_(), th = new X_(), eh = new W_(), nh = new K_();
function rh() {
  return wi;
}
(function(e) {
  e[e.INT = 0] = "INT", e[e.DOUBLE = 1] = "DOUBLE";
})(ae || (ae = {}));
var Kt, oh = { get: function(e, t) {
  if (e != null) return e[t];
}, keys: function(e) {
  return e == null ? [] : Object.keys(e);
} }, ih = { set: function(e, t, n) {
  e != null && (e[t] = n);
} }, ah = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, sh = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}, uh = function() {
  function e() {
  }
  return e.prototype.active = function() {
    return Zt;
  }, e.prototype.with = function(t, n, r) {
    for (var o = [], i = 3; i < arguments.length; i++) o[i - 3] = arguments[i];
    return n.call.apply(n, sh([r], ah(o), !1));
  }, e.prototype.bind = function(t, n) {
    return n;
  }, e.prototype.enable = function() {
    return this;
  }, e.prototype.disable = function() {
    return this;
  }, e;
}(), ch = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, lh = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}, Wn = "context", ph = new uh(), In = function() {
  function e() {
  }
  return e.getInstance = function() {
    return this._instance || (this._instance = new e()), this._instance;
  }, e.prototype.setGlobalContextManager = function(t) {
    return Ke(Wn, t, Wt.instance());
  }, e.prototype.active = function() {
    return this._getContextManager().active();
  }, e.prototype.with = function(t, n, r) {
    for (var o, i = [], a = 3; a < arguments.length; a++) i[a - 3] = arguments[a];
    return (o = this._getContextManager()).with.apply(o, lh([t, n, r], ch(i), !1));
  }, e.prototype.bind = function(t, n) {
    return this._getContextManager().bind(t, n);
  }, e.prototype._getContextManager = function() {
    return _e(Wn) || ph;
  }, e.prototype.disable = function() {
    this._getContextManager().disable(), qe(Wn, Wt.instance());
  }, e;
}();
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(Kt || (Kt = {}));
var Mi = "0000000000000000", Pi = "00000000000000000000000000000000", Ii = { traceId: Pi, spanId: Mi, traceFlags: Kt.NONE }, Ge = function() {
  function e(t) {
    t === void 0 && (t = Ii), this._spanContext = t;
  }
  return e.prototype.spanContext = function() {
    return this._spanContext;
  }, e.prototype.setAttribute = function(t, n) {
    return this;
  }, e.prototype.setAttributes = function(t) {
    return this;
  }, e.prototype.addEvent = function(t, n) {
    return this;
  }, e.prototype.addLink = function(t) {
    return this;
  }, e.prototype.addLinks = function(t) {
    return this;
  }, e.prototype.setStatus = function(t) {
    return this;
  }, e.prototype.updateName = function(t) {
    return this;
  }, e.prototype.end = function(t) {
  }, e.prototype.isRecording = function() {
    return !1;
  }, e.prototype.recordException = function(t, n) {
  }, e;
}(), Br = xr("OpenTelemetry Context Key SPAN");
function Gr(e) {
  return e.getValue(Br) || void 0;
}
function fh() {
  return Gr(In.getInstance().active());
}
function Hr(e, t) {
  return e.setValue(Br, t);
}
function _h(e) {
  return e.deleteValue(Br);
}
function hh(e, t) {
  return Hr(e, new Ge(t));
}
function Di(e) {
  var t;
  return (t = Gr(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
var Eh = /^([0-9a-f]{32})$/i, dh = /^[0-9a-f]{16}$/i;
function Ui(e) {
  return Eh.test(e) && e !== Pi;
}
function Th(e) {
  return dh.test(e) && e !== Mi;
}
function Dn(e) {
  return Ui(e.traceId) && Th(e.spanId);
}
function Sh(e) {
  return new Ge(e);
}
var Kn = In.getInstance(), ki = function() {
  function e() {
  }
  return e.prototype.startSpan = function(t, n, r) {
    if (r === void 0 && (r = Kn.active()), !!n?.root) return new Ge();
    var o, i = r && Di(r);
    return typeof (o = i) == "object" && typeof o.spanId == "string" && typeof o.traceId == "string" && typeof o.traceFlags == "number" && Dn(i) ? new Ge(i) : new Ge();
  }, e.prototype.startActiveSpan = function(t, n, r, o) {
    var i, a, u;
    if (!(arguments.length < 2)) {
      arguments.length === 2 ? u = n : arguments.length === 3 ? (i = n, u = r) : (i = n, a = r, u = o);
      var c = a ?? Kn.active(), l = this.startSpan(t, i, c), s = Hr(c, l);
      return Kn.with(s, u, void 0, l);
    }
  }, e;
}(), gn, Ze, br, yh = new ki(), vh = function() {
  function e(t, n, r, o) {
    this._provider = t, this.name = n, this.version = r, this.options = o;
  }
  return e.prototype.startSpan = function(t, n, r) {
    return this._getTracer().startSpan(t, n, r);
  }, e.prototype.startActiveSpan = function(t, n, r, o) {
    var i = this._getTracer();
    return Reflect.apply(i.startActiveSpan, i, arguments);
  }, e.prototype._getTracer = function() {
    if (this._delegate) return this._delegate;
    var t = this._provider.getDelegateTracer(this.name, this.version, this.options);
    return t ? (this._delegate = t, this._delegate) : yh;
  }, e;
}(), mh = new (function() {
  function e() {
  }
  return e.prototype.getTracer = function(t, n, r) {
    return new ki();
  }, e;
}())(), yo = function() {
  function e() {
  }
  return e.prototype.getTracer = function(t, n, r) {
    var o;
    return (o = this.getDelegateTracer(t, n, r)) !== null && o !== void 0 ? o : new vh(this, t, n, r);
  }, e.prototype.getDelegate = function() {
    var t;
    return (t = this._delegate) !== null && t !== void 0 ? t : mh;
  }, e.prototype.setDelegate = function(t) {
    this._delegate = t;
  }, e.prototype.getDelegateTracer = function(t, n, r) {
    var o;
    return (o = this._delegate) === null || o === void 0 ? void 0 : o.getTracer(t, n, r);
  }, e;
}();
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(gn || (gn = {})), function(e) {
  e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
}(Ze || (Ze = {})), function(e) {
  e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
}(br || (br = {}));
var qn = "[_0-9a-z-*/]", gh = new RegExp("^(?:" + ("[a-z]" + qn + "{0,255}") + "|" + ("[a-z0-9]" + qn + "{0,240}@[a-z]" + qn + "{0,13}") + ")$"), Ah = /^[ -~]{0,255}[!-~]$/, Oh = /,|=/, Rh = function() {
  function e(t) {
    this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
  }
  return e.prototype.set = function(t, n) {
    var r = this._clone();
    return r._internalState.has(t) && r._internalState.delete(t), r._internalState.set(t, n), r;
  }, e.prototype.unset = function(t) {
    var n = this._clone();
    return n._internalState.delete(t), n;
  }, e.prototype.get = function(t) {
    return this._internalState.get(t);
  }, e.prototype.serialize = function() {
    var t = this;
    return this._keys().reduce(function(n, r) {
      return n.push(r + "=" + t.get(r)), n;
    }, []).join(",");
  }, e.prototype._parse = function(t) {
    t.length > 512 || (this._internalState = t.split(",").reverse().reduce(function(n, r) {
      var o = r.trim(), i = o.indexOf("=");
      if (i !== -1) {
        var a = o.slice(0, i), u = o.slice(i + 1, r.length);
        (function(c) {
          return gh.test(c);
        })(a) && function(c) {
          return Ah.test(c) && !Oh.test(c);
        }(u) && n.set(a, u);
      }
      return n;
    }, /* @__PURE__ */ new Map()), this._internalState.size > 32 && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, 32))));
  }, e.prototype._keys = function() {
    return Array.from(this._internalState.keys()).reverse();
  }, e.prototype._clone = function() {
    var t = new e();
    return t._internalState = new Map(this._internalState), t;
  }, e;
}();
function PS(e) {
  return new Rh(e);
}
var $ = In.getInstance(), w = Wt.instance(), bh = new (function() {
  function e() {
  }
  return e.prototype.getMeter = function(t, n, r) {
    return wi;
  }, e;
}())(), Qn = "metrics", xi = function() {
  function e() {
  }
  return e.getInstance = function() {
    return this._instance || (this._instance = new e()), this._instance;
  }, e.prototype.setGlobalMeterProvider = function(t) {
    return Ke(Qn, t, Wt.instance());
  }, e.prototype.getMeterProvider = function() {
    return _e(Qn) || bh;
  }, e.prototype.getMeter = function(t, n, r) {
    return this.getMeterProvider().getMeter(t, n, r);
  }, e.prototype.disable = function() {
    qe(Qn, Wt.instance());
  }, e;
}().getInstance(), Nh = function() {
  function e() {
  }
  return e.prototype.inject = function(t, n) {
  }, e.prototype.extract = function(t, n) {
    return t;
  }, e.prototype.fields = function() {
    return [];
  }, e;
}(), jr = xr("OpenTelemetry Baggage Key");
function Vi(e) {
  return e.getValue(jr) || void 0;
}
function Lh() {
  return Vi(In.getInstance().active());
}
function Ch(e, t) {
  return e.setValue(jr, t);
}
function wh(e) {
  return e.deleteValue(jr);
}
var Jn = "propagation", Mh = new Nh(), Ph = function() {
  function e() {
    this.createBaggage = B_, this.getBaggage = Vi, this.getActiveBaggage = Lh, this.setBaggage = Ch, this.deleteBaggage = wh;
  }
  return e.getInstance = function() {
    return this._instance || (this._instance = new e()), this._instance;
  }, e.prototype.setGlobalPropagator = function(t) {
    return Ke(Jn, t, Wt.instance());
  }, e.prototype.inject = function(t, n, r) {
    return r === void 0 && (r = ih), this._getGlobalPropagator().inject(t, n, r);
  }, e.prototype.extract = function(t, n, r) {
    return r === void 0 && (r = oh), this._getGlobalPropagator().extract(t, n, r);
  }, e.prototype.fields = function() {
    return this._getGlobalPropagator().fields();
  }, e.prototype.disable = function() {
    qe(Jn, Wt.instance());
  }, e.prototype._getGlobalPropagator = function() {
    return _e(Jn) || Mh;
  }, e;
}(), Pt = Ph.getInstance(), $n = "trace", dt = function() {
  function e() {
    this._proxyTracerProvider = new yo(), this.wrapSpanContext = Sh, this.isSpanContextValid = Dn, this.deleteSpan = _h, this.getSpan = Gr, this.getActiveSpan = fh, this.getSpanContext = Di, this.setSpan = Hr, this.setSpanContext = hh;
  }
  return e.getInstance = function() {
    return this._instance || (this._instance = new e()), this._instance;
  }, e.prototype.setGlobalTracerProvider = function(t) {
    var n = Ke($n, this._proxyTracerProvider, Wt.instance());
    return n && this._proxyTracerProvider.setDelegate(t), n;
  }, e.prototype.getTracerProvider = function() {
    return _e($n) || this._proxyTracerProvider;
  }, e.prototype.getTracer = function(t, n) {
    return this.getTracerProvider().getTracer(t, n);
  }, e.prototype.disable = function() {
    qe($n, Wt.instance()), this._proxyTracerProvider = new yo();
  }, e;
}().getInstance(), Bi = xr("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function Gi(e) {
  return e.setValue(Bi, !0);
}
function Fr(e) {
  return e.getValue(Bi) === !0;
}
var tr = "baggage", Ih = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, Dh = function() {
  function e() {
  }
  return e.prototype.inject = function(t, n, r) {
    var o = Pt.getBaggage(t);
    if (o && !Fr(t)) {
      var i = function(u) {
        return u.getAllEntries().map(function(c) {
          var l = Ih(c, 2), s = l[0], p = l[1], v = encodeURIComponent(s) + "=" + encodeURIComponent(p.value);
          return p.metadata !== void 0 && (v += ";" + p.metadata.toString()), v;
        });
      }(o).filter(function(u) {
        return u.length <= 4096;
      }).slice(0, 180), a = function(u) {
        return u.reduce(function(c, l) {
          var s = c + (c !== "" ? "," : "") + l;
          return s.length > 8192 ? c : s;
        }, "");
      }(i);
      a.length > 0 && r.set(n, tr, a);
    }
  }, e.prototype.extract = function(t, n, r) {
    var o = r.get(n, tr), i = Array.isArray(o) ? o.join(",") : o;
    if (!i) return t;
    var a = {};
    return i.length === 0 ? t : (i.split(",").forEach(function(u) {
      var c = function(s) {
        var p = s.split(";");
        if (!(p.length <= 0)) {
          var v = p.shift();
          if (v) {
            var g = v.indexOf("=");
            if (!(g <= 0)) {
              var b, H = decodeURIComponent(v.substring(0, g).trim()), P = decodeURIComponent(v.substring(g + 1).trim());
              return p.length > 0 && (b = G_(p.join(";"))), { key: H, value: P, metadata: b };
            }
          }
        }
      }(u);
      if (c) {
        var l = { value: c.value };
        c.metadata && (l.metadata = c.metadata), a[c.key] = l;
      }
    }), Object.entries(a).length === 0 ? t : Pt.setBaggage(t, Pt.createBaggage(a)));
  }, e.prototype.fields = function() {
    return [tr];
  }, e;
}(), Hi = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Uh = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
};
function dn(e) {
  var t, n, r = {};
  if (typeof e != "object" || e == null) return r;
  try {
    for (var o = Hi(Object.entries(e)), i = o.next(); !i.done; i = o.next()) {
      var a = Uh(i.value, 2), u = a[0], c = a[1];
      kh(u) ? ji(c) ? Array.isArray(c) ? r[u] = c.slice() : r[u] = c : w.warn("Invalid attribute value set for key: " + u) : w.warn("Invalid attribute key: " + u);
    }
  } catch (l) {
    t = { error: l };
  } finally {
    try {
      i && !i.done && (n = o.return) && n.call(o);
    } finally {
      if (t) throw t.error;
    }
  }
  return r;
}
function kh(e) {
  return typeof e == "string" && e.length > 0;
}
function ji(e) {
  return e == null || (Array.isArray(e) ? function(t) {
    var n, r, o;
    try {
      for (var i = Hi(t), a = i.next(); !a.done; a = i.next()) {
        var u = a.value;
        if (u != null) {
          if (!o) {
            if (vo(u)) {
              o = typeof u;
              continue;
            }
            return !1;
          }
          if (typeof u !== o) return !1;
        }
      }
    } catch (c) {
      n = { error: c };
    } finally {
      try {
        a && !a.done && (r = i.return) && r.call(i);
      } finally {
        if (n) throw n.error;
      }
    }
    return !0;
  }(e) : vo(e));
}
function vo(e) {
  switch (typeof e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
var zt, xh = function(e) {
  w.error(function(t) {
    return typeof t == "string" ? t : JSON.stringify(function(n) {
      for (var r = {}, o = n; o !== null; ) Object.getOwnPropertyNames(o).forEach(function(i) {
        if (!r[i]) {
          var a = o[i];
          a && (r[i] = String(a));
        }
      }), o = Object.getPrototypeOf(o);
      return r;
    }(t));
  }(e));
};
function Gt(e) {
  try {
    xh(e);
  } catch {
  }
}
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(zt || (zt = {}));
var Vh = ["OTEL_SDK_DISABLED"];
function Bh(e) {
  return Vh.indexOf(e) > -1;
}
var Gh = ["OTEL_BSP_EXPORT_TIMEOUT", "OTEL_BSP_MAX_EXPORT_BATCH_SIZE", "OTEL_BSP_MAX_QUEUE_SIZE", "OTEL_BSP_SCHEDULE_DELAY", "OTEL_BLRP_EXPORT_TIMEOUT", "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE", "OTEL_BLRP_MAX_QUEUE_SIZE", "OTEL_BLRP_SCHEDULE_DELAY", "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT", "OTEL_ATTRIBUTE_COUNT_LIMIT", "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT", "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT", "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT", "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT", "OTEL_SPAN_EVENT_COUNT_LIMIT", "OTEL_SPAN_LINK_COUNT_LIMIT", "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT", "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT", "OTEL_EXPORTER_OTLP_TIMEOUT", "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT", "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT", "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT", "OTEL_EXPORTER_JAEGER_AGENT_PORT"];
function Hh(e) {
  return Gh.indexOf(e) > -1;
}
var jh = ["OTEL_NO_PATCH_MODULES", "OTEL_PROPAGATORS", "OTEL_SEMCONV_STABILITY_OPT_IN"];
function Fh(e) {
  return jh.indexOf(e) > -1;
}
var Tn = 1 / 0, Sn = 128, Fi = { OTEL_SDK_DISABLED: !1, CONTAINER_NAME: "", ECS_CONTAINER_METADATA_URI_V4: "", ECS_CONTAINER_METADATA_URI: "", HOSTNAME: "", KUBERNETES_SERVICE_HOST: "", NAMESPACE: "", OTEL_BSP_EXPORT_TIMEOUT: 3e4, OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512, OTEL_BSP_MAX_QUEUE_SIZE: 2048, OTEL_BSP_SCHEDULE_DELAY: 5e3, OTEL_BLRP_EXPORT_TIMEOUT: 3e4, OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512, OTEL_BLRP_MAX_QUEUE_SIZE: 2048, OTEL_BLRP_SCHEDULE_DELAY: 5e3, OTEL_EXPORTER_JAEGER_AGENT_HOST: "", OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832, OTEL_EXPORTER_JAEGER_ENDPOINT: "", OTEL_EXPORTER_JAEGER_PASSWORD: "", OTEL_EXPORTER_JAEGER_USER: "", OTEL_EXPORTER_OTLP_ENDPOINT: "", OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "", OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "", OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "", OTEL_EXPORTER_OTLP_HEADERS: "", OTEL_EXPORTER_OTLP_TRACES_HEADERS: "", OTEL_EXPORTER_OTLP_METRICS_HEADERS: "", OTEL_EXPORTER_OTLP_LOGS_HEADERS: "", OTEL_EXPORTER_OTLP_TIMEOUT: 1e4, OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4, OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4, OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4, OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans", OTEL_LOG_LEVEL: yt.INFO, OTEL_NO_PATCH_MODULES: [], OTEL_PROPAGATORS: ["tracecontext", "baggage"], OTEL_RESOURCE_ATTRIBUTES: "", OTEL_SERVICE_NAME: "", OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: Tn, OTEL_ATTRIBUTE_COUNT_LIMIT: Sn, OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: Tn, OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Sn, OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: Tn, OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Sn, OTEL_SPAN_EVENT_COUNT_LIMIT: 128, OTEL_SPAN_LINK_COUNT_LIMIT: 128, OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: 128, OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: 128, OTEL_TRACES_EXPORTER: "", OTEL_TRACES_SAMPLER: zt.ParentBasedAlwaysOn, OTEL_TRACES_SAMPLER_ARG: "", OTEL_LOGS_EXPORTER: "", OTEL_EXPORTER_OTLP_INSECURE: "", OTEL_EXPORTER_OTLP_TRACES_INSECURE: "", OTEL_EXPORTER_OTLP_METRICS_INSECURE: "", OTEL_EXPORTER_OTLP_LOGS_INSECURE: "", OTEL_EXPORTER_OTLP_CERTIFICATE: "", OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "", OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "", OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "", OTEL_EXPORTER_OTLP_COMPRESSION: "", OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "", OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "", OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "", OTEL_EXPORTER_OTLP_CLIENT_KEY: "", OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "", OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "", OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "", OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "", OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "", OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "", OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "", OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf", OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf", OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf", OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf", OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative", OTEL_SEMCONV_STABILITY_OPT_IN: [] };
function Yh(e, t, n) {
  if (n[e] !== void 0) {
    var r = String(n[e]);
    t[e] = r.toLowerCase() === "true";
  }
}
function zh(e, t, n, r, o) {
  if (r === void 0 && (r = -1 / 0), o === void 0 && (o = 1 / 0), n[e] !== void 0) {
    var i = Number(n[e]);
    isNaN(i) || (t[e] = i < r ? r : i > o ? o : i);
  }
}
function Zh(e, t, n, r) {
  r === void 0 && (r = ",");
  var o = n[e];
  typeof o == "string" && (t[e] = o.split(r).map(function(i) {
    return i.trim();
  }));
}
var Xh = { ALL: yt.ALL, VERBOSE: yt.VERBOSE, DEBUG: yt.DEBUG, INFO: yt.INFO, WARN: yt.WARN, ERROR: yt.ERROR, NONE: yt.NONE };
function Wh(e, t, n) {
  var r = n[e];
  if (typeof r == "string") {
    var o = Xh[r.toUpperCase()];
    o != null && (t[e] = o);
  }
}
function Yi(e) {
  var t = {};
  for (var n in Fi) {
    var r = n;
    if (r === "OTEL_LOG_LEVEL") Wh(r, t, e);
    else if (Bh(r)) Yh(r, t, e);
    else if (Hh(r)) zh(r, t, e);
    else if (Fh(r)) Zh(r, t, e);
    else {
      var o = e[r];
      o != null && (t[r] = String(o));
    }
  }
  return t;
}
var He = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function he() {
  var e = Yi(He);
  return Object.assign({}, Fi, e);
}
function mo(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function Yr(e) {
  for (var t = new Uint8Array(e.length / 2), n = 0, r = 0; r < e.length; r += 2) {
    var o = mo(e.charCodeAt(r)), i = mo(e.charCodeAt(r + 1));
    t[n++] = o << 4 | i;
  }
  return t;
}
var De, It = performance, er = ((De = {})["telemetry.sdk.name"] = "opentelemetry", De["process.runtime.name"] = "browser", De["telemetry.sdk.language"] = "webjs", De["telemetry.sdk.version"] = "1.30.1", De), Mt, Kh = Math.pow(10, 6), An = Math.pow(10, 9);
function Dt(e) {
  var t = e / 1e3;
  return [Math.trunc(t), Math.round(e % 1e3 * Kh)];
}
function zr() {
  var e = It.timeOrigin;
  if (typeof e != "number") {
    var t = It;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Ee(e) {
  return zi(Dt(zr()), Dt(typeof e == "number" ? e : It.now()));
}
function Ue(e) {
  if (Zr(e)) return e;
  if (typeof e == "number") return e < zr() ? Ee(e) : Dt(e);
  if (e instanceof Date) return Dt(e.getTime());
  throw TypeError("Invalid input type");
}
function Jt(e) {
  return e[0] * An + e[1];
}
function on(e) {
  return 1e6 * e[0] + e[1] / 1e3;
}
function Zr(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function go(e) {
  return Zr(e) || typeof e == "number" || e instanceof Date;
}
function zi(e, t) {
  var n = [e[0] + t[0], e[1] + t[1]];
  return n[1] >= An && (n[1] -= An, n[0] += 1), n;
}
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(Mt || (Mt = {}));
var qh = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Qh = function() {
  function e(t) {
    var n;
    t === void 0 && (t = {}), this._propagators = (n = t.propagators) !== null && n !== void 0 ? n : [], this._fields = Array.from(new Set(this._propagators.map(function(r) {
      return typeof r.fields == "function" ? r.fields() : [];
    }).reduce(function(r, o) {
      return r.concat(o);
    }, [])));
  }
  return e.prototype.inject = function(t, n, r) {
    var o, i;
    try {
      for (var a = qh(this._propagators), u = a.next(); !u.done; u = a.next()) {
        var c = u.value;
        try {
          c.inject(t, n, r);
        } catch (l) {
          w.warn("Failed to inject with " + c.constructor.name + ". Err: " + l.message);
        }
      }
    } catch (l) {
      o = { error: l };
    } finally {
      try {
        u && !u.done && (i = a.return) && i.call(a);
      } finally {
        if (o) throw o.error;
      }
    }
  }, e.prototype.extract = function(t, n, r) {
    return this._propagators.reduce(function(o, i) {
      try {
        return i.extract(o, n, r);
      } catch (a) {
        w.warn("Failed to extract with " + i.constructor.name + ". Err: " + a.message);
      }
      return o;
    }, t);
  }, e.prototype.fields = function() {
    return this._fields.slice();
  }, e;
}(), nr = "[_0-9a-z-*/]", Jh = new RegExp("^(?:" + ("[a-z]" + nr + "{0,255}") + "|" + ("[a-z0-9]" + nr + "{0,240}@[a-z]" + nr + "{0,13}") + ")$"), $h = /^[ -~]{0,255}[!-~]$/, tE = /,|=/, eE = function() {
  function e(t) {
    this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
  }
  return e.prototype.set = function(t, n) {
    var r = this._clone();
    return r._internalState.has(t) && r._internalState.delete(t), r._internalState.set(t, n), r;
  }, e.prototype.unset = function(t) {
    var n = this._clone();
    return n._internalState.delete(t), n;
  }, e.prototype.get = function(t) {
    return this._internalState.get(t);
  }, e.prototype.serialize = function() {
    var t = this;
    return this._keys().reduce(function(n, r) {
      return n.push(r + "=" + t.get(r)), n;
    }, []).join(",");
  }, e.prototype._parse = function(t) {
    t.length > 512 || (this._internalState = t.split(",").reverse().reduce(function(n, r) {
      var o = r.trim(), i = o.indexOf("=");
      if (i !== -1) {
        var a = o.slice(0, i), u = o.slice(i + 1, r.length);
        (function(c) {
          return Jh.test(c);
        })(a) && function(c) {
          return $h.test(c) && !tE.test(c);
        }(u) && n.set(a, u);
      }
      return n;
    }, /* @__PURE__ */ new Map()), this._internalState.size > 32 && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, 32))));
  }, e.prototype._keys = function() {
    return Array.from(this._internalState.keys()).reverse();
  }, e.prototype._clone = function() {
    var t = new e();
    return t._internalState = new Map(this._internalState), t;
  }, e;
}(), yn = "traceparent", rr = "tracestate", nE = new RegExp("^\\s?((?!ff)[\\da-f]{2})-((?![0]{32})[\\da-f]{32})-((?![0]{16})[\\da-f]{16})-([\\da-f]{2})(-.*)?\\s?$"), Ao, Oo, rE = function() {
  function e() {
  }
  return e.prototype.inject = function(t, n, r) {
    var o = dt.getSpanContext(t);
    if (o && !Fr(t) && Dn(o)) {
      var i = "00-" + o.traceId + "-" + o.spanId + "-0" + Number(o.traceFlags || Kt.NONE).toString(16);
      r.set(n, yn, i), o.traceState && r.set(n, rr, o.traceState.serialize());
    }
  }, e.prototype.extract = function(t, n, r) {
    var o = r.get(n, yn);
    if (!o) return t;
    var i = Array.isArray(o) ? o[0] : o;
    if (typeof i != "string") return t;
    var a = function(l) {
      var s = nE.exec(l);
      return s ? s[1] === "00" && s[5] ? null : { traceId: s[2], spanId: s[3], traceFlags: parseInt(s[4], 16) } : null;
    }(i);
    if (!a) return t;
    a.isRemote = !0;
    var u = r.get(n, rr);
    if (u) {
      var c = Array.isArray(u) ? u.join(",") : u;
      a.traceState = new eE(typeof c == "string" ? c : void 0);
    }
    return dt.setSpanContext(t, a);
  }, e.prototype.fields = function() {
    return [yn, rr];
  }, e;
}(), oE = "[object Null]", iE = "[object Undefined]", Zi = Function.prototype.toString, aE = Zi.call(Object), sE = (Ao = Object.getPrototypeOf, Oo = Object, function(e) {
  return Ao(Oo(e));
}), Xi = Object.prototype, Ro = Xi.hasOwnProperty, se = Symbol ? Symbol.toStringTag : void 0, bo = Xi.toString;
function No(e) {
  if (!function(r) {
    return r != null && typeof r == "object";
  }(e) || function(r) {
    return r == null ? r === void 0 ? iE : oE : se && se in Object(r) ? function(o) {
      var i = Ro.call(o, se), a = o[se], u = !1;
      try {
        o[se] = void 0, u = !0;
      } catch {
      }
      var c = bo.call(o);
      return u && (i ? o[se] = a : delete o[se]), c;
    }(r) : function(o) {
      return bo.call(o);
    }(r);
  }(e) !== "[object Object]") return !1;
  var t = sE(e);
  if (t === null) return !0;
  var n = Ro.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && Zi.call(n) === aE;
}
function or(e) {
  return On(e) ? e.slice() : e;
}
function Wi(e, t, n, r) {
  var o;
  if (n === void 0 && (n = 0), !(n > 20)) {
    if (n++, vn(e) || vn(t) || Ki(t)) o = or(t);
    else if (On(e)) {
      if (o = e.slice(), On(t)) for (var i = 0, a = t.length; i < a; i++) o.push(or(t[i]));
      else if (ke(t)) for (i = 0, a = (u = Object.keys(t)).length; i < a; i++)
        o[c = u[i]] = or(t[c]);
    } else if (ke(e)) if (ke(t)) {
      if (!function(b, H) {
        return !(!No(b) || !No(H));
      }(e, t)) return t;
      o = Object.assign({}, e);
      var u;
      for (i = 0, a = (u = Object.keys(t)).length; i < a; i++) {
        var c, l = t[c = u[i]];
        if (vn(l)) l === void 0 ? delete o[c] : o[c] = l;
        else {
          var s = o[c], p = l;
          if (Lo(e, c, r) || Lo(t, c, r)) delete o[c];
          else {
            if (ke(s) && ke(p)) {
              var v = r.get(s) || [], g = r.get(p) || [];
              v.push({ obj: e, key: c }), g.push({ obj: t, key: c }), r.set(s, v), r.set(p, g);
            }
            o[c] = Wi(o[c], l, n, r);
          }
        }
      }
    } else o = t;
    return o;
  }
}
function Lo(e, t, n) {
  for (var r = n.get(e[t]) || [], o = 0, i = r.length; o < i; o++) {
    var a = r[o];
    if (a.key === t && a.obj === e) return !0;
  }
  return !1;
}
function On(e) {
  return Array.isArray(e);
}
function Ki(e) {
  return typeof e == "function";
}
function ke(e) {
  return !vn(e) && !On(e) && !Ki(e) && typeof e == "object";
}
function vn(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || e === void 0 || e instanceof Date || e instanceof RegExp || e === null;
}
var uE = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function qi(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function Qi(e, t) {
  var n, r;
  if (!t) return !1;
  try {
    for (var o = uE(t), i = o.next(); !i.done; i = o.next())
      if (qi(e, i.value)) return !0;
  } catch (a) {
    n = { error: a };
  } finally {
    try {
      i && !i.done && (r = o.return) && r.call(o);
    } finally {
      if (n) throw n.error;
    }
  }
  return !1;
}
var cE = function() {
  function e() {
    var t = this;
    this._promise = new Promise(function(n, r) {
      t._resolve = n, t._reject = r;
    });
  }
  return Object.defineProperty(e.prototype, "promise", { get: function() {
    return this._promise;
  }, enumerable: !1, configurable: !0 }), e.prototype.resolve = function(t) {
    this._resolve(t);
  }, e.prototype.reject = function(t) {
    this._reject(t);
  }, e;
}(), lE = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, pE = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}, Ji = function() {
  function e(t, n) {
    this._callback = t, this._that = n, this._isCalled = !1, this._deferred = new cE();
  }
  return Object.defineProperty(e.prototype, "isCalled", { get: function() {
    return this._isCalled;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "promise", { get: function() {
    return this._deferred.promise;
  }, enumerable: !1, configurable: !0 }), e.prototype.call = function() {
    for (var t, n = this, r = [], o = 0; o < arguments.length; o++) r[o] = arguments[o];
    if (!this._isCalled) {
      this._isCalled = !0;
      try {
        Promise.resolve((t = this._callback).call.apply(t, pE([this._that], lE(r), !1))).then(function(i) {
          return n._deferred.resolve(i);
        }, function(i) {
          return n._deferred.reject(i);
        });
      } catch (i) {
        this._deferred.reject(i);
      }
    }
    return this._deferred.promise;
  }, e;
}(), Le, $i = { _export: function(e, t) {
  return new Promise(function(n) {
    $.with(Gi($.active()), function() {
      e.export(t, function(r) {
        n(r);
      });
    });
  });
} }, ir = "exception.type", ar = "exception.message", Nr = function() {
  return Nr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    return e;
  }, Nr.apply(this, arguments);
}, fE = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Co = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, _E = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}, hE = function() {
  function e(t, n, r, o, i, a, u, c, l, s) {
    u === void 0 && (u = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = { code: br.UNSET }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = r, this._spanContext = o, this.parentSpanId = a, this.kind = i, this.links = u;
    var p = Date.now();
    this._performanceStartTime = It.now(), this._performanceOffset = p - (this._performanceStartTime + zr()), this._startTimeProvided = c != null, this.startTime = this._getTime(c ?? p), this.resource = t.resource, this.instrumentationLibrary = t.instrumentationLibrary, this._spanLimits = t.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, s != null && this.setAttributes(s), this._spanProcessor = t.getActiveSpanProcessor(), this._spanProcessor.onStart(this, n);
  }
  return e.prototype.spanContext = function() {
    return this._spanContext;
  }, e.prototype.setAttribute = function(t, n) {
    return n == null || this._isSpanEnded() ? this : t.length === 0 ? (w.warn("Invalid attribute key: " + t), this) : ji(n) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, t) ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(n), this) : (w.warn("Invalid attribute value set for key: " + t), this);
  }, e.prototype.setAttributes = function(t) {
    var n, r;
    try {
      for (var o = fE(Object.entries(t)), i = o.next(); !i.done; i = o.next()) {
        var a = Co(i.value, 2), u = a[0], c = a[1];
        this.setAttribute(u, c);
      }
    } catch (l) {
      n = { error: l };
    } finally {
      try {
        i && !i.done && (r = o.return) && r.call(o);
      } finally {
        if (n) throw n.error;
      }
    }
    return this;
  }, e.prototype.addEvent = function(t, n, r) {
    if (this._isSpanEnded()) return this;
    if (this._spanLimits.eventCountLimit === 0) return w.warn("No events allowed."), this._droppedEventsCount++, this;
    this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && w.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), go(n) && (go(r) || (r = n), n = void 0);
    var o = dn(n);
    return this.events.push({ name: t, attributes: o, time: this._getTime(r), droppedAttributesCount: 0 }), this;
  }, e.prototype.addLink = function(t) {
    return this.links.push(t), this;
  }, e.prototype.addLinks = function(t) {
    var n;
    return (n = this.links).push.apply(n, _E([], Co(t), !1)), this;
  }, e.prototype.setStatus = function(t) {
    return this._isSpanEnded() || (this.status = Nr({}, t), this.status.message != null && typeof t.message != "string" && (w.warn("Dropping invalid status.message of type '" + typeof t.message + "', expected 'string'"), delete this.status.message)), this;
  }, e.prototype.updateName = function(t) {
    return this._isSpanEnded() || (this.name = t), this;
  }, e.prototype.end = function(t) {
    this._isSpanEnded() ? w.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.") : (this._ended = !0, this.endTime = this._getTime(t), this._duration = function(n, r) {
      var o = r[0] - n[0], i = r[1] - n[1];
      return i < 0 && (o -= 1, i += An), [o, i];
    }(this.startTime, this.endTime), this._duration[0] < 0 && (w.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && w.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this));
  }, e.prototype._getTime = function(t) {
    if (typeof t == "number" && t <= It.now()) return Ee(t + this._performanceOffset);
    if (typeof t == "number") return Dt(t);
    if (t instanceof Date) return Dt(t.getTime());
    if (Zr(t)) return t;
    if (this._startTimeProvided) return Dt(Date.now());
    var n = It.now() - this._performanceStartTime;
    return zi(this.startTime, Dt(n));
  }, e.prototype.isRecording = function() {
    return this._ended === !1;
  }, e.prototype.recordException = function(t, n) {
    var r = {};
    typeof t == "string" ? r[ar] = t : t && (t.code ? r[ir] = t.code.toString() : t.name && (r[ir] = t.name), t.message && (r[ar] = t.message), t.stack && (r["exception.stacktrace"] = t.stack)), r[ir] || r[ar] ? this.addEvent("exception", r, n) : w.warn("Failed to record an exception " + t);
  }, Object.defineProperty(e.prototype, "duration", { get: function() {
    return this._duration;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "ended", { get: function() {
    return this._ended;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "droppedAttributesCount", { get: function() {
    return this._droppedAttributesCount;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "droppedEventsCount", { get: function() {
    return this._droppedEventsCount;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "droppedLinksCount", { get: function() {
    return this._droppedLinksCount;
  }, enumerable: !1, configurable: !0 }), e.prototype._isSpanEnded = function() {
    return this._ended && w.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
  }, e.prototype._truncateToLimitUtil = function(t, n) {
    return t.length <= n ? t : t.substring(0, n);
  }, e.prototype._truncateToSize = function(t) {
    var n = this, r = this._attributeValueLengthLimit;
    return r <= 0 ? (w.warn("Attribute value limit must be positive, got " + r), t) : typeof t == "string" ? this._truncateToLimitUtil(t, r) : Array.isArray(t) ? t.map(function(o) {
      return typeof o == "string" ? n._truncateToLimitUtil(o, r) : o;
    }) : t;
  }, e;
}();
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Le || (Le = {}));
var Rn = function() {
  function e() {
  }
  return e.prototype.shouldSample = function() {
    return { decision: Le.NOT_RECORD };
  }, e.prototype.toString = function() {
    return "AlwaysOffSampler";
  }, e;
}(), Ne = function() {
  function e() {
  }
  return e.prototype.shouldSample = function() {
    return { decision: Le.RECORD_AND_SAMPLED };
  }, e.prototype.toString = function() {
    return "AlwaysOnSampler";
  }, e;
}(), sr = function() {
  function e(t) {
    var n, r, o, i;
    this._root = t.root, this._root || (Gt(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new Ne()), this._remoteParentSampled = (n = t.remoteParentSampled) !== null && n !== void 0 ? n : new Ne(), this._remoteParentNotSampled = (r = t.remoteParentNotSampled) !== null && r !== void 0 ? r : new Rn(), this._localParentSampled = (o = t.localParentSampled) !== null && o !== void 0 ? o : new Ne(), this._localParentNotSampled = (i = t.localParentNotSampled) !== null && i !== void 0 ? i : new Rn();
  }
  return e.prototype.shouldSample = function(t, n, r, o, i, a) {
    var u = dt.getSpanContext(t);
    return u && Dn(u) ? u.isRemote ? u.traceFlags & Kt.SAMPLED ? this._remoteParentSampled.shouldSample(t, n, r, o, i, a) : this._remoteParentNotSampled.shouldSample(t, n, r, o, i, a) : u.traceFlags & Kt.SAMPLED ? this._localParentSampled.shouldSample(t, n, r, o, i, a) : this._localParentNotSampled.shouldSample(t, n, r, o, i, a) : this._root.shouldSample(t, n, r, o, i, a);
  }, e.prototype.toString = function() {
    return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
  }, e;
}(), wo = function() {
  function e(t) {
    t === void 0 && (t = 0), this._ratio = t, this._ratio = this._normalize(t), this._upperBound = Math.floor(4294967295 * this._ratio);
  }
  return e.prototype.shouldSample = function(t, n) {
    return { decision: Ui(n) && this._accumulate(n) < this._upperBound ? Le.RECORD_AND_SAMPLED : Le.NOT_RECORD };
  }, e.prototype.toString = function() {
    return "TraceIdRatioBased{" + this._ratio + "}";
  }, e.prototype._normalize = function(t) {
    return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
  }, e.prototype._accumulate = function(t) {
    for (var n = 0, r = 0; r < t.length / 8; r++) {
      var o = 8 * r;
      n = (n ^ parseInt(t.slice(o, o + 8), 16)) >>> 0;
    }
    return n;
  }, e;
}(), EE = zt.AlwaysOn;
function ta() {
  var e = he();
  return { sampler: ea(e), forceFlushTimeoutMillis: 3e4, generalLimits: { attributeValueLengthLimit: e.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT, attributeCountLimit: e.OTEL_ATTRIBUTE_COUNT_LIMIT }, spanLimits: { attributeValueLengthLimit: e.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT, attributeCountLimit: e.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT, linkCountLimit: e.OTEL_SPAN_LINK_COUNT_LIMIT, eventCountLimit: e.OTEL_SPAN_EVENT_COUNT_LIMIT, attributePerEventCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT, attributePerLinkCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT }, mergeResourceWithDefaults: !0 };
}
function ea(e) {
  switch (e === void 0 && (e = he()), e.OTEL_TRACES_SAMPLER) {
    case zt.AlwaysOn:
      return new Ne();
    case zt.AlwaysOff:
      return new Rn();
    case zt.ParentBasedAlwaysOn:
      return new sr({ root: new Ne() });
    case zt.ParentBasedAlwaysOff:
      return new sr({ root: new Rn() });
    case zt.TraceIdRatio:
      return new wo(Mo(e));
    case zt.ParentBasedTraceIdRatio:
      return new sr({ root: new wo(Mo(e)) });
    default:
      return w.error('OTEL_TRACES_SAMPLER value "' + e.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + EE + '".'), new Ne();
  }
}
function Mo(e) {
  if (e.OTEL_TRACES_SAMPLER_ARG === void 0 || e.OTEL_TRACES_SAMPLER_ARG === "") return w.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to 1."), 1;
  var t = Number(e.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(t) ? (w.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to 1."), 1) : t < 0 || t > 1 ? (w.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to 1."), 1) : t;
}
function dE(e) {
  var t, n, r, o, i, a, u, c, l, s, p, v, g = Object.assign({}, e.spanLimits), b = Yi(He);
  return g.attributeCountLimit = (a = (i = (o = (n = (t = e.spanLimits) === null || t === void 0 ? void 0 : t.attributeCountLimit) !== null && n !== void 0 ? n : (r = e.generalLimits) === null || r === void 0 ? void 0 : r.attributeCountLimit) !== null && o !== void 0 ? o : b.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && i !== void 0 ? i : b.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : Sn, g.attributeValueLengthLimit = (v = (p = (s = (c = (u = e.spanLimits) === null || u === void 0 ? void 0 : u.attributeValueLengthLimit) !== null && c !== void 0 ? c : (l = e.generalLimits) === null || l === void 0 ? void 0 : l.attributeValueLengthLimit) !== null && s !== void 0 ? s : b.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && p !== void 0 ? p : b.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && v !== void 0 ? v : Tn, Object.assign({}, e, { spanLimits: g });
}
var TE = function() {
  function e(t, n) {
    this._exporter = t, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
    var r = he();
    this._maxExportBatchSize = typeof n?.maxExportBatchSize == "number" ? n.maxExportBatchSize : r.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof n?.maxQueueSize == "number" ? n.maxQueueSize : r.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof n?.scheduledDelayMillis == "number" ? n.scheduledDelayMillis : r.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof n?.exportTimeoutMillis == "number" ? n.exportTimeoutMillis : r.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new Ji(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (w.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
  }
  return e.prototype.forceFlush = function() {
    return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
  }, e.prototype.onStart = function(t, n) {
  }, e.prototype.onEnd = function(t) {
    this._shutdownOnce.isCalled || t.spanContext().traceFlags & Kt.SAMPLED && this._addToBuffer(t);
  }, e.prototype.shutdown = function() {
    return this._shutdownOnce.call();
  }, e.prototype._shutdown = function() {
    var t = this;
    return Promise.resolve().then(function() {
      return t.onShutdown();
    }).then(function() {
      return t._flushAll();
    }).then(function() {
      return t._exporter.shutdown();
    });
  }, e.prototype._addToBuffer = function(t) {
    if (this._finishedSpans.length >= this._maxQueueSize) return this._droppedSpansCount === 0 && w.debug("maxQueueSize reached, dropping spans"), void this._droppedSpansCount++;
    this._droppedSpansCount > 0 && (w.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
  }, e.prototype._flushAll = function() {
    var t = this;
    return new Promise(function(n, r) {
      for (var o = [], i = 0, a = Math.ceil(t._finishedSpans.length / t._maxExportBatchSize); i < a; i++) o.push(t._flushOneBatch());
      Promise.all(o).then(function() {
        n();
      }).catch(r);
    });
  }, e.prototype._flushOneBatch = function() {
    var t = this;
    return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(n, r) {
      var o = setTimeout(function() {
        r(new Error("Timeout"));
      }, t._exportTimeoutMillis);
      $.with(Gi($.active()), function() {
        var i;
        t._finishedSpans.length <= t._maxExportBatchSize ? (i = t._finishedSpans, t._finishedSpans = []) : i = t._finishedSpans.splice(0, t._maxExportBatchSize);
        for (var a = function() {
          return t._exporter.export(i, function(p) {
            var v;
            clearTimeout(o), p.code === Mt.SUCCESS ? n() : r((v = p.error) !== null && v !== void 0 ? v : new Error("BatchSpanProcessor: span export failed"));
          });
        }, u = null, c = 0, l = i.length; c < l; c++) {
          var s = i[c];
          s.resource.asyncAttributesPending && s.resource.waitForAsyncAttributes && (u != null || (u = []), u.push(s.resource.waitForAsyncAttributes()));
        }
        u === null ? a() : Promise.all(u).then(a, function(p) {
          Gt(p), r(p);
        });
      });
    });
  }, e.prototype._maybeStartTimer = function() {
    var t = this;
    if (!this._isExporting) {
      var n = function() {
        t._isExporting = !0, t._flushOneBatch().finally(function() {
          t._isExporting = !1, t._finishedSpans.length > 0 && (t._clearTimer(), t._maybeStartTimer());
        }).catch(function(r) {
          t._isExporting = !1, Gt(r);
        });
      };
      if (this._finishedSpans.length >= this._maxExportBatchSize) return n();
      this._timer === void 0 && (this._timer = setTimeout(function() {
        return n();
      }, this._scheduledDelayMillis), this._timer);
    }
  }, e.prototype._clearTimer = function() {
    this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
  }, e;
}(), SE = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), yE = function(e) {
  function t(n, r) {
    var o = e.call(this, n, r) || this;
    return o.onInit(r), o;
  }
  return SE(t, e), t.prototype.onInit = function(n) {
    var r = this;
    n?.disableAutoFlushOnDocumentHide !== !0 && typeof document < "u" && (this._visibilityChangeListener = function() {
      document.visibilityState === "hidden" && r.forceFlush().catch(function(o) {
        Gt(o);
      });
    }, this._pageHideListener = function() {
      r.forceFlush().catch(function(o) {
        Gt(o);
      });
    }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
  }, t.prototype.onShutdown = function() {
    typeof document < "u" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
  }, t;
}(TE), vE = function() {
  this.generateTraceId = Po(16), this.generateSpanId = Po(8);
}, an = Array(32);
function Po(e) {
  return function() {
    for (var t = 0; t < 2 * e; t++) an[t] = Math.floor(16 * Math.random()) + 48, an[t] >= 58 && (an[t] += 39);
    return String.fromCharCode.apply(null, an.slice(0, 2 * e));
  };
}
var mE = function() {
  function e(t, n, r) {
    this._tracerProvider = r;
    var o, i, a, u, c = (o = n, i = { sampler: ea() }, a = ta(), (u = Object.assign({}, a, i, o)).generalLimits = Object.assign({}, a.generalLimits, o.generalLimits || {}), u.spanLimits = Object.assign({}, a.spanLimits, o.spanLimits || {}), u);
    this._sampler = c.sampler, this._generalLimits = c.generalLimits, this._spanLimits = c.spanLimits, this._idGenerator = n.idGenerator || new vE(), this.resource = r.resource, this.instrumentationLibrary = t;
  }
  return e.prototype.startSpan = function(t, n, r) {
    var o, i, a;
    n === void 0 && (n = {}), r === void 0 && (r = $.active()), n.root && (r = dt.deleteSpan(r));
    var u = dt.getSpan(r);
    if (Fr(r)) return w.debug("Instrumentation suppressed, returning Noop Span"), dt.wrapSpanContext(Ii);
    var c, l, s, p = u?.spanContext(), v = this._idGenerator.generateSpanId();
    p && dt.isSpanContextValid(p) ? (c = p.traceId, l = p.traceState, s = p.spanId) : c = this._idGenerator.generateTraceId();
    var g = (o = n.kind) !== null && o !== void 0 ? o : Ze.INTERNAL, b = ((i = n.links) !== null && i !== void 0 ? i : []).map(function(ct) {
      return { context: ct.context, attributes: dn(ct.attributes) };
    }), H = dn(n.attributes), P = this._sampler.shouldSample(r, c, t, g, H, b);
    l = (a = P.traceState) !== null && a !== void 0 ? a : l;
    var N = { traceId: c, spanId: v, traceFlags: P.decision === gn.RECORD_AND_SAMPLED ? Kt.SAMPLED : Kt.NONE, traceState: l };
    if (P.decision === gn.NOT_RECORD) return w.debug("Recording is off, propagating context in a non-recording span"), dt.wrapSpanContext(N);
    var J = dn(Object.assign(H, P.attributes));
    return new hE(this, r, t, N, g, s, b, n.startTime, void 0, J);
  }, e.prototype.startActiveSpan = function(t, n, r, o) {
    var i, a, u;
    if (!(arguments.length < 2)) {
      arguments.length === 2 ? u = n : arguments.length === 3 ? (i = n, u = r) : (i = n, a = r, u = o);
      var c = a ?? $.active(), l = this.startSpan(t, i, c), s = dt.setSpan(c, l);
      return $.with(s, u, void 0, l);
    }
  }, e.prototype.getGeneralLimits = function() {
    return this._generalLimits;
  }, e.prototype.getSpanLimits = function() {
    return this._spanLimits;
  }, e.prototype.getActiveSpanProcessor = function() {
    return this._tracerProvider.getActiveSpanProcessor();
  }, e;
}(), Io = "process.runtime.version", na = "service.name", Do = "telemetry.sdk.name", Uo = "telemetry.sdk.language", ko = "telemetry.sdk.version";
function IS() {
  return "unknown_service";
}
var ue, re = function() {
  return re = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    return e;
  }, re.apply(this, arguments);
}, gE = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, AE = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, OE = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, Nt = function() {
  function e(t, n) {
    var r, o = this;
    this._attributes = t, this.asyncAttributesPending = n != null, this._syncAttributes = (r = this._attributes) !== null && r !== void 0 ? r : {}, this._asyncAttributesPromise = n?.then(function(i) {
      return o._attributes = Object.assign({}, o._attributes, i), o.asyncAttributesPending = !1, i;
    }, function(i) {
      return w.debug("a resource's async attributes promise rejected: %s", i), o.asyncAttributesPending = !1, {};
    });
  }
  return e.empty = function() {
    return e.EMPTY;
  }, e.default = function() {
    var t;
    return new e(((t = {})[na] = "unknown_service", t[Uo] = er[Uo], t[Do] = er[Do], t[ko] = er[ko], t));
  }, Object.defineProperty(e.prototype, "attributes", { get: function() {
    var t;
    return this.asyncAttributesPending && w.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
  }, enumerable: !1, configurable: !0 }), e.prototype.waitForAsyncAttributes = function() {
    return gE(this, void 0, void 0, function() {
      return AE(this, function(t) {
        switch (t.label) {
          case 0:
            return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
          case 1:
            t.sent(), t.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, e.prototype.merge = function(t) {
    var n, r = this;
    if (!t) return this;
    var o = re(re({}, this._syncAttributes), (n = t._syncAttributes) !== null && n !== void 0 ? n : t.attributes);
    if (!this._asyncAttributesPromise && !t._asyncAttributesPromise) return new e(o);
    var i = Promise.all([this._asyncAttributesPromise, t._asyncAttributesPromise]).then(function(a) {
      var u, c = OE(a, 2), l = c[0], s = c[1];
      return re(re(re(re({}, r._syncAttributes), l), (u = t._syncAttributes) !== null && u !== void 0 ? u : t.attributes), s);
    });
    return new e(o, i);
  }, e.EMPTY = new e({}), e;
}(), Un = new (function() {
  function e() {
  }
  return e.prototype.detect = function() {
    return new Nt({});
  }, e;
}())(), kn = new (function() {
  function e() {
  }
  return e.prototype.detect = function() {
    return Promise.resolve(Un.detect());
  }, e;
}())(), DS = kn, US = Un, kS = kn, xS = Un, VS = kn, BS = kn, GS = Un, Lr = function() {
  return Lr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    return e;
  }, Lr.apply(this, arguments);
}, RE = function() {
  function e() {
  }
  return e.prototype.detect = function(t) {
    var n, r, o, i;
    if (!(typeof navigator < "u" && ((o = (r = global.process) === null || r === void 0 ? void 0 : r.versions) === null || o === void 0 ? void 0 : o.node) === void 0 && ((i = global.Bun) === null || i === void 0 ? void 0 : i.version) === void 0)) return Nt.empty();
    var a = ((n = {})["process.runtime.name"] = "browser", n["process.runtime.description"] = "Web Browser", n[Io] = navigator.userAgent, n);
    return this._getResourceAttributes(a, t);
  }, e.prototype._getResourceAttributes = function(t, n) {
    return t[Io] === "" ? (w.debug("BrowserDetector failed: Unable to find required browser resources. "), Nt.empty()) : new Nt(Lr({}, t));
  }, e;
}(), bE = new RE(), HS = new (function() {
  function e() {
  }
  return e.prototype.detect = function(t) {
    return Promise.resolve(bE.detect(t));
  }, e;
}())(), NE = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, LE = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, CE = function() {
  function e() {
    this._MAX_LENGTH = 255, this._COMMA_SEPARATOR = ",", this._LABEL_KEY_VALUE_SPLITTER = "=", this._ERROR_MESSAGE_INVALID_CHARS = "should be a ASCII string with a length greater than 0 and not exceed " + this._MAX_LENGTH + " characters.", this._ERROR_MESSAGE_INVALID_VALUE = "should be a ASCII string with a length not exceed " + this._MAX_LENGTH + " characters.";
  }
  return e.prototype.detect = function(t) {
    var n = {}, r = he(), o = r.OTEL_RESOURCE_ATTRIBUTES, i = r.OTEL_SERVICE_NAME;
    if (o) try {
      var a = this._parseResourceAttributes(o);
      Object.assign(n, a);
    } catch (u) {
      w.debug("EnvDetector failed: " + u.message);
    }
    return i && (n[na] = i), new Nt(n);
  }, e.prototype._parseResourceAttributes = function(t) {
    var n, r;
    if (!t) return {};
    var o = {}, i = t.split(this._COMMA_SEPARATOR, -1);
    try {
      for (var a = NE(i), u = a.next(); !u.done; u = a.next()) {
        var c = u.value.split(this._LABEL_KEY_VALUE_SPLITTER, -1);
        if (c.length === 2) {
          var l = LE(c, 2), s = l[0], p = l[1];
          if (s = s.trim(), p = p.trim().split(/^"|"$/).join(""), !this._isValidAndNotEmpty(s)) throw new Error("Attribute key " + this._ERROR_MESSAGE_INVALID_CHARS);
          if (!this._isValid(p)) throw new Error("Attribute value " + this._ERROR_MESSAGE_INVALID_VALUE);
          o[s] = decodeURIComponent(p);
        }
      }
    } catch (v) {
      n = { error: v };
    } finally {
      try {
        u && !u.done && (r = a.return) && r.call(a);
      } finally {
        if (n) throw n.error;
      }
    }
    return o;
  }, e.prototype._isValid = function(t) {
    return t.length <= this._MAX_LENGTH && this._isBaggageOctetString(t);
  }, e.prototype._isBaggageOctetString = function(t) {
    for (var n = 0; n < t.length; n++) {
      var r = t.charCodeAt(n);
      if (r < 33 || r === 44 || r === 59 || r === 92 || r > 126) return !1;
    }
    return !0;
  }, e.prototype._isValidAndNotEmpty = function(t) {
    return t.length > 0 && this._isValid(t);
  }, e;
}(), wE = new CE(), jS = new (function() {
  function e() {
  }
  return e.prototype.detect = function(t) {
    return Promise.resolve(wE.detect(t));
  }, e;
}())(), Cr = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, wr = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, FS = function(e) {
  return e === void 0 && (e = {}), Cr(void 0, void 0, void 0, function() {
    var t;
    return wr(this, function(n) {
      switch (n.label) {
        case 0:
          return [4, Promise.all((e.detectors || []).map(function(r) {
            return Cr(void 0, void 0, void 0, function() {
              var o, i;
              return wr(this, function(a) {
                switch (a.label) {
                  case 0:
                    return a.trys.push([0, 2, , 3]), [4, r.detect(e)];
                  case 1:
                    return o = a.sent(), w.debug(r.constructor.name + " found resource.", o), [2, o];
                  case 2:
                    return i = a.sent(), w.debug(r.constructor.name + " failed: " + i.message), [2, Nt.empty()];
                  case 3:
                    return [2];
                }
              });
            });
          }))];
        case 1:
          return t = n.sent(), ra(t), [2, t.reduce(function(r, o) {
            return r.merge(o);
          }, Nt.empty())];
      }
    });
  });
}, YS = function(e) {
  var t;
  e === void 0 && (e = {});
  var n = ((t = e.detectors) !== null && t !== void 0 ? t : []).map(function(o) {
    try {
      var i, a = o.detect(e);
      return (u = a) !== null && typeof u == "object" && typeof u.then == "function" ? i = new Nt({}, Cr(void 0, void 0, void 0, function() {
        var c, l;
        return wr(this, function(s) {
          switch (s.label) {
            case 0:
              return [4, a];
            case 1:
              return c = s.sent(), [4, (l = c.waitForAsyncAttributes) === null || l === void 0 ? void 0 : l.call(c)];
            case 2:
              return s.sent(), [2, c.attributes];
          }
        });
      })) : i = a, i.waitForAsyncAttributes ? i.waitForAsyncAttributes().then(function() {
        return w.debug(o.constructor.name + " found resource.", i);
      }) : w.debug(o.constructor.name + " found resource.", i), i;
    } catch (c) {
      return w.error(o.constructor.name + " failed: " + c.message), Nt.empty();
    }
    var u;
  }), r = n.reduce(function(o, i) {
    return o.merge(i);
  }, Nt.empty());
  return r.waitForAsyncAttributes && r.waitForAsyncAttributes().then(function() {
    ra(n);
  }), r;
}, ra = function(e) {
  e.forEach(function(t) {
    if (Object.keys(t.attributes).length > 0) {
      var n = JSON.stringify(t.attributes, null, 4);
      w.verbose(n);
    }
  });
}, sn = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, xo = function() {
  function e(t) {
    this._spanProcessors = t;
  }
  return e.prototype.forceFlush = function() {
    var t, n, r = [];
    try {
      for (var o = sn(this._spanProcessors), i = o.next(); !i.done; i = o.next()) {
        var a = i.value;
        r.push(a.forceFlush());
      }
    } catch (u) {
      t = { error: u };
    } finally {
      try {
        i && !i.done && (n = o.return) && n.call(o);
      } finally {
        if (t) throw t.error;
      }
    }
    return new Promise(function(u) {
      Promise.all(r).then(function() {
        u();
      }).catch(function(c) {
        Gt(c || new Error("MultiSpanProcessor: forceFlush failed")), u();
      });
    });
  }, e.prototype.onStart = function(t, n) {
    var r, o;
    try {
      for (var i = sn(this._spanProcessors), a = i.next(); !a.done; a = i.next())
        a.value.onStart(t, n);
    } catch (u) {
      r = { error: u };
    } finally {
      try {
        a && !a.done && (o = i.return) && o.call(i);
      } finally {
        if (r) throw r.error;
      }
    }
  }, e.prototype.onEnd = function(t) {
    var n, r;
    try {
      for (var o = sn(this._spanProcessors), i = o.next(); !i.done; i = o.next())
        i.value.onEnd(t);
    } catch (a) {
      n = { error: a };
    } finally {
      try {
        i && !i.done && (r = o.return) && r.call(o);
      } finally {
        if (n) throw n.error;
      }
    }
  }, e.prototype.shutdown = function() {
    var t, n, r = [];
    try {
      for (var o = sn(this._spanProcessors), i = o.next(); !i.done; i = o.next()) {
        var a = i.value;
        r.push(a.shutdown());
      }
    } catch (u) {
      t = { error: u };
    } finally {
      try {
        i && !i.done && (n = o.return) && n.call(o);
      } finally {
        if (t) throw t.error;
      }
    }
    return new Promise(function(u, c) {
      Promise.all(r).then(function() {
        u();
      }, c);
    });
  }, e;
}(), ME = function() {
  function e() {
  }
  return e.prototype.onStart = function(t, n) {
  }, e.prototype.onEnd = function(t) {
  }, e.prototype.shutdown = function() {
    return Promise.resolve();
  }, e.prototype.forceFlush = function() {
    return Promise.resolve();
  }, e;
}(), PE = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, IE = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
};
(function(e) {
  e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
})(ue || (ue = {}));
var Z, DE = function() {
  function e(t) {
    var n, r;
    t === void 0 && (t = {}), this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
    var o = function() {
      for (var u = [], c = 0; c < arguments.length; c++) u[c] = arguments[c];
      for (var l = u.shift(), s = /* @__PURE__ */ new WeakMap(); u.length > 0; ) l = Wi(l, u.shift(), 0, s);
      return l;
    }({}, ta(), dE(t));
    if (this.resource = (n = o.resource) !== null && n !== void 0 ? n : Nt.empty(), o.mergeResourceWithDefaults && (this.resource = Nt.default().merge(this.resource)), this._config = Object.assign({}, o, { resource: this.resource }), (r = t.spanProcessors) === null || r === void 0 ? void 0 : r.length) this._registeredSpanProcessors = IE([], PE(t.spanProcessors), !1), this.activeSpanProcessor = new xo(this._registeredSpanProcessors);
    else {
      var i = this._buildExporterFromEnv();
      if (i !== void 0) {
        var a = new yE(i);
        this.activeSpanProcessor = a;
      } else this.activeSpanProcessor = new ME();
    }
  }
  return e.prototype.getTracer = function(t, n, r) {
    var o = t + "@" + (n || "") + ":" + (r?.schemaUrl || "");
    return this._tracers.has(o) || this._tracers.set(o, new mE({ name: t, version: n, schemaUrl: r?.schemaUrl }, this._config, this)), this._tracers.get(o);
  }, e.prototype.addSpanProcessor = function(t) {
    this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(n) {
      return w.error("Error while trying to shutdown current span processor", n);
    }), this._registeredSpanProcessors.push(t), this.activeSpanProcessor = new xo(this._registeredSpanProcessors);
  }, e.prototype.getActiveSpanProcessor = function() {
    return this.activeSpanProcessor;
  }, e.prototype.register = function(t) {
    t === void 0 && (t = {}), dt.setGlobalTracerProvider(this), t.propagator === void 0 && (t.propagator = this._buildPropagatorFromEnv()), t.contextManager && $.setGlobalContextManager(t.contextManager), t.propagator && Pt.setGlobalPropagator(t.propagator);
  }, e.prototype.forceFlush = function() {
    var t = this._config.forceFlushTimeoutMillis, n = this._registeredSpanProcessors.map(function(r) {
      return new Promise(function(o) {
        var i, a = setTimeout(function() {
          o(new Error("Span processor did not completed within timeout period of " + t + " ms")), i = ue.timeout;
        }, t);
        r.forceFlush().then(function() {
          clearTimeout(a), i !== ue.timeout && (i = ue.resolved, o(i));
        }).catch(function(u) {
          clearTimeout(a), i = ue.error, o(u);
        });
      });
    });
    return new Promise(function(r, o) {
      Promise.all(n).then(function(i) {
        var a = i.filter(function(u) {
          return u !== ue.resolved;
        });
        a.length > 0 ? o(a) : r();
      }).catch(function(i) {
        return o([i]);
      });
    });
  }, e.prototype.shutdown = function() {
    return this.activeSpanProcessor.shutdown();
  }, e.prototype._getPropagator = function(t) {
    var n;
    return (n = this.constructor._registeredPropagators.get(t)) === null || n === void 0 ? void 0 : n();
  }, e.prototype._getSpanExporter = function(t) {
    var n;
    return (n = this.constructor._registeredExporters.get(t)) === null || n === void 0 ? void 0 : n();
  }, e.prototype._buildPropagatorFromEnv = function() {
    var t = this, n = Array.from(new Set(he().OTEL_PROPAGATORS)), r = n.map(function(o) {
      var i = t._getPropagator(o);
      return i || w.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), i;
    }).reduce(function(o, i) {
      return i && o.push(i), o;
    }, []);
    return r.length === 0 ? void 0 : n.length === 1 ? r[0] : new Qh({ propagators: r });
  }, e.prototype._buildExporterFromEnv = function() {
    var t = he().OTEL_TRACES_EXPORTER;
    if (t !== "none" && t !== "") {
      var n = this._getSpanExporter(t);
      return n || w.error('Exporter "' + t + '" requested through environment variable is unavailable.'), n;
    }
  }, e._registeredPropagators = /* @__PURE__ */ new Map([["tracecontext", function() {
    return new rE();
  }], ["baggage", function() {
    return new Dh();
  }]]), e._registeredExporters = /* @__PURE__ */ new Map(), e;
}(), UE = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, kE = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, zS = function() {
  function e(t) {
    this._exporter = t, this._shutdownOnce = new Ji(this._shutdown, this), this._unresolvedExports = /* @__PURE__ */ new Set();
  }
  return e.prototype.forceFlush = function() {
    return UE(this, void 0, void 0, function() {
      return kE(this, function(t) {
        switch (t.label) {
          case 0:
            return [4, Promise.all(Array.from(this._unresolvedExports))];
          case 1:
            return t.sent(), this._exporter.forceFlush ? [4, this._exporter.forceFlush()] : [3, 3];
          case 2:
            t.sent(), t.label = 3;
          case 3:
            return [2];
        }
      });
    });
  }, e.prototype.onStart = function(t, n) {
  }, e.prototype.onEnd = function(t) {
    var n, r, o = this;
    if (!this._shutdownOnce.isCalled && t.spanContext().traceFlags & Kt.SAMPLED) {
      var i = function() {
        return $i._export(o._exporter, [t]).then(function(u) {
          var c;
          u.code !== Mt.SUCCESS && Gt((c = u.error) !== null && c !== void 0 ? c : new Error("SimpleSpanProcessor: span export failed (status " + u + ")"));
        }).catch(function(u) {
          Gt(u);
        });
      };
      if (t.resource.asyncAttributesPending) {
        var a = (r = (n = t.resource).waitForAsyncAttributes) === null || r === void 0 ? void 0 : r.call(n).then(function() {
          return a != null && o._unresolvedExports.delete(a), i();
        }, function(u) {
          return Gt(u);
        });
        a != null && this._unresolvedExports.add(a);
      } else i();
    }
  }, e.prototype.shutdown = function() {
    return this._shutdownOnce.call();
  }, e.prototype._shutdown = function() {
    return this._exporter.shutdown();
  }, e;
}(), xE = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, VE = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}, BE = function() {
  function e() {
    this._enabled = !1, this._currentContext = Zt;
  }
  return e.prototype._bindFunction = function(t, n) {
    t === void 0 && (t = Zt);
    var r = this, o = function() {
      for (var i = this, a = [], u = 0; u < arguments.length; u++) a[u] = arguments[u];
      return r.with(t, function() {
        return n.apply(i, a);
      });
    };
    return Object.defineProperty(o, "length", { enumerable: !1, configurable: !0, writable: !1, value: n.length }), o;
  }, e.prototype.active = function() {
    return this._currentContext;
  }, e.prototype.bind = function(t, n) {
    return t === void 0 && (t = this.active()), typeof n == "function" ? this._bindFunction(t, n) : n;
  }, e.prototype.disable = function() {
    return this._currentContext = Zt, this._enabled = !1, this;
  }, e.prototype.enable = function() {
    return this._enabled || (this._enabled = !0, this._currentContext = Zt), this;
  }, e.prototype.with = function(t, n, r) {
    for (var o = [], i = 3; i < arguments.length; i++) o[i - 3] = arguments[i];
    var a = this._currentContext;
    this._currentContext = t || Zt;
    try {
      return n.call.apply(n, VE([r], xE(o), !1));
    } finally {
      this._currentContext = a;
    }
  }, e;
}(), GE = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ZS = function(e) {
  function t(n) {
    n === void 0 && (n = {});
    var r = e.call(this, n) || this;
    if (n.contextManager) throw "contextManager should be defined in register method not in constructor";
    if (n.propagator) throw "propagator should be defined in register method not in constructor";
    return r;
  }
  return GE(t, e), t.prototype.register = function(n) {
    n === void 0 && (n = {}), n.contextManager === void 0 && (n.contextManager = new BE()), n.contextManager && n.contextManager.enable(), e.prototype.register.call(this, n);
  }, t;
}(DE);
(function(e) {
  e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
})(Z || (Z = {}));
var ur;
function oe(e, t) {
  return t in e;
}
function gt(e, t, n, r) {
  var o = void 0, i = void 0;
  oe(n, t) && typeof n[t] == "number" && (o = n[t]);
  var a = Z.FETCH_START;
  if (oe(n, a) && typeof n[a] == "number" && (i = n[a]), o !== void 0 && i !== void 0 && o >= i) return e.addEvent(t, o), e;
}
function Ce(e, t, n) {
  n === void 0 && (n = !1), n || (gt(e, Z.FETCH_START, t), gt(e, Z.DOMAIN_LOOKUP_START, t), gt(e, Z.DOMAIN_LOOKUP_END, t), gt(e, Z.CONNECT_START, t), oe(t, "name") && t.name.startsWith("https:") && gt(e, Z.SECURE_CONNECTION_START, t), gt(e, Z.CONNECT_END, t), gt(e, Z.REQUEST_START, t), gt(e, Z.RESPONSE_START, t), gt(e, Z.RESPONSE_END, t));
  var r = t[Z.ENCODED_BODY_SIZE];
  r !== void 0 && e.setAttribute("http.response_content_length", r);
  var o = t[Z.DECODED_BODY_SIZE];
  o !== void 0 && r !== o && e.setAttribute("http.response_content_length_uncompressed", o);
}
function oa() {
  return typeof location < "u" ? location.origin : void 0;
}
function ia(e, t, n, r, o, i) {
  o === void 0 && (o = /* @__PURE__ */ new WeakSet());
  var a = te(e), u = function(v, g, b, H, P, N) {
    var J = Jt(g), ct = Jt(b), X = H.filter(function(lt) {
      var xt = Jt(Ue(lt[Z.FETCH_START])), Rt = Jt(Ue(lt[Z.RESPONSE_END]));
      return lt.initiatorType.toLowerCase() === (N || "xmlhttprequest") && lt.name === v && xt >= J && Rt <= ct;
    });
    return X.length > 0 && (X = X.filter(function(lt) {
      return !P.has(lt);
    })), X;
  }(e = a.toString(), t, n, r, o, i);
  if (u.length === 0) return { mainRequest: void 0 };
  if (u.length === 1) return { mainRequest: u[0] };
  var c = function(v) {
    return v.slice().sort(function(g, b) {
      var H = g[Z.FETCH_START], P = b[Z.FETCH_START];
      return H > P ? 1 : H < P ? -1 : 0;
    });
  }(u);
  if (a.origin !== oa() && c.length > 1) {
    var l = c[0], s = function(v, g, b) {
      for (var H, P = Jt(b), N = Jt(Ue(g)), J = v[1], ct = v.length, X = 1; X < ct; X++) {
        var lt = v[X], xt = Jt(Ue(lt[Z.FETCH_START])), Rt = P - Jt(Ue(lt[Z.RESPONSE_END]));
        xt >= N && (!H || Rt < H) && (H = Rt, J = lt);
      }
      return J;
    }(c, l[Z.RESPONSE_END], n), p = l[Z.RESPONSE_END];
    return s[Z.FETCH_START] < p && (s = l, l = void 0), { corsPreFlightRequest: l, mainRequest: s };
  }
  return { mainRequest: u[0] };
}
function te(e) {
  if (typeof URL == "function") return new URL(e, typeof document < "u" ? document.baseURI : typeof location < "u" ? location.href : void 0);
  var t = (ur || (ur = document.createElement("a")), ur);
  return t.href = e, t;
}
function aa(e, t) {
  if (e.nodeType === Node.DOCUMENT_NODE) return "/";
  var n = function(o, i) {
    var a = o.nodeType, u = function(s) {
      if (!s.parentNode) return 0;
      var p = [s.nodeType];
      s.nodeType === Node.CDATA_SECTION_NODE && p.push(Node.TEXT_NODE);
      var v = Array.from(s.parentNode.childNodes);
      return v = v.filter(function(g) {
        var b = g.localName;
        return p.indexOf(g.nodeType) >= 0 && b === s.localName;
      }), v.length >= 1 ? v.indexOf(s) + 1 : 0;
    }(o), c = "";
    if (a === Node.ELEMENT_NODE) {
      var l = o.getAttribute("id");
      if (i && l) return '//*[@id="' + l + '"]';
      c = o.localName;
    } else if (a === Node.TEXT_NODE || a === Node.CDATA_SECTION_NODE) c = "text()";
    else {
      if (a !== Node.COMMENT_NODE) return "";
      c = "comment()";
    }
    return c && u > 1 ? "/" + c + "[" + u + "]" : "/" + c;
  }(e, t);
  if (t && n.indexOf("@id") > 0) return n;
  var r = "";
  return e.parentNode && (r += aa(e.parentNode, !1)), r += n;
}
function sa(e, t) {
  var n = t || [];
  return (typeof n == "string" || n instanceof RegExp) && (n = [n]), te(e).origin === oa() || n.some(function(r) {
    return qi(e, r);
  });
}
var ua = function() {
  function e() {
  }
  return e.prototype.emit = function(t) {
  }, e;
}(), HE = new ua(), ca = new (function() {
  function e() {
  }
  return e.prototype.getLogger = function(t, n, r) {
    return new ua();
  }, e;
}())(), jE = function() {
  function e(t, n, r, o) {
    this._provider = t, this.name = n, this.version = r, this.options = o;
  }
  return e.prototype.emit = function(t) {
    this._getLogger().emit(t);
  }, e.prototype._getLogger = function() {
    if (this._delegate) return this._delegate;
    var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
    return t ? (this._delegate = t, this._delegate) : HE;
  }, e;
}(), Vo = function() {
  function e() {
  }
  return e.prototype.getLogger = function(t, n, r) {
    var o;
    return (o = this.getDelegateLogger(t, n, r)) !== null && o !== void 0 ? o : new jE(this, t, n, r);
  }, e.prototype.getDelegate = function() {
    var t;
    return (t = this._delegate) !== null && t !== void 0 ? t : ca;
  }, e.prototype.setDelegate = function(t) {
    this._delegate = t;
  }, e.prototype.getDelegateLogger = function(t, n, r) {
    var o;
    return (o = this._delegate) === null || o === void 0 ? void 0 : o.getLogger(t, n, r);
  }, e;
}(), FE = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, un = Symbol.for("io.opentelemetry.js.api.logs"), xe = FE, Bo, Go, YE = function() {
  function e() {
    this._proxyLoggerProvider = new Vo();
  }
  return e.getInstance = function() {
    return this._instance || (this._instance = new e()), this._instance;
  }, e.prototype.setGlobalLoggerProvider = function(t) {
    return xe[un] ? this.getLoggerProvider() : (xe[un] = (n = 1, r = t, o = ca, function(i) {
      return i === n ? r : o;
    }), this._proxyLoggerProvider.setDelegate(t), t);
    var n, r, o;
  }, e.prototype.getLoggerProvider = function() {
    var t, n;
    return (n = (t = xe[un]) === null || t === void 0 ? void 0 : t.call(xe, 1)) !== null && n !== void 0 ? n : this._proxyLoggerProvider;
  }, e.prototype.getLogger = function(t, n, r) {
    return this.getLoggerProvider().getLogger(t, n, r);
  }, e.prototype.disable = function() {
    delete xe[un], this._proxyLoggerProvider = new Vo();
  }, e;
}(), la = YE.getInstance();
function XS(e) {
  var t, n, r = e.tracerProvider || dt.getTracerProvider(), o = e.meterProvider || xi.getMeterProvider(), i = e.loggerProvider || la.getLoggerProvider(), a = (n = (t = e.instrumentations) === null || t === void 0 ? void 0 : t.flat()) !== null && n !== void 0 ? n : [];
  return function(u, c, l, s) {
    for (var p = 0, v = u.length; p < v; p++) {
      var g = u[p];
      c && g.setTracerProvider(c), l && g.setMeterProvider(l), s && g.setLoggerProvider && g.setLoggerProvider(s), g.getConfig().enabled || g.enable();
    }
  }(a, r, o, i), function() {
    (function(u) {
      u.forEach(function(c) {
        return c.disable();
      });
    })(a);
  };
}
var cn = function() {
  if (Go) return Bo;
  function e(a) {
    return typeof a == "function";
  }
  Go = 1;
  var t = console.error.bind(console);
  function n(a, u, c) {
    var l = !!a[u] && a.propertyIsEnumerable(u);
    Object.defineProperty(a, u, { configurable: !0, enumerable: l, writable: !0, value: c });
  }
  function r(a) {
    a && a.logger && (e(a.logger) ? t = a.logger : t("new logger isn't a function, not replacing"));
  }
  function o(a, u, c) {
    if (a && a[u]) {
      if (!c) return t("no wrapper function"), void t(new Error().stack);
      if (e(a[u]) && e(c)) {
        var l = a[u], s = c(l, u);
        return n(s, "__original", l), n(s, "__unwrap", function() {
          a[u] === s && n(a, u, l);
        }), n(s, "__wrapped", !0), n(a, u, s), s;
      }
      t("original object and wrapper must be functions");
    } else t("no original function " + u + " to wrap");
  }
  function i(a, u) {
    return a && a[u] ? a[u].__unwrap ? a[u].__unwrap() : void t("no original to unwrap to -- has " + u + " already been unwrapped?") : (t("no function to unwrap."), void t(new Error().stack));
  }
  return r.wrap = o, r.massWrap = function(a, u, c) {
    if (!a) return t("must provide one or more modules to patch"), void t(new Error().stack);
    Array.isArray(a) || (a = [a]), u && Array.isArray(u) ? a.forEach(function(l) {
      u.forEach(function(s) {
        o(l, s, c);
      });
    }) : t("must provide one or more functions to wrap on modules");
  }, r.unwrap = i, r.massUnwrap = function(a, u) {
    if (!a) return t("must provide one or more modules to patch"), void t(new Error().stack);
    Array.isArray(a) || (a = [a]), u && Array.isArray(u) ? a.forEach(function(c) {
      u.forEach(function(l) {
        i(c, l);
      });
    }) : t("must provide one or more functions to unwrap on modules");
  }, Bo = r;
}(), Mr = function() {
  return Mr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    return e;
  }, Mr.apply(this, arguments);
}, zE = function() {
  function e(t, n, r) {
    this.instrumentationName = t, this.instrumentationVersion = n, this._config = {}, this._wrap = cn.wrap, this._unwrap = cn.unwrap, this._massWrap = cn.massWrap, this._massUnwrap = cn.massUnwrap, this.setConfig(r), this._diag = w.createComponentLogger({ namespace: t }), this._tracer = dt.getTracer(t, n), this._meter = xi.getMeter(t, n), this._logger = la.getLogger(t, n), this._updateMetricInstruments();
  }
  return Object.defineProperty(e.prototype, "meter", { get: function() {
    return this._meter;
  }, enumerable: !1, configurable: !0 }), e.prototype.setMeterProvider = function(t) {
    this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
  }, Object.defineProperty(e.prototype, "logger", { get: function() {
    return this._logger;
  }, enumerable: !1, configurable: !0 }), e.prototype.setLoggerProvider = function(t) {
    this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
  }, e.prototype.getModuleDefinitions = function() {
    var t, n = (t = this.init()) !== null && t !== void 0 ? t : [];
    return Array.isArray(n) ? n : [n];
  }, e.prototype._updateMetricInstruments = function() {
  }, e.prototype.getConfig = function() {
    return this._config;
  }, e.prototype.setConfig = function(t) {
    this._config = Mr({ enabled: !0 }, t);
  }, e.prototype.setTracerProvider = function(t) {
    this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
  }, Object.defineProperty(e.prototype, "tracer", { get: function() {
    return this._tracer;
  }, enumerable: !1, configurable: !0 }), e.prototype._runSpanCustomizationHook = function(t, n, r, o) {
    if (t) try {
      t(r, o);
    } catch (i) {
      this._diag.error("Error running span customization hook due to exception in handler", { triggerName: n }, i);
    }
  }, e;
}(), ZE = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), xn = function(e) {
  function t(n, r, o) {
    var i = e.call(this, n, r, o) || this;
    return i._config.enabled && i.enable(), i;
  }
  return ZE(t, e), t;
}(zE), je, WS = function(e, t, n, r, o) {
  this.name = e, this.supportedVersions = t, this.patch = n, this.unpatch = r, this.files = o || [];
}, KS = function(e, t, n, r) {
  var o;
  this.supportedVersions = t, this.patch = n, this.unpatch = r, this.name = (o = e, w.warn("Path normalization is not implemented for this platform. To silence this warning, ensure no node-specific instrumentations are loaded, and node-specific types (e.g. InstrumentationNodeModuleFile), are not used in a browser context)"), o);
}, XE = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, WE = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
};
function bn(e, t, n) {
  var r, o;
  try {
    o = e();
  } catch (i) {
    r = i;
  } finally {
    if (t(r, o), r && !n) throw r;
    return o;
  }
}
function qS(e, t, n) {
  return XE(this, void 0, void 0, function() {
    var r, o, i;
    return WE(this, function(a) {
      switch (a.label) {
        case 0:
          return a.trys.push([0, 2, 3, 4]), [4, e()];
        case 1:
          return o = a.sent(), [3, 4];
        case 2:
          return i = a.sent(), r = i, [3, 4];
        case 3:
          if (t(r, o), r && !n) throw r;
          return [2, o];
        case 4:
          return [2];
      }
    });
  });
}
function mt(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
(function(e) {
  e.DOCUMENT_LOAD = "documentLoad", e.DOCUMENT_FETCH = "documentFetch", e.RESOURCE_FETCH = "resourceFetch";
})(je || (je = {}));
function vt(e) {
  for (var t = {}, n = e.length, r = 0; r < n; r++) {
    var o = e[r];
    o && (t[String(o).toUpperCase().replace(/[-.]/g, "_")] = o);
  }
  return t;
}
var Nn, pa = "aws.lambda.invoked_arn", fa = "db.system", _a = "db.connection_string", ha = "db.user", Ea = "db.jdbc.driver_classname", da = "db.name", Ta = "db.statement", Sa = "db.operation", ya = "db.mssql.instance_name", va = "db.cassandra.keyspace", ma = "db.cassandra.page_size", ga = "db.cassandra.consistency_level", Aa = "db.cassandra.table", Oa = "db.cassandra.idempotence", Ra = "db.cassandra.speculative_execution_count", ba = "db.cassandra.coordinator.id", Na = "db.cassandra.coordinator.dc", La = "db.hbase.namespace", Ca = "db.redis.database_index", wa = "db.mongodb.collection", Ma = "db.sql.table", Pa = "exception.type", Ia = "exception.message", Da = "exception.stacktrace", Ua = "exception.escaped", ka = "faas.trigger", xa = "faas.execution", Va = "faas.document.collection", Ba = "faas.document.operation", Ga = "faas.document.time", Ha = "faas.document.name", ja = "faas.time", Fa = "faas.cron", Ya = "faas.coldstart", za = "faas.invoked_name", Za = "faas.invoked_provider", Xa = "faas.invoked_region", Wa = "net.transport", Ka = "net.peer.ip", qa = "net.peer.port", Qa = "net.peer.name", Ja = "net.host.ip", $a = "net.host.port", ts = "net.host.name", es = "net.host.connection.type", ns = "net.host.connection.subtype", rs = "net.host.carrier.name", os = "net.host.carrier.mcc", is = "net.host.carrier.mnc", as = "net.host.carrier.icc", ss = "peer.service", us = "enduser.id", cs = "enduser.role", ls = "enduser.scope", ps = "thread.id", fs = "thread.name", _s = "code.function", hs = "code.namespace", Es = "code.filepath", ds = "code.lineno", Ts = "http.method", Ss = "http.url", ys = "http.target", vs = "http.host", ms = "http.scheme", gs = "http.status_code", As = "http.flavor", Os = "http.user_agent", Rs = "http.request_content_length", bs = "http.request_content_length_uncompressed", Ns = "http.response_content_length", Ls = "http.response_content_length_uncompressed", Cs = "http.server_name", ws = "http.route", Ms = "http.client_ip", Ps = "aws.dynamodb.table_names", Is = "aws.dynamodb.consumed_capacity", Ds = "aws.dynamodb.item_collection_metrics", Us = "aws.dynamodb.provisioned_read_capacity", ks = "aws.dynamodb.provisioned_write_capacity", xs = "aws.dynamodb.consistent_read", Vs = "aws.dynamodb.projection", Bs = "aws.dynamodb.limit", Gs = "aws.dynamodb.attributes_to_get", Hs = "aws.dynamodb.index_name", js = "aws.dynamodb.select", Fs = "aws.dynamodb.global_secondary_indexes", Ys = "aws.dynamodb.local_secondary_indexes", zs = "aws.dynamodb.exclusive_start_table", Zs = "aws.dynamodb.table_count", Xs = "aws.dynamodb.scan_forward", Ws = "aws.dynamodb.segment", Ks = "aws.dynamodb.total_segments", qs = "aws.dynamodb.count", Qs = "aws.dynamodb.scanned_count", Js = "aws.dynamodb.attribute_definitions", $s = "aws.dynamodb.global_secondary_index_updates", tu = "messaging.system", eu = "messaging.destination", nu = "messaging.destination_kind", ru = "messaging.temp_destination", ou = "messaging.protocol", iu = "messaging.protocol_version", au = "messaging.url", su = "messaging.message_id", uu = "messaging.conversation_id", cu = "messaging.message_payload_size_bytes", lu = "messaging.message_payload_compressed_size_bytes", pu = "messaging.operation", fu = "messaging.consumer_id", _u = "messaging.rabbitmq.routing_key", hu = "messaging.kafka.message_key", Eu = "messaging.kafka.consumer_group", du = "messaging.kafka.client_id", Tu = "messaging.kafka.partition", Su = "messaging.kafka.tombstone", yu = "rpc.system", vu = "rpc.service", mu = "rpc.method", gu = "rpc.grpc.status_code", Au = "rpc.jsonrpc.version", Ou = "rpc.jsonrpc.request_id", Ru = "rpc.jsonrpc.error_code", bu = "rpc.jsonrpc.error_message", Nu = "message.type", Lu = "message.id", Cu = "message.compressed_size", wu = "message.uncompressed_size", QS = pa, JS = fa, $S = _a, ty = ha, ey = Ea, ny = da, ry = Ta, oy = Sa, iy = ya, ay = va, sy = ma, uy = ga, cy = Aa, ly = Oa, py = Ra, fy = ba, _y = Na, hy = La, Ey = Ca, dy = wa, Ty = Ma, Sy = Pa, yy = Ia, vy = Da, my = Ua, gy = ka, Ay = xa, Oy = Va, Ry = Ba, by = Ga, Ny = Ha, Ly = ja, Cy = Fa, wy = Ya, My = za, Py = Za, Iy = Xa, Dy = Wa, Uy = Ka, ky = qa, xy = Qa, Vy = Ja, By = $a, Gy = ts, Hy = es, jy = ns, Fy = rs, Yy = os, zy = is, Zy = as, Xy = ss, Wy = us, Ky = cs, qy = ls, Qy = ps, Jy = fs, $y = _s, tv = hs, ev = Es, nv = ds, rv = Ts, cr = Ss, ov = ys, iv = vs, av = ms, sv = gs, uv = As, KE = Os, cv = Rs, lv = bs, pv = Ns, fv = Ls, _v = Cs, hv = ws, Ev = Ms, dv = Ps, Tv = Is, Sv = Ds, yv = Us, vv = ks, mv = xs, gv = Vs, Av = Bs, Ov = Gs, Rv = Hs, bv = js, Nv = Fs, Lv = Ys, Cv = zs, wv = Zs, Mv = Xs, Pv = Ws, Iv = Ks, Dv = qs, Uv = Qs, kv = Js, xv = $s, Vv = tu, Bv = eu, Gv = nu, Hv = ru, jv = ou, Fv = iu, Yv = au, zv = su, Zv = uu, Xv = cu, Wv = lu, Kv = pu, qv = fu, Qv = _u, Jv = hu, $v = Eu, tm = du, em = Tu, nm = Su, rm = yu, om = vu, im = mu, am = gu, sm = Au, um = Ou, cm = Ru, lm = bu, pm = Nu, fm = Lu, _m = Cu, hm = wu, Em = vt([pa, fa, _a, ha, Ea, da, Ta, Sa, ya, va, ma, ga, Aa, Oa, Ra, ba, Na, La, Ca, wa, Ma, Pa, Ia, Da, Ua, ka, xa, Va, Ba, Ga, Ha, ja, Fa, Ya, za, Za, Xa, Wa, Ka, qa, Qa, Ja, $a, ts, es, ns, rs, os, is, as, ss, us, cs, ls, ps, fs, _s, hs, Es, ds, Ts, Ss, ys, vs, ms, gs, As, Os, Rs, bs, Ns, Ls, Cs, ws, Ms, Ps, Is, Ds, Us, ks, xs, Vs, Bs, Gs, Hs, js, Fs, Ys, zs, Zs, Xs, Ws, Ks, qs, Qs, Js, $s, tu, eu, nu, ru, ou, iu, au, su, uu, cu, lu, pu, fu, _u, hu, Eu, du, Tu, Su, yu, vu, mu, gu, Au, Ou, Ru, bu, Nu, Lu, Cu, wu]), Mu = "other_sql", Pu = "mssql", Iu = "mysql", Du = "oracle", Uu = "postgresql", ku = "redshift", xu = "hive", Vu = "cloudscape", Bu = "hsqldb", Gu = "progress", Hu = "maxdb", ju = "hanadb", Fu = "ingres", Yu = "firstsql", zu = "cache", Zu = "adabas", Xu = "firebird", Wu = "derby", Ku = "filemaker", qu = "informix", Qu = "instantdb", Ju = "interbase", $u = "mariadb", tc = "netezza", ec = "pervasive", nc = "pointbase", rc = "sqlite", oc = "sybase", ic = "teradata", ac = "vertica", sc = "coldfusion", uc = "cassandra", cc = "hbase", lc = "mongodb", pc = "redis", fc = "couchbase", _c = "couchdb", hc = "cosmosdb", Ec = "dynamodb", dc = "neo4j", Tc = "geode", Sc = "elasticsearch", yc = "memcached", vc = "cockroachdb", dm = Mu, Tm = Pu, Sm = Iu, ym = Du, vm = "db2", mm = Uu, gm = ku, Am = xu, Om = Vu, Rm = Bu, bm = Gu, Nm = Hu, Lm = ju, Cm = Fu, wm = Yu, Mm = "edb", Pm = zu, Im = Zu, Dm = Xu, Um = Wu, km = Ku, xm = qu, Vm = Qu, Bm = Ju, Gm = $u, Hm = tc, jm = ec, Fm = nc, Ym = rc, zm = oc, Zm = ic, Xm = ac, Wm = "h2", Km = sc, qm = uc, Qm = cc, Jm = lc, $m = pc, tg = fc, eg = _c, ng = hc, rg = Ec, og = dc, ig = Tc, ag = Sc, sg = yc, ug = vc, cg = vt([Mu, Pu, Iu, Du, "db2", Uu, ku, xu, Vu, Bu, Gu, Hu, ju, Fu, Yu, "edb", zu, Zu, Xu, Wu, Ku, qu, Qu, Ju, $u, tc, ec, nc, rc, oc, ic, ac, "h2", sc, uc, cc, lc, pc, fc, _c, hc, Ec, dc, Tc, Sc, yc, vc]), mc = "each_quorum", gc = "quorum", Ac = "local_quorum", Oc = "three", Rc = "local_one", bc = "serial", Nc = "local_serial", lg = "all", pg = mc, fg = gc, _g = Ac, hg = "one", Eg = "two", dg = Oc, Tg = Rc, Sg = "any", yg = bc, vg = Nc, mg = vt(["all", mc, gc, Ac, "one", "two", Oc, Rc, "any", bc, Nc]), Lc = "datasource", Cc = "http", wc = "pubsub", Mc = "timer", Pc = "other", gg = Lc, Ag = Cc, Og = wc, Rg = Mc, bg = Pc, Ng = vt([Lc, Cc, wc, Mc, Pc]), Ic = "insert", Dc = "edit", Uc = "delete", Lg = Ic, Cg = Dc, wg = Uc, Mg = vt([Ic, Dc, Uc]), kc = "alibaba_cloud", xc = "azure", Pg = kc, Ig = "aws", Dg = xc, Ug = "gcp", kg = vt([kc, "aws", xc, "gcp"]), Vc = "ip_tcp", Bc = "ip_udp", Gc = "unix", Hc = "pipe", jc = "inproc", Fc = "other", xg = Vc, Vg = Bc, Bg = "ip", Gg = Gc, Hg = Hc, jg = jc, Fg = Fc, Yg = vt([Vc, Bc, "ip", Gc, Hc, jc, Fc]), Yc = "wifi", zc = "wired", Zc = "cell", Xc = "unavailable", Wc = "unknown", zg = Yc, Zg = zc, Xg = Zc, Wg = Xc, Kg = Wc, qg = vt([Yc, zc, Zc, Xc, Wc]), Kc = "gprs", qc = "edge", Qc = "umts", Jc = "cdma", $c = "evdo_0", tl = "evdo_a", el = "cdma2000_1xrtt", nl = "hsdpa", rl = "hsupa", ol = "hspa", il = "iden", al = "evdo_b", sl = "ehrpd", ul = "hspap", cl = "td_scdma", ll = "iwlan", pl = "nrnsa", fl = "lte_ca", Qg = Kc, Jg = qc, $g = Qc, tA = Jc, eA = $c, nA = tl, rA = el, oA = nl, iA = rl, aA = ol, sA = il, uA = al, cA = "lte", lA = sl, pA = ul, fA = "gsm", _A = cl, hA = ll, EA = "nr", dA = pl, TA = fl, SA = vt([Kc, qc, Qc, Jc, $c, tl, el, nl, rl, ol, il, al, "lte", sl, ul, "gsm", cl, ll, "nr", pl, fl]), _l = "SPDY", hl = "QUIC", yA = "1.0", vA = "1.1", mA = "2.0", gA = _l, AA = hl, OA = { HTTP_1_0: "1.0", HTTP_1_1: "1.1", HTTP_2_0: "2.0", SPDY: _l, QUIC: hl }, El = "queue", dl = "topic", RA = El, bA = dl, NA = vt([El, dl]), Tl = "receive", Sl = "process", LA = Tl, CA = Sl, wA = vt([Tl, Sl]), MA = 0, PA = 1, IA = 2, DA = 3, UA = 4, kA = 5, xA = 6, VA = 7, BA = 8, GA = 9, HA = 10, jA = 11, FA = 12, YA = 13, zA = 14, ZA = 15, XA = 16, WA = { OK: 0, CANCELLED: 1, UNKNOWN: 2, INVALID_ARGUMENT: 3, DEADLINE_EXCEEDED: 4, NOT_FOUND: 5, ALREADY_EXISTS: 6, PERMISSION_DENIED: 7, RESOURCE_EXHAUSTED: 8, FAILED_PRECONDITION: 9, ABORTED: 10, OUT_OF_RANGE: 11, UNIMPLEMENTED: 12, INTERNAL: 13, UNAVAILABLE: 14, DATA_LOSS: 15, UNAUTHENTICATED: 16 }, yl = "SENT", vl = "RECEIVED", KA = yl, qA = vl, QA = vt([yl, vl]), ml = "cloud.provider", gl = "cloud.account.id", Al = "cloud.region", Ol = "cloud.availability_zone", Rl = "cloud.platform", bl = "aws.ecs.container.arn", Nl = "aws.ecs.cluster.arn", Ll = "aws.ecs.launchtype", Cl = "aws.ecs.task.arn", wl = "aws.ecs.task.family", Ml = "aws.ecs.task.revision", Pl = "aws.eks.cluster.arn", Il = "aws.log.group.names", Dl = "aws.log.group.arns", Ul = "aws.log.stream.names", kl = "aws.log.stream.arns", xl = "container.name", Vl = "container.id", Bl = "container.runtime", Gl = "container.image.name", Hl = "container.image.tag", jl = "deployment.environment", Fl = "device.id", Yl = "device.model.identifier", zl = "device.model.name", Zl = "faas.name", Xl = "faas.id", Wl = "faas.version", Kl = "faas.instance", ql = "faas.max_memory", Ql = "host.id", Jl = "host.name", $l = "host.type", tp = "host.arch", ep = "host.image.name", np = "host.image.id", rp = "host.image.version", op = "k8s.cluster.name", ip = "k8s.node.name", ap = "k8s.node.uid", sp = "k8s.namespace.name", up = "k8s.pod.uid", cp = "k8s.pod.name", lp = "k8s.container.name", pp = "k8s.replicaset.uid", fp = "k8s.replicaset.name", _p = "k8s.deployment.uid", hp = "k8s.deployment.name", Ep = "k8s.statefulset.uid", dp = "k8s.statefulset.name", Tp = "k8s.daemonset.uid", Sp = "k8s.daemonset.name", yp = "k8s.job.uid", vp = "k8s.job.name", mp = "k8s.cronjob.uid", gp = "k8s.cronjob.name", Ap = "os.type", Op = "os.description", Rp = "os.name", bp = "os.version", Np = "process.pid", Lp = "process.executable.name", Cp = "process.executable.path", wp = "process.command", Mp = "process.command_line", Pp = "process.command_args", Ip = "process.owner", Dp = "process.runtime.name", Up = "process.runtime.version", kp = "process.runtime.description", xp = "service.name", Vp = "service.namespace", Bp = "service.instance.id", Gp = "service.version", Hp = "telemetry.sdk.name", jp = "telemetry.sdk.language", Fp = "telemetry.sdk.version", Yp = "telemetry.auto.version", zp = "webengine.name", Zp = "webengine.version", Xp = "webengine.description", JA = ml, $A = gl, tO = Al, eO = Ol, nO = Rl, rO = bl, oO = Nl, iO = Ll, aO = Cl, sO = wl, uO = Ml, cO = Pl, lO = Il, pO = Dl, fO = Ul, _O = kl, hO = xl, EO = Vl, dO = Bl, TO = Gl, SO = Hl, yO = jl, vO = Fl, mO = Yl, gO = zl, AO = Zl, OO = Xl, RO = Wl, bO = Kl, NO = ql, LO = Ql, CO = Jl, wO = $l, MO = tp, PO = ep, IO = np, DO = rp, UO = op, kO = ip, xO = ap, VO = sp, BO = up, GO = cp, HO = lp, jO = pp, FO = fp, YO = _p, zO = hp, ZO = Ep, XO = dp, WO = Tp, KO = Sp, qO = yp, QO = vp, JO = mp, $O = gp, tR = Ap, eR = Op, nR = Rp, rR = bp, oR = Np, iR = Lp, aR = Cp, sR = wp, uR = Mp, cR = Pp, lR = Ip, pR = Dp, fR = Up, _R = kp, hR = xp, ER = Vp, dR = Bp, TR = Gp, SR = Hp, yR = jp, vR = Fp, mR = Yp, gR = zp, AR = Zp, OR = Xp, RR = vt([ml, gl, Al, Ol, Rl, bl, Nl, Ll, Cl, wl, Ml, Pl, Il, Dl, Ul, kl, xl, Vl, Bl, Gl, Hl, jl, Fl, Yl, zl, Zl, Xl, Wl, Kl, ql, Ql, Jl, $l, tp, ep, np, rp, op, ip, ap, sp, up, cp, lp, pp, fp, _p, hp, Ep, dp, Tp, Sp, yp, vp, mp, gp, Ap, Op, Rp, bp, Np, Lp, Cp, wp, Mp, Pp, Ip, Dp, Up, kp, xp, Vp, Bp, Gp, Hp, jp, Fp, Yp, zp, Zp, Xp]), Wp = "alibaba_cloud", Kp = "azure", bR = Wp, NR = "aws", LR = Kp, CR = "gcp", wR = vt([Wp, "aws", Kp, "gcp"]), qp = "alibaba_cloud_ecs", Qp = "alibaba_cloud_fc", Jp = "aws_ec2", $p = "aws_ecs", tf = "aws_eks", ef = "aws_lambda", nf = "aws_elastic_beanstalk", rf = "azure_vm", of = "azure_container_instances", af = "azure_aks", sf = "azure_functions", uf = "azure_app_service", cf = "gcp_compute_engine", lf = "gcp_cloud_run", pf = "gcp_kubernetes_engine", ff = "gcp_cloud_functions", _f = "gcp_app_engine", MR = qp, PR = Qp, IR = Jp, DR = $p, UR = tf, kR = ef, xR = nf, VR = rf, BR = of, GR = af, HR = sf, jR = uf, FR = cf, YR = lf, zR = pf, ZR = ff, XR = _f, WR = vt([qp, Qp, Jp, $p, tf, ef, nf, rf, of, af, sf, uf, cf, lf, pf, ff, _f]), hf = "fargate", KR = "ec2", qR = hf, QR = vt(["ec2", hf]), Ef = "amd64", df = "arm32", Tf = "arm64", Sf = "ia64", yf = "ppc32", vf = "ppc64", JR = Ef, $R = df, tb = Tf, eb = Sf, nb = yf, rb = vf, ob = "x86", ib = vt([Ef, df, Tf, Sf, yf, vf, "x86"]), mf = "windows", gf = "linux", Af = "darwin", Of = "freebsd", Rf = "netbsd", bf = "openbsd", Nf = "dragonflybsd", Lf = "hpux", Cf = "solaris", wf = "z_os", ab = mf, sb = gf, ub = Af, cb = Of, lb = Rf, pb = bf, fb = Nf, _b = Lf, hb = "aix", Eb = Cf, db = wf, Tb = vt([mf, gf, Af, Of, Rf, bf, Nf, Lf, "aix", Cf, wf]), Mf = "dotnet", Pf = "erlang", If = "java", Df = "nodejs", Uf = "python", kf = "ruby", xf = "webjs", Sb = "cpp", yb = Mf, vb = Pf, mb = "go", gb = If, Ab = Df, Ob = "php", Rb = Uf, bb = kf, Nb = xf, Lb = vt(["cpp", Mf, Pf, "go", If, Df, "php", Uf, kf, xf]), Cb = "aspnetcore.diagnostics.exception.result", wb = "aborted", Mb = "handled", Pb = "skipped", Ib = "unhandled", Db = "aspnetcore.diagnostics.handler.type", Ub = "aspnetcore.rate_limiting.policy", kb = "aspnetcore.rate_limiting.result", xb = "acquired", Vb = "endpoint_limiter", Bb = "global_limiter", Gb = "request_canceled", Hb = "aspnetcore.request.is_unhandled", jb = "aspnetcore.routing.is_fallback", Fb = "aspnetcore.routing.match_status", Yb = "failure", zb = "success", Zb = "client.address", Xb = "client.port", Wb = "dotnet.gc.heap.generation", Kb = "gen0", qb = "gen1", Qb = "gen2", Jb = "loh", $b = "poh", t0 = "error.type", e0 = "_OTHER", n0 = "exception.escaped", r0 = "exception.message", o0 = "exception.stacktrace", i0 = "exception.type", a0 = function(e) {
  return "http.request.header.".concat(e);
}, s0 = "http.request.method", u0 = "_OTHER", c0 = "CONNECT", l0 = "DELETE", p0 = "GET", f0 = "HEAD", _0 = "OPTIONS", h0 = "PATCH", E0 = "POST", d0 = "PUT", T0 = "TRACE", S0 = "http.request.method_original", y0 = "http.request.resend_count", v0 = function(e) {
  return "http.response.header.".concat(e);
}, m0 = "http.response.status_code", g0 = "http.route", A0 = "jvm.gc.action", O0 = "jvm.gc.name", R0 = "jvm.memory.pool.name", b0 = "jvm.memory.type", N0 = "heap", L0 = "non_heap", C0 = "jvm.thread.daemon", w0 = "jvm.thread.state", M0 = "blocked", P0 = "new", I0 = "runnable", D0 = "terminated", U0 = "timed_waiting", k0 = "waiting", x0 = "network.local.address", V0 = "network.local.port", B0 = "network.peer.address", G0 = "network.peer.port", H0 = "network.protocol.name", j0 = "network.protocol.version", F0 = "network.transport", Y0 = "pipe", z0 = "quic", Z0 = "tcp", X0 = "udp", W0 = "unix", K0 = "network.type", q0 = "ipv4", Q0 = "ipv6", J0 = "otel.scope.name", $0 = "otel.scope.version", tN = "otel.status_code", eN = "ERROR", nN = "OK", rN = "otel.status_description", oN = "server.address", iN = "server.port", aN = "service.name", sN = "service.version", uN = "signalr.connection.status", cN = "app_shutdown", lN = "normal_closure", pN = "timeout", fN = "signalr.transport", _N = "long_polling", hN = "server_sent_events", EN = "web_sockets", dN = "telemetry.sdk.language", TN = "cpp", SN = "dotnet", yN = "erlang", vN = "go", mN = "java", gN = "nodejs", AN = "php", ON = "python", RN = "ruby", bN = "rust", NN = "swift", LN = "webjs", CN = "telemetry.sdk.name", wN = "telemetry.sdk.version", MN = "url.fragment", PN = "url.full", IN = "url.path", DN = "url.query", UN = "url.scheme", kN = "user_agent.original", xN = "aspnetcore.diagnostics.exceptions", VN = "aspnetcore.rate_limiting.active_request_leases", BN = "aspnetcore.rate_limiting.queued_requests", GN = "aspnetcore.rate_limiting.request.time_in_queue", HN = "aspnetcore.rate_limiting.request_lease.duration", jN = "aspnetcore.rate_limiting.requests", FN = "aspnetcore.routing.match_attempts", YN = "dotnet.assembly.count", zN = "dotnet.exceptions", ZN = "dotnet.gc.collections", XN = "dotnet.gc.heap.total_allocated", WN = "dotnet.gc.last_collection.heap.fragmentation.size", KN = "dotnet.gc.last_collection.heap.size", qN = "dotnet.gc.last_collection.memory.committed_size", QN = "dotnet.gc.pause.time", JN = "dotnet.jit.compilation.time", $N = "dotnet.jit.compiled_il.size", tL = "dotnet.jit.compiled_methods", eL = "dotnet.monitor.lock_contentions", nL = "dotnet.process.cpu.count", rL = "dotnet.process.cpu.time", oL = "dotnet.process.memory.working_set", iL = "dotnet.thread_pool.queue.length", aL = "dotnet.thread_pool.thread.count", sL = "dotnet.thread_pool.work_item.count", uL = "dotnet.timer.count", cL = "http.client.request.duration", lL = "http.server.request.duration", pL = "jvm.class.count", fL = "jvm.class.loaded", _L = "jvm.class.unloaded", hL = "jvm.cpu.count", EL = "jvm.cpu.recent_utilization", dL = "jvm.cpu.time", TL = "jvm.gc.duration", SL = "jvm.memory.committed", yL = "jvm.memory.limit", vL = "jvm.memory.used", mL = "jvm.memory.used_after_last_gc", gL = "jvm.thread.count", AL = "kestrel.active_connections", OL = "kestrel.active_tls_handshakes", RL = "kestrel.connection.duration", bL = "kestrel.queued_connections", NL = "kestrel.queued_requests", LL = "kestrel.rejected_connections", CL = "kestrel.tls_handshake.duration", wL = "kestrel.upgraded_connections", ML = "signalr.server.active_connections", PL = "signalr.server.connection.duration";
(function(e) {
  e.FIRST_PAINT = "firstPaint", e.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(Nn || (Nn = {}));
var Ln, Ho = { "first-paint": Nn.FIRST_PAINT, "first-contentful-paint": Nn.FIRST_CONTENTFUL_PAINT }, qE = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), QE = function(e) {
  function t(n) {
    n === void 0 && (n = {});
    var r = e.call(this, "@opentelemetry/instrumentation-document-load", "0.44.1", n) || this;
    return r.component = "document-load", r.version = "1", r.moduleName = r.component, r;
  }
  return qE(t, e), t.prototype.init = function() {
  }, t.prototype._onDocumentLoaded = function() {
    var n = this;
    window.setTimeout(function() {
      n._collectPerformance();
    });
  }, t.prototype._addResourcesSpans = function(n) {
    var r, o, i = this, a = (o = (r = It).getEntriesByType) === null || o === void 0 ? void 0 : o.call(r, "resource");
    a && a.forEach(function(u) {
      i._initResourceSpan(u, n);
    });
  }, t.prototype._collectPerformance = function() {
    var n = this, r = Array.from(document.getElementsByTagName("meta")).find(function(a) {
      return a.getAttribute("name") === yn;
    }), o = function() {
      var a, u, c = {}, l = (u = (a = It).getEntriesByType) === null || u === void 0 ? void 0 : u.call(a, "navigation")[0];
      if (l) Object.values(Z).forEach(function(p) {
        if (oe(l, p)) {
          var v = l[p];
          typeof v == "number" && (c[p] = v);
        }
      });
      else {
        var s = It.timing;
        s && Object.values(Z).forEach(function(p) {
          if (oe(s, p)) {
            var v = s[p];
            typeof v == "number" && (c[p] = v);
          }
        });
      }
      return c;
    }(), i = r && r.content || "";
    $.with(Pt.extract(Zt, { traceparent: i }), function() {
      var a, u = n._startSpan(je.DOCUMENT_LOAD, Z.FETCH_START, o);
      u && ($.with(dt.setSpan($.active(), u), function() {
        var c = n._startSpan(je.DOCUMENT_FETCH, Z.FETCH_START, o);
        c && (c.setAttribute(cr, location.href), $.with(dt.setSpan($.active(), c), function() {
          var l;
          n.getConfig().ignoreNetworkEvents || Ce(c, o), n._addCustomAttributesOnSpan(c, (l = n.getConfig().applyCustomAttributesOnSpan) === null || l === void 0 ? void 0 : l.documentFetch), n._endSpan(c, Z.RESPONSE_END, o);
        }));
      }), u.setAttribute(cr, location.href), u.setAttribute(KE, navigator.userAgent), n._addResourcesSpans(u), n.getConfig().ignoreNetworkEvents || (gt(u, Z.FETCH_START, o), gt(u, Z.UNLOAD_EVENT_START, o), gt(u, Z.UNLOAD_EVENT_END, o), gt(u, Z.DOM_INTERACTIVE, o), gt(u, Z.DOM_CONTENT_LOADED_EVENT_START, o), gt(u, Z.DOM_CONTENT_LOADED_EVENT_END, o), gt(u, Z.DOM_COMPLETE, o), gt(u, Z.LOAD_EVENT_START, o), gt(u, Z.LOAD_EVENT_END, o)), n.getConfig().ignorePerformancePaintEvents || function(c) {
        var l, s, p = (s = (l = It).getEntriesByType) === null || s === void 0 ? void 0 : s.call(l, "paint");
        p && p.forEach(function(v) {
          var g = v.name, b = v.startTime;
          oe(Ho, g) && c.addEvent(Ho[g], b);
        });
      }(u), n._addCustomAttributesOnSpan(u, (a = n.getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), n._endSpan(u, Z.LOAD_EVENT_END, o));
    });
  }, t.prototype._endSpan = function(n, r, o) {
    n && (oe(o, r) ? n.end(o[r]) : n.end());
  }, t.prototype._initResourceSpan = function(n, r) {
    var o, i = this._startSpan(je.RESOURCE_FETCH, Z.FETCH_START, n, r);
    i && (i.setAttribute(cr, n.name), this.getConfig().ignoreNetworkEvents || Ce(i, n), this._addCustomAttributesOnResourceSpan(i, n, (o = this.getConfig().applyCustomAttributesOnSpan) === null || o === void 0 ? void 0 : o.resourceFetch), this._endSpan(i, Z.RESPONSE_END, n));
  }, t.prototype._startSpan = function(n, r, o, i) {
    if (oe(o, r) && typeof o[r] == "number") return this.tracer.startSpan(n, { startTime: o[r] }, i ? dt.setSpan($.active(), i) : void 0);
  }, t.prototype._waitForPageLoad = function() {
    window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
  }, t.prototype._addCustomAttributesOnSpan = function(n, r) {
    var o = this;
    r && bn(function() {
      return r(n);
    }, function(i) {
      i && o._diag.error("addCustomAttributesOnSpan", i);
    }, !0);
  }, t.prototype._addCustomAttributesOnResourceSpan = function(n, r, o) {
    var i = this;
    o && bn(function() {
      return o(n, r);
    }, function(a) {
      a && i._diag.error("addCustomAttributesOnResourceSpan", a);
    }, !0);
  }, t.prototype.enable = function() {
    window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
  }, t.prototype.disable = function() {
    window.removeEventListener("load", this._onDocumentLoaded);
  }, t;
}(xn);
(function(e) {
  e.COMPONENT = "component", e.HTTP_ERROR_NAME = "http.error_name", e.HTTP_STATUS_TEXT = "http.status_text";
})(Ln || (Ln = {}));
var JE = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, $E = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, td = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ed = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, jo = w.createComponentLogger({ namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils" });
function nd() {
  for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
  if (e[0] instanceof URL || typeof e[0] == "string") {
    var n = e[1];
    if (!n?.body) return Promise.resolve();
    if (n.body instanceof ReadableStream) {
      var r = function(u) {
        if (!u.pipeThrough) return jo.warn("Platform has ReadableStream but not pipeThrough!"), { body: u, length: Promise.resolve(void 0) };
        var c, l = 0, s = new Promise(function(v) {
          c = v;
        }), p = new TransformStream({ start: function() {
        }, transform: function(v, g) {
          return JE(this, void 0, void 0, function() {
            var b;
            return $E(this, function(H) {
              switch (H.label) {
                case 0:
                  return [4, v];
                case 1:
                  return b = H.sent(), l += b.byteLength, g.enqueue(v), [2];
              }
            });
          });
        }, flush: function() {
          c(l);
        } });
        return { body: u.pipeThrough(p), length: s };
      }(n.body), o = r.body, i = r.length;
      return n.body = o, i;
    }
    return Promise.resolve(function(u) {
      return typeof Document < "u" && u instanceof Document ? new XMLSerializer().serializeToString(document).length : u instanceof Blob ? u.size : u.byteLength !== void 0 ? u.byteLength : u instanceof FormData ? function(c) {
        var l, s, p = 0;
        try {
          for (var v = td(c.entries()), g = v.next(); !g.done; g = v.next()) {
            var b = ed(g.value, 2), H = b[0], P = b[1];
            p += H.length, P instanceof Blob ? p += P.size : p += P.length;
          }
        } catch (N) {
          l = { error: N };
        } finally {
          try {
            g && !g.done && (s = v.return) && s.call(v);
          } finally {
            if (l) throw l.error;
          }
        }
        return p;
      }(u) : u instanceof URLSearchParams ? lr(u.toString()) : typeof u == "string" ? lr(u) : void jo.warn("unknown body type");
    }(n.body));
  }
  var a = e[0];
  return a?.body ? a.clone().text().then(function(u) {
    return lr(u);
  }) : Promise.resolve();
}
var rd = new TextEncoder();
function lr(e) {
  return rd.encode(e).byteLength;
}
var pr, Re, Fo = "0.57.2", od = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), id = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, ad = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}, Yo = typeof process == "object" && ((pr = process.release) === null || pr === void 0 ? void 0 : pr.name) === "node", sd = function(e) {
  function t(n) {
    n === void 0 && (n = {});
    var r = e.call(this, "@opentelemetry/instrumentation-fetch", Fo, n) || this;
    return r.component = "fetch", r.version = Fo, r.moduleName = r.component, r._usedResources = /* @__PURE__ */ new WeakSet(), r._tasksCount = 0, r;
  }
  return od(t, e), t.prototype.init = function() {
  }, t.prototype._addChildSpan = function(n, r) {
    var o = this.tracer.startSpan("CORS Preflight", { startTime: r[Z.FETCH_START] }, dt.setSpan($.active(), n));
    Ce(o, r, this.getConfig().ignoreNetworkEvents), o.end(r[Z.RESPONSE_END]);
  }, t.prototype._addFinalSpanAttributes = function(n, r) {
    var o = te(r.url);
    n.setAttribute("http.status_code", r.status), r.statusText != null && n.setAttribute(Ln.HTTP_STATUS_TEXT, r.statusText), n.setAttribute("http.host", o.host), n.setAttribute("http.scheme", o.protocol.replace(":", "")), typeof navigator < "u" && n.setAttribute("http.user_agent", navigator.userAgent);
  }, t.prototype._addHeaders = function(n, r) {
    if (!sa(r, this.getConfig().propagateTraceHeaderCorsUrls)) {
      var o = {};
      return Pt.inject($.active(), o), void (Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy"));
    }
    n instanceof Request ? Pt.inject($.active(), n.headers, { set: function(i, a, u) {
      return i.set(a, typeof u == "string" ? u : String(u));
    } }) : n.headers instanceof Headers ? Pt.inject($.active(), n.headers, { set: function(i, a, u) {
      return i.set(a, typeof u == "string" ? u : String(u));
    } }) : n.headers instanceof Map ? Pt.inject($.active(), n.headers, { set: function(i, a, u) {
      return i.set(a, typeof u == "string" ? u : String(u));
    } }) : (o = {}, Pt.inject($.active(), o), n.headers = Object.assign({}, o, n.headers || {}));
  }, t.prototype._clearResources = function() {
    this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
  }, t.prototype._createSpan = function(n, r) {
    var o;
    if (r === void 0 && (r = {}), !Qi(n, this.getConfig().ignoreUrls)) {
      var i = (r.method || "GET").toUpperCase(), a = "HTTP " + i;
      return this.tracer.startSpan(a, { kind: Ze.CLIENT, attributes: (o = {}, o[Ln.COMPONENT] = this.moduleName, o["http.method"] = i, o["http.url"] = n, o) });
    }
    this._diag.debug("ignoring span as url matches ignored url");
  }, t.prototype._findResourceAndAddNetworkEvents = function(n, r, o) {
    var i = r.entries;
    if (!i.length) {
      if (!performance.getEntriesByType) return;
      i = performance.getEntriesByType("resource");
    }
    var a = ia(r.spanUrl, r.startTime, o, i, this._usedResources, "fetch");
    if (a.mainRequest) {
      var u = a.mainRequest;
      this._markResourceAsUsed(u);
      var c = a.corsPreFlightRequest;
      c && (this._addChildSpan(n, c), this._markResourceAsUsed(c)), Ce(n, u, this.getConfig().ignoreNetworkEvents);
    }
  }, t.prototype._markResourceAsUsed = function(n) {
    this._usedResources.add(n);
  }, t.prototype._endSpan = function(n, r, o) {
    var i = this, a = Dt(Date.now()), u = Ee();
    this._addFinalSpanAttributes(n, o), setTimeout(function() {
      var c;
      (c = r.observer) === null || c === void 0 || c.disconnect(), i._findResourceAndAddNetworkEvents(n, r, u), i._tasksCount--, i._clearResources(), n.end(a);
    }, 300);
  }, t.prototype._patchConstructor = function() {
    var n = this;
    return function(r) {
      var o = n;
      return function() {
        for (var i = [], a = 0; a < arguments.length; a++) i[a] = arguments[a];
        var u = this, c = te(i[0] instanceof Request ? i[0].url : String(i[0])).href, l = i[0] instanceof Request ? i[0] : i[1] || {}, s = o._createSpan(c, l);
        if (!s) return r.apply(this, i);
        var p = o._prepareSpanData(c);
        function v(P, N) {
          o._applyAttributesAfterFetch(P, l, N), o._endSpan(P, p, { status: N.status || 0, statusText: N.message, url: c });
        }
        function g(P, N) {
          o._applyAttributesAfterFetch(P, l, N), N.status >= 200 && N.status < 400 ? o._endSpan(P, p, N) : o._endSpan(P, p, { status: N.status, statusText: N.statusText, url: c });
        }
        function b(P, N, J) {
          try {
            var ct = J.clone(), X = J.clone(), lt = ct.body;
            if (lt) {
              var xt = lt.getReader(), Rt = function() {
                xt.read().then(function(jt) {
                  jt.done ? g(P, X) : Rt();
                }, function(jt) {
                  v(P, jt);
                });
              };
              Rt();
            } else g(P, J);
          } finally {
            N(J);
          }
        }
        function H(P, N, J) {
          try {
            v(P, J);
          } finally {
            N(J);
          }
        }
        return o.getConfig().measureRequestSize && nd.apply(void 0, ad([], id(i), !1)).then(function(P) {
          P && s.setAttribute("http.request_content_length_uncompressed", P);
        }).catch(function(P) {
          o._diag.warn("getFetchBodyLength", P);
        }), new Promise(function(P, N) {
          return $.with(dt.setSpan($.active(), s), function() {
            return o._addHeaders(l, c), o._tasksCount++, r.apply(u, l instanceof Request ? [l] : [c, l]).then(b.bind(u, s, P), H.bind(u, s, N));
          });
        });
      };
    };
  }, t.prototype._applyAttributesAfterFetch = function(n, r, o) {
    var i = this, a = this.getConfig().applyCustomAttributesOnSpan;
    a && bn(function() {
      return a(n, r, o);
    }, function(u) {
      u && i._diag.error("applyCustomAttributesOnSpan", u);
    }, !0);
  }, t.prototype._prepareSpanData = function(n) {
    var r = Ee(), o = [];
    if (typeof PerformanceObserver != "function") return { entries: o, startTime: r, spanUrl: n };
    var i = new PerformanceObserver(function(a) {
      a.getEntries().forEach(function(u) {
        u.initiatorType === "fetch" && u.name === n && o.push(u);
      });
    });
    return i.observe({ entryTypes: ["resource"] }), { entries: o, observer: i, startTime: r, spanUrl: n };
  }, t.prototype.enable = function() {
    Yo ? this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()") : (mt(fetch) && (this._unwrap(He, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(He, "fetch", this._patchConstructor()));
  }, t.prototype.disable = function() {
    Yo || (this._unwrap(He, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
  }, t;
}(xn);
(function(e) {
  e.EVENT_TYPE = "event_type", e.TARGET_ELEMENT = "target_element", e.TARGET_XPATH = "target_xpath", e.HTTP_URL = "http.url";
})(Re || (Re = {}));
var zo = "0.44.1", ud = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), cd = ["click"];
function ld() {
  return !1;
}
var $t, pd = function(e) {
  function t(n) {
    var r;
    n === void 0 && (n = {});
    var o = e.call(this, "@opentelemetry/instrumentation-user-interaction", zo, n) || this;
    return o.version = zo, o.moduleName = "user-interaction", o._spansData = /* @__PURE__ */ new WeakMap(), o._wrappedListeners = /* @__PURE__ */ new WeakMap(), o._eventsSpanMap = /* @__PURE__ */ new WeakMap(), o._eventNames = new Set((r = n?.eventNames) !== null && r !== void 0 ? r : cd), o._shouldPreventSpanCreation = typeof n?.shouldPreventSpanCreation == "function" ? n.shouldPreventSpanCreation : ld, o;
  }
  return ud(t, e), t.prototype.init = function() {
  }, t.prototype._checkForTimeout = function(n, r) {
    var o = this._spansData.get(r);
    o && (n.source === "setTimeout" ? o.hrTimeLastTimeout = Ee() : n.source !== "Promise.then" && n.source !== "setTimeout" && (o.hrTimeLastTimeout = void 0));
  }, t.prototype._allowEventName = function(n) {
    return this._eventNames.has(n);
  }, t.prototype._createSpan = function(n, r, o) {
    var i;
    if (n instanceof HTMLElement && n.getAttribute && !n.hasAttribute("disabled") && this._allowEventName(r)) {
      var a = aa(n, !0);
      try {
        var u = this.tracer.startSpan(r, { attributes: (i = {}, i[Re.EVENT_TYPE] = r, i[Re.TARGET_ELEMENT] = n.tagName, i[Re.TARGET_XPATH] = a, i[Re.HTTP_URL] = window.location.href, i) }, o ? dt.setSpan($.active(), o) : void 0);
        return this._shouldPreventSpanCreation(r, n, u) === !0 ? void 0 : (this._spansData.set(u, { taskCount: 0 }), u);
      } catch (c) {
        this._diag.error("failed to start create new user interaction span", c);
      }
    }
  }, t.prototype._decrementTask = function(n) {
    var r = this._spansData.get(n);
    r && (r.taskCount--, r.taskCount === 0 && this._tryToEndSpan(n, r.hrTimeLastTimeout));
  }, t.prototype._getCurrentSpan = function(n) {
    var r = n.get("OT_ZONE_CONTEXT");
    return r && dt.getSpan(r);
  }, t.prototype._incrementTask = function(n) {
    var r = this._spansData.get(n);
    r && r.taskCount++;
  }, t.prototype.addPatchedListener = function(n, r, o, i) {
    var a = this._wrappedListeners.get(o);
    a || (a = /* @__PURE__ */ new Map(), this._wrappedListeners.set(o, a));
    var u = a.get(r);
    return u || (u = /* @__PURE__ */ new Map(), a.set(r, u)), !u.has(n) && (u.set(n, i), !0);
  }, t.prototype.removePatchedListener = function(n, r, o) {
    var i = this._wrappedListeners.get(o);
    if (i) {
      var a = i.get(r);
      if (a) {
        var u = a.get(n);
        return u && (a.delete(n), a.size === 0 && (i.delete(r), i.size === 0 && this._wrappedListeners.delete(o))), u;
      }
    }
  }, t.prototype._invokeListener = function(n, r, o) {
    return typeof n == "function" ? n.apply(r, o) : n.handleEvent(o[0]);
  }, t.prototype._patchAddEventListener = function() {
    var n = this;
    return function(r) {
      return function(o, i, a) {
        if (!i) return r.call(this, o, i, a);
        var u = a && typeof a == "object" && a.once, c = function() {
          for (var l, s = this, p = [], v = 0; v < arguments.length; v++) p[v] = arguments[v];
          var g = p[0], b = g?.target;
          g && (l = n._eventsSpanMap.get(g)), u && n.removePatchedListener(this, o, i);
          var H = n._createSpan(b, o, l);
          return H ? (g && n._eventsSpanMap.set(g, H), $.with(dt.setSpan($.active(), H), function() {
            var P = n._invokeListener(i, s, p);
            return H.end(), P;
          })) : n._invokeListener(i, this, p);
        };
        return n.addPatchedListener(this, o, i, c) ? r.call(this, o, c, a) : void 0;
      };
    };
  }, t.prototype._patchRemoveEventListener = function() {
    var n = this;
    return function(r) {
      return function(o, i, a) {
        var u = n.removePatchedListener(this, o, i);
        return u ? r.call(this, o, u, a) : r.call(this, o, i, a);
      };
    };
  }, t.prototype._getPatchableEventTargets = function() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }, t.prototype._patchHistoryApi = function() {
    this._unpatchHistoryApi(), this._wrap(history, "replaceState", this._patchHistoryMethod()), this._wrap(history, "pushState", this._patchHistoryMethod()), this._wrap(history, "back", this._patchHistoryMethod()), this._wrap(history, "forward", this._patchHistoryMethod()), this._wrap(history, "go", this._patchHistoryMethod());
  }, t.prototype._patchHistoryMethod = function() {
    var n = this;
    return function(r) {
      return function() {
        for (var o = [], i = 0; i < arguments.length; i++) o[i] = arguments[i];
        var a = "" + location.pathname + location.hash + location.search, u = r.apply(this, o), c = "" + location.pathname + location.hash + location.search;
        return a !== c && n._updateInteractionName(c), u;
      };
    };
  }, t.prototype._unpatchHistoryApi = function() {
    mt(history.replaceState) && this._unwrap(history, "replaceState"), mt(history.pushState) && this._unwrap(history, "pushState"), mt(history.back) && this._unwrap(history, "back"), mt(history.forward) && this._unwrap(history, "forward"), mt(history.go) && this._unwrap(history, "go");
  }, t.prototype._updateInteractionName = function(n) {
    var r = dt.getSpan($.active());
    r && typeof r.updateName == "function" && r.updateName("Navigation: " + n);
  }, t.prototype._patchZoneCancelTask = function() {
    var n = this;
    return function(r) {
      return function(o) {
        var i = Zone.current, a = n._getCurrentSpan(i);
        return a && n._shouldCountTask(o, i) && n._decrementTask(a), r.call(this, o);
      };
    };
  }, t.prototype._patchZoneScheduleTask = function() {
    var n = this;
    return function(r) {
      return function(o) {
        var i = Zone.current, a = n._getCurrentSpan(i);
        return a && n._shouldCountTask(o, i) && (n._incrementTask(a), n._checkForTimeout(o, a)), r.call(this, o);
      };
    };
  }, t.prototype._patchZoneRunTask = function() {
    var n = this;
    return function(r) {
      return function(o, i, a) {
        var u, c = Array.isArray(a) && a[0] instanceof Event ? a[0] : void 0, l = c?.target, s = this;
        if (l) {
          if (u = n._createSpan(l, o.eventName)) return n._incrementTask(u), s.run(function() {
            try {
              return $.with(dt.setSpan($.active(), u), function() {
                var p = Zone.current;
                return o._zone = p, r.call(p, o, i, a);
              });
            } finally {
              n._decrementTask(u);
            }
          });
        } else u = n._getCurrentSpan(s);
        try {
          return r.call(s, o, i, a);
        } finally {
          u && n._shouldCountTask(o, s) && n._decrementTask(u);
        }
      };
    };
  }, t.prototype._shouldCountTask = function(n, r) {
    if (n._zone && (r = n._zone), !r || !n.data || n.data.isPeriodic) return !1;
    var o = this._getCurrentSpan(r);
    return !!o && !!this._spansData.get(o) && (n.type === "macroTask" || n.type === "microTask");
  }, t.prototype._tryToEndSpan = function(n, r) {
    n && this._spansData.get(n) && (n.end(r), this._spansData.delete(n));
  }, t.prototype.enable = function() {
    var n = this, r = this._getZoneWithPrototype();
    this._diag.debug("applying patch to", this.moduleName, this.version, "zone:", !!r), r ? (mt(r.prototype.runTask) && (this._unwrap(r.prototype, "runTask"), this._diag.debug("removing previous patch from method runTask")), mt(r.prototype.scheduleTask) && (this._unwrap(r.prototype, "scheduleTask"), this._diag.debug("removing previous patch from method scheduleTask")), mt(r.prototype.cancelTask) && (this._unwrap(r.prototype, "cancelTask"), this._diag.debug("removing previous patch from method cancelTask")), this._zonePatched = !0, this._wrap(r.prototype, "runTask", this._patchZoneRunTask()), this._wrap(r.prototype, "scheduleTask", this._patchZoneScheduleTask()), this._wrap(r.prototype, "cancelTask", this._patchZoneCancelTask())) : (this._zonePatched = !1, this._getPatchableEventTargets().forEach(function(o) {
      mt(o.addEventListener) && (n._unwrap(o, "addEventListener"), n._diag.debug("removing previous patch from method addEventListener")), mt(o.removeEventListener) && (n._unwrap(o, "removeEventListener"), n._diag.debug("removing previous patch from method removeEventListener")), n._wrap(o, "addEventListener", n._patchAddEventListener()), n._wrap(o, "removeEventListener", n._patchRemoveEventListener());
    })), this._patchHistoryApi();
  }, t.prototype.disable = function() {
    var n = this, r = this._getZoneWithPrototype();
    this._diag.debug("removing patch from", this.moduleName, this.version, "zone:", !!r), r && this._zonePatched ? (mt(r.prototype.runTask) && this._unwrap(r.prototype, "runTask"), mt(r.prototype.scheduleTask) && this._unwrap(r.prototype, "scheduleTask"), mt(r.prototype.cancelTask) && this._unwrap(r.prototype, "cancelTask")) : this._getPatchableEventTargets().forEach(function(o) {
      mt(o.addEventListener) && n._unwrap(o, "addEventListener"), mt(o.removeEventListener) && n._unwrap(o, "removeEventListener");
    }), this._unpatchHistoryApi();
  }, t.prototype._getZoneWithPrototype = function() {
    return window.Zone;
  }, t;
}(xn);
(function(e) {
  e.METHOD_OPEN = "open", e.METHOD_SEND = "send", e.EVENT_ABORT = "abort", e.EVENT_ERROR = "error", e.EVENT_LOAD = "loaded", e.EVENT_TIMEOUT = "timeout";
})($t || ($t = {}));
var fd = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, _d = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, hd = w.createComponentLogger({ namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils" });
function Ed(e) {
  return typeof Document < "u" && e instanceof Document ? new XMLSerializer().serializeToString(document).length : e instanceof Blob ? e.size : e.byteLength !== void 0 ? e.byteLength : e instanceof FormData ? function(t) {
    var n, r, o = 0;
    try {
      for (var i = fd(t.entries()), a = i.next(); !a.done; a = i.next()) {
        var u = _d(a.value, 2), c = u[0], l = u[1];
        o += c.length, l instanceof Blob ? o += l.size : o += l.length;
      }
    } catch (s) {
      n = { error: s };
    } finally {
      try {
        a && !a.done && (r = i.return) && r.call(i);
      } finally {
        if (n) throw n.error;
      }
    }
    return o;
  }(e) : e instanceof URLSearchParams ? Zo(e.toString()) : typeof e == "string" ? Zo(e) : void hd.warn("unknown body type");
}
var dd = new TextEncoder();
function Zo(e) {
  return dd.encode(e).byteLength;
}
var Pr, Xo = "0.57.2";
(function(e) {
  e.HTTP_STATUS_TEXT = "http.status_text";
})(Pr || (Pr = {}));
var Td = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Sd = function(e) {
  function t(n) {
    n === void 0 && (n = {});
    var r = e.call(this, "@opentelemetry/instrumentation-xml-http-request", Xo, n) || this;
    return r.component = "xml-http-request", r.version = Xo, r.moduleName = r.component, r._tasksCount = 0, r._xhrMem = /* @__PURE__ */ new WeakMap(), r._usedResources = /* @__PURE__ */ new WeakSet(), r;
  }
  return Td(t, e), t.prototype.init = function() {
  }, t.prototype._addHeaders = function(n, r) {
    if (!sa(te(r).href, this.getConfig().propagateTraceHeaderCorsUrls)) {
      var o = {};
      return Pt.inject($.active(), o), void (Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy"));
    }
    var i = {};
    Pt.inject($.active(), i), Object.keys(i).forEach(function(a) {
      n.setRequestHeader(a, String(i[a]));
    });
  }, t.prototype._addChildSpan = function(n, r) {
    var o = this;
    $.with(dt.setSpan($.active(), n), function() {
      var i = o.tracer.startSpan("CORS Preflight", { startTime: r[Z.FETCH_START] });
      Ce(i, r, o.getConfig().ignoreNetworkEvents), i.end(r[Z.RESPONSE_END]);
    });
  }, t.prototype._addFinalSpanAttributes = function(n, r, o) {
    if (typeof o == "string") {
      var i = te(o);
      r.status !== void 0 && n.setAttribute("http.status_code", r.status), r.statusText !== void 0 && n.setAttribute(Pr.HTTP_STATUS_TEXT, r.statusText), n.setAttribute("http.host", i.host), n.setAttribute("http.scheme", i.protocol.replace(":", "")), n.setAttribute("http.user_agent", navigator.userAgent);
    }
  }, t.prototype._applyAttributesAfterXHR = function(n, r) {
    var o = this, i = this.getConfig().applyCustomAttributesOnSpan;
    typeof i == "function" && bn(function() {
      return i(n, r);
    }, function(a) {
      a && o._diag.error("applyCustomAttributesOnSpan", a);
    }, !0);
  }, t.prototype._addResourceObserver = function(n, r) {
    var o = this._xhrMem.get(n);
    o && typeof PerformanceObserver == "function" && typeof PerformanceResourceTiming == "function" && (o.createdResources = { observer: new PerformanceObserver(function(i) {
      var a = i.getEntries(), u = te(r);
      a.forEach(function(c) {
        c.initiatorType === "xmlhttprequest" && c.name === u.href && o.createdResources && o.createdResources.entries.push(c);
      });
    }), entries: [] }, o.createdResources.observer.observe({ entryTypes: ["resource"] }));
  }, t.prototype._clearResources = function() {
    this._tasksCount === 0 && this.getConfig().clearTimingResources && (It.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
  }, t.prototype._findResourceAndAddNetworkEvents = function(n, r, o, i, a) {
    if (o && i && a && n.createdResources) {
      var u = n.createdResources.entries;
      u && u.length || (u = It.getEntriesByType("resource"));
      var c = ia(te(o).href, i, a, u, this._usedResources);
      if (c.mainRequest) {
        var l = c.mainRequest;
        this._markResourceAsUsed(l);
        var s = c.corsPreFlightRequest;
        s && (this._addChildSpan(r, s), this._markResourceAsUsed(s)), Ce(r, l, this.getConfig().ignoreNetworkEvents);
      }
    }
  }, t.prototype._cleanPreviousSpanInformation = function(n) {
    var r = this._xhrMem.get(n);
    if (r) {
      var o = r.callbackToRemoveEvents;
      o && o(), this._xhrMem.delete(n);
    }
  }, t.prototype._createSpan = function(n, r, o) {
    var i;
    if (!Qi(r, this.getConfig().ignoreUrls)) {
      var a = o.toUpperCase(), u = this.tracer.startSpan(a, { kind: Ze.CLIENT, attributes: (i = {}, i["http.method"] = o, i["http.url"] = te(r).toString(), i) });
      return u.addEvent($t.METHOD_OPEN), this._cleanPreviousSpanInformation(n), this._xhrMem.set(n, { span: u, spanUrl: r }), u;
    }
    this._diag.debug("ignoring span as url matches ignored url");
  }, t.prototype._markResourceAsUsed = function(n) {
    this._usedResources.add(n);
  }, t.prototype._patchOpen = function() {
    var n = this;
    return function(r) {
      var o = n;
      return function() {
        for (var i = [], a = 0; a < arguments.length; a++) i[a] = arguments[a];
        var u = i[0], c = i[1];
        return o._createSpan(this, c, u), r.apply(this, i);
      };
    };
  }, t.prototype._patchSend = function() {
    var n = this;
    function r(c, l) {
      var s = n._xhrMem.get(l);
      if (s) {
        s.status = l.status, s.statusText = l.statusText, n._xhrMem.delete(l), s.span && n._applyAttributesAfterXHR(s.span, l);
        var p = Ee(), v = Date.now();
        setTimeout(function() {
          (function(g, b, H, P) {
            var N = b.callbackToRemoveEvents;
            typeof N == "function" && N();
            var J = b.span, ct = b.spanUrl, X = b.sendStartTime;
            J && (n._findResourceAndAddNetworkEvents(b, J, ct, X, H), J.addEvent(g, P), n._addFinalSpanAttributes(J, b, ct), J.end(P), n._tasksCount--), n._clearResources();
          })(c, s, p, v);
        }, 300);
      }
    }
    function o() {
      r($t.EVENT_ERROR, this);
    }
    function i() {
      r($t.EVENT_ABORT, this);
    }
    function a() {
      r($t.EVENT_TIMEOUT, this);
    }
    function u() {
      this.status < 299 ? r($t.EVENT_LOAD, this) : r($t.EVENT_ERROR, this);
    }
    return function(c) {
      return function() {
        for (var l = this, s = [], p = 0; p < arguments.length; p++) s[p] = arguments[p];
        var v = n._xhrMem.get(this);
        if (!v) return c.apply(this, s);
        var g = v.span, b = v.spanUrl;
        if (g && b) {
          if (n.getConfig().measureRequestSize && s?.[0]) {
            var H = Ed(s[0]);
            H !== void 0 && g.setAttribute("http.request_content_length_uncompressed", H);
          }
          $.with(dt.setSpan($.active(), g), function() {
            n._tasksCount++, v.sendStartTime = Ee(), g.addEvent($t.METHOD_SEND), l.addEventListener("abort", i), l.addEventListener("error", o), l.addEventListener("load", u), l.addEventListener("timeout", a), v.callbackToRemoveEvents = function() {
              (function(P) {
                P.removeEventListener("abort", i), P.removeEventListener("error", o), P.removeEventListener("load", u), P.removeEventListener("timeout", a);
                var N = n._xhrMem.get(P);
                N && (N.callbackToRemoveEvents = void 0);
              })(l), v.createdResources && v.createdResources.observer.disconnect();
            }, n._addHeaders(l, b), n._addResourceObserver(l, b);
          });
        }
        return c.apply(this, s);
      };
    };
  }, t.prototype.enable = function() {
    this._diag.debug("applying patch to", this.moduleName, this.version), mt(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), mt(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
  }, t.prototype.disable = function() {
    this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
  }, t;
}(xn), fr = { "@opentelemetry/instrumentation-document-load": QE, "@opentelemetry/instrumentation-fetch": sd, "@opentelemetry/instrumentation-user-interaction": pd, "@opentelemetry/instrumentation-xml-http-request": Sd };
function IL(e) {
  var t;
  e === void 0 && (e = {});
  for (var n = 0, r = Object.keys(e); n < r.length; n++) {
    var o = r[n];
    Object.prototype.hasOwnProperty.call(fr, o) || w.error('Provided instrumentation name "' + o + '" not found');
  }
  for (var i = [], a = 0, u = Object.keys(fr); a < u.length; a++) {
    var c = u[a], l = fr[c], s = (t = e[c]) !== null && t !== void 0 ? t : {};
    if (s.enabled !== !1) try {
      w.debug("Loading instrumentation for " + c), i.push(new l(s));
    } catch (p) {
      w.error(p);
    }
    else w.debug("Disabling instrumentation for " + c);
  }
  return i;
}
var Wo, Ht, Xt, Ko = "OT_ZONE_CONTEXT", DL = function() {
  function e() {
    this._enabled = !1, this._zoneCounter = 0;
  }
  return e.prototype._activeContextFromZone = function(t) {
    return t && t.get(Ko) || Zt;
  }, e.prototype._bindFunction = function(t, n) {
    var r = this, o = function() {
      for (var i = this, a = [], u = 0; u < arguments.length; u++) a[u] = arguments[u];
      return r.with(t, function() {
        return n.apply(i, a);
      });
    };
    return Object.defineProperty(o, "length", { enumerable: !1, configurable: !0, writable: !1, value: n.length }), o;
  }, e.prototype._bindListener = function(t, n) {
    var r = n;
    return r.__ot_listeners !== void 0 || (r.__ot_listeners = {}, typeof r.addEventListener == "function" && (r.addEventListener = this._patchAddEventListener(r, r.addEventListener, t)), typeof r.removeEventListener == "function" && (r.removeEventListener = this._patchRemoveEventListener(r, r.removeEventListener))), n;
  }, e.prototype._createZoneName = function() {
    this._zoneCounter++;
    var t = Math.random();
    return this._zoneCounter + "-" + t;
  }, e.prototype._createZone = function(t, n) {
    var r;
    return Zone.current.fork({ name: t, properties: (r = {}, r[Ko] = n, r) });
  }, e.prototype._getActiveZone = function() {
    return Zone.current;
  }, e.prototype._patchAddEventListener = function(t, n, r) {
    var o = this;
    return function(i, a, u) {
      t.__ot_listeners === void 0 && (t.__ot_listeners = {});
      var c = t.__ot_listeners[i];
      c === void 0 && (c = /* @__PURE__ */ new WeakMap(), t.__ot_listeners[i] = c);
      var l = o.bind(r, a);
      return c.set(a, l), n.call(this, i, l, u);
    };
  }, e.prototype._patchRemoveEventListener = function(t, n) {
    return function(r, o) {
      if (t.__ot_listeners === void 0 || t.__ot_listeners[r] === void 0) return n.call(this, r, o);
      var i = t.__ot_listeners[r], a = i.get(o);
      return i.delete(o), n.call(this, r, a || o);
    };
  }, e.prototype.active = function() {
    if (!this._enabled) return Zt;
    var t = this._getActiveZone(), n = this._activeContextFromZone(t);
    return n || Zt;
  }, e.prototype.bind = function(t, n) {
    return t === void 0 && (t = this.active()), typeof n == "function" ? this._bindFunction(t, n) : ((r = n) === void 0 && (r = {}), typeof r.addEventListener == "function" && typeof r.removeEventListener == "function" && this._bindListener(t, n), n);
    var r;
  }, e.prototype.disable = function() {
    return this._enabled = !1, this;
  }, e.prototype.enable = function() {
    return this._enabled = !0, this;
  }, e.prototype.with = function(t, n, r) {
    for (var o = [], i = 3; i < arguments.length; i++) o[i - 3] = arguments[i];
    var a = this._createZoneName();
    return this._createZone(a, t).run(n, r, o);
  }, e;
}(), yd = {};
(function() {
  if (Wo) return yd;
  Wo = 1;
  const e = globalThis;
  function t(f) {
    return (e.__Zone_symbol_prefix || "__zone_symbol__") + f;
  }
  function n() {
    const f = e.performance;
    function E(ot) {
      f && f.mark && f.mark(ot);
    }
    function m(ot, S) {
      f && f.measure && f.measure(ot, S);
    }
    E("Zone");
    class _ {
      static {
        this.__symbol__ = t;
      }
      static assertZonePatched() {
        if (e.Promise !== I.ZoneAwarePromise) throw new Error("Zone.js has detected that ZoneAwarePromise `(window|global).Promise` has been overwritten.\nMost likely cause is that a Promise polyfill has been loaded after Zone.js (Polyfilling Promise api is not necessary when zone.js is loaded. If you must load one, do so before loading zone.js.)");
      }
      static get root() {
        let S = _.current;
        for (; S.parent; ) S = S.parent;
        return S;
      }
      static get current() {
        return tt.zone;
      }
      static get currentTask() {
        return Lt;
      }
      static __load_patch(S, h, y = !1) {
        if (I.hasOwnProperty(S)) {
          const B = e[t("forceDuplicateZoneCheck")] === !0;
          if (!y && B) throw Error("Already loaded patch: " + S);
        } else if (!e["__Zone_disable_" + S]) {
          const B = "Zone:" + S;
          E(B), I[S] = h(e, _, Ot), m(B, B);
        }
      }
      get parent() {
        return this._parent;
      }
      get name() {
        return this._name;
      }
      constructor(S, h) {
        this._parent = S, this._name = h ? h.name || "unnamed" : "<root>", this._properties = h && h.properties || {}, this._zoneDelegate = new O(this, this._parent && this._parent._zoneDelegate, h);
      }
      get(S) {
        const h = this.getZoneWith(S);
        if (h) return h._properties[S];
      }
      getZoneWith(S) {
        let h = this;
        for (; h; ) {
          if (h._properties.hasOwnProperty(S)) return h;
          h = h._parent;
        }
        return null;
      }
      fork(S) {
        if (!S) throw new Error("ZoneSpec required!");
        return this._zoneDelegate.fork(this, S);
      }
      wrap(S, h) {
        if (typeof S != "function") throw new Error("Expecting function got: " + S);
        const y = this._zoneDelegate.intercept(this, S, h), B = this;
        return function() {
          return B.runGuarded(y, this, arguments, h);
        };
      }
      run(S, h, y, B) {
        tt = { parent: tt, zone: this };
        try {
          return this._zoneDelegate.invoke(this, S, h, y, B);
        } finally {
          tt = tt.parent;
        }
      }
      runGuarded(S, h = null, y, B) {
        tt = { parent: tt, zone: this };
        try {
          try {
            return this._zoneDelegate.invoke(this, S, h, y, B);
          } catch (st) {
            if (this._zoneDelegate.handleError(this, st)) throw st;
          }
        } finally {
          tt = tt.parent;
        }
      }
      runTask(S, h, y) {
        if (S.zone != this) throw new Error("A task can only be run in the zone of creation! (Creation: " + (S.zone || ft).name + "; Execution: " + this.name + ")");
        const B = S, { type: st, data: { isPeriodic: C = !1, isRefreshable: T = !1 } = {} } = S;
        if (S.state === pt && (st === K || st === R)) return;
        const A = S.state != _t;
        A && B._transitionTo(_t, D);
        const M = Lt;
        Lt = B, tt = { parent: tt, zone: this };
        try {
          st != R || !S.data || C || T || (S.cancelFn = void 0);
          try {
            return this._zoneDelegate.invokeTask(this, B, h, y);
          } catch (x) {
            if (this._zoneDelegate.handleError(this, x)) throw x;
          }
        } finally {
          const x = S.state;
          if (x !== pt && x !== Et) if (st == K || C || T && x === z) A && B._transitionTo(D, _t, z);
          else {
            const F = B._zoneDelegates;
            this._updateTaskCount(B, -1), A && B._transitionTo(pt, _t, pt), T && (B._zoneDelegates = F);
          }
          tt = tt.parent, Lt = M;
        }
      }
      scheduleTask(S) {
        if (S.zone && S.zone !== this) {
          let y = this;
          for (; y; ) {
            if (y === S.zone) throw Error(`can not reschedule task to ${this.name} which is descendants of the original zone ${S.zone.name}`);
            y = y.parent;
          }
        }
        S._transitionTo(z, pt);
        const h = [];
        S._zoneDelegates = h, S._zone = this;
        try {
          S = this._zoneDelegate.scheduleTask(this, S);
        } catch (y) {
          throw S._transitionTo(Et, z, pt), this._zoneDelegate.handleError(this, y), y;
        }
        return S._zoneDelegates === h && this._updateTaskCount(S, 1), S.state == z && S._transitionTo(D, z), S;
      }
      scheduleMicroTask(S, h, y, B) {
        return this.scheduleTask(new L(rt, S, h, y, B, void 0));
      }
      scheduleMacroTask(S, h, y, B, st) {
        return this.scheduleTask(new L(R, S, h, y, B, st));
      }
      scheduleEventTask(S, h, y, B, st) {
        return this.scheduleTask(new L(K, S, h, y, B, st));
      }
      cancelTask(S) {
        if (S.zone != this) throw new Error("A task can only be cancelled in the zone of creation! (Creation: " + (S.zone || ft).name + "; Execution: " + this.name + ")");
        if (S.state === D || S.state === _t) {
          S._transitionTo(it, D, _t);
          try {
            this._zoneDelegate.cancelTask(this, S);
          } catch (h) {
            throw S._transitionTo(Et, it), this._zoneDelegate.handleError(this, h), h;
          }
          return this._updateTaskCount(S, -1), S._transitionTo(pt, it), S.runCount = -1, S;
        }
      }
      _updateTaskCount(S, h) {
        const y = S._zoneDelegates;
        h == -1 && (S._zoneDelegates = null);
        for (let B = 0; B < y.length; B++) y[B]._updateTaskCount(S.type, h);
      }
    }
    const d = { name: "", onHasTask: (ot, S, h, y) => ot.hasTask(h, y), onScheduleTask: (ot, S, h, y) => ot.scheduleTask(h, y), onInvokeTask: (ot, S, h, y, B, st) => ot.invokeTask(h, y, B, st), onCancelTask: (ot, S, h, y) => ot.cancelTask(h, y) };
    class O {
      get zone() {
        return this._zone;
      }
      constructor(S, h, y) {
        this._taskCounts = { microTask: 0, macroTask: 0, eventTask: 0 }, this._zone = S, this._parentDelegate = h, this._forkZS = y && (y && y.onFork ? y : h._forkZS), this._forkDlgt = y && (y.onFork ? h : h._forkDlgt), this._forkCurrZone = y && (y.onFork ? this._zone : h._forkCurrZone), this._interceptZS = y && (y.onIntercept ? y : h._interceptZS), this._interceptDlgt = y && (y.onIntercept ? h : h._interceptDlgt), this._interceptCurrZone = y && (y.onIntercept ? this._zone : h._interceptCurrZone), this._invokeZS = y && (y.onInvoke ? y : h._invokeZS), this._invokeDlgt = y && (y.onInvoke ? h : h._invokeDlgt), this._invokeCurrZone = y && (y.onInvoke ? this._zone : h._invokeCurrZone), this._handleErrorZS = y && (y.onHandleError ? y : h._handleErrorZS), this._handleErrorDlgt = y && (y.onHandleError ? h : h._handleErrorDlgt), this._handleErrorCurrZone = y && (y.onHandleError ? this._zone : h._handleErrorCurrZone), this._scheduleTaskZS = y && (y.onScheduleTask ? y : h._scheduleTaskZS), this._scheduleTaskDlgt = y && (y.onScheduleTask ? h : h._scheduleTaskDlgt), this._scheduleTaskCurrZone = y && (y.onScheduleTask ? this._zone : h._scheduleTaskCurrZone), this._invokeTaskZS = y && (y.onInvokeTask ? y : h._invokeTaskZS), this._invokeTaskDlgt = y && (y.onInvokeTask ? h : h._invokeTaskDlgt), this._invokeTaskCurrZone = y && (y.onInvokeTask ? this._zone : h._invokeTaskCurrZone), this._cancelTaskZS = y && (y.onCancelTask ? y : h._cancelTaskZS), this._cancelTaskDlgt = y && (y.onCancelTask ? h : h._cancelTaskDlgt), this._cancelTaskCurrZone = y && (y.onCancelTask ? this._zone : h._cancelTaskCurrZone), this._hasTaskZS = null, this._hasTaskDlgt = null, this._hasTaskDlgtOwner = null, this._hasTaskCurrZone = null;
        const B = y && y.onHasTask, st = h && h._hasTaskZS;
        (B || st) && (this._hasTaskZS = B ? y : d, this._hasTaskDlgt = h, this._hasTaskDlgtOwner = this, this._hasTaskCurrZone = this._zone, y.onScheduleTask || (this._scheduleTaskZS = d, this._scheduleTaskDlgt = h, this._scheduleTaskCurrZone = this._zone), y.onInvokeTask || (this._invokeTaskZS = d, this._invokeTaskDlgt = h, this._invokeTaskCurrZone = this._zone), y.onCancelTask || (this._cancelTaskZS = d, this._cancelTaskDlgt = h, this._cancelTaskCurrZone = this._zone));
      }
      fork(S, h) {
        return this._forkZS ? this._forkZS.onFork(this._forkDlgt, this.zone, S, h) : new _(S, h);
      }
      intercept(S, h, y) {
        return this._interceptZS ? this._interceptZS.onIntercept(this._interceptDlgt, this._interceptCurrZone, S, h, y) : h;
      }
      invoke(S, h, y, B, st) {
        return this._invokeZS ? this._invokeZS.onInvoke(this._invokeDlgt, this._invokeCurrZone, S, h, y, B, st) : h.apply(y, B);
      }
      handleError(S, h) {
        return !this._handleErrorZS || this._handleErrorZS.onHandleError(this._handleErrorDlgt, this._handleErrorCurrZone, S, h);
      }
      scheduleTask(S, h) {
        let y = h;
        if (this._scheduleTaskZS) this._hasTaskZS && y._zoneDelegates.push(this._hasTaskDlgtOwner), y = this._scheduleTaskZS.onScheduleTask(this._scheduleTaskDlgt, this._scheduleTaskCurrZone, S, h), y || (y = h);
        else if (h.scheduleFn) h.scheduleFn(h);
        else {
          if (h.type != rt) throw new Error("Task is missing scheduleFn.");
          St(h);
        }
        return y;
      }
      invokeTask(S, h, y, B) {
        return this._invokeTaskZS ? this._invokeTaskZS.onInvokeTask(this._invokeTaskDlgt, this._invokeTaskCurrZone, S, h, y, B) : h.callback.apply(y, B);
      }
      cancelTask(S, h) {
        let y;
        if (this._cancelTaskZS) y = this._cancelTaskZS.onCancelTask(this._cancelTaskDlgt, this._cancelTaskCurrZone, S, h);
        else {
          if (!h.cancelFn) throw Error("Task is not cancelable");
          y = h.cancelFn(h);
        }
        return y;
      }
      hasTask(S, h) {
        try {
          this._hasTaskZS && this._hasTaskZS.onHasTask(this._hasTaskDlgt, this._hasTaskCurrZone, S, h);
        } catch (y) {
          this.handleError(S, y);
        }
      }
      _updateTaskCount(S, h) {
        const y = this._taskCounts, B = y[S], st = y[S] = B + h;
        if (st < 0) throw new Error("More tasks executed then were scheduled.");
        if (B == 0 || st == 0) {
          const C = { microTask: y.microTask > 0, macroTask: y.macroTask > 0, eventTask: y.eventTask > 0, change: S };
          this.hasTask(this._zone, C);
        }
      }
    }
    class L {
      constructor(S, h, y, B, st, C) {
        if (this._zone = null, this.runCount = 0, this._zoneDelegates = null, this._state = "notScheduled", this.type = S, this.source = h, this.data = B, this.scheduleFn = st, this.cancelFn = C, !y) throw new Error("callback is not defined");
        this.callback = y;
        const T = this;
        S === K && B && B.useG ? this.invoke = L.invokeTask : this.invoke = function() {
          return L.invokeTask.call(e, T, this, arguments);
        };
      }
      static invokeTask(S, h, y) {
        S || (S = this), wt++;
        try {
          return S.runCount++, S.zone.runTask(S, h, y);
        } finally {
          wt == 1 && At(), wt--;
        }
      }
      get zone() {
        return this._zone;
      }
      get state() {
        return this._state;
      }
      cancelScheduleRequest() {
        this._transitionTo(pt, z);
      }
      _transitionTo(S, h, y) {
        if (this._state !== h && this._state !== y) throw new Error(`${this.type} '${this.source}': can not transition to '${S}', expecting state '${h}'${y ? " or '" + y + "'" : ""}, was '${this._state}'.`);
        this._state = S, S == pt && (this._zoneDelegates = null);
      }
      toString() {
        return this.data && this.data.handleId !== void 0 ? this.data.handleId.toString() : Object.prototype.toString.call(this);
      }
      toJSON() {
        return { type: this.type, state: this.state, source: this.source, zone: this.zone.name, runCount: this.runCount };
      }
    }
    const U = t("setTimeout"), Y = t("Promise"), j = t("then");
    let k, W = [], nt = !1;
    function at(ot) {
      if (k || e[Y] && (k = e[Y].resolve(0)), k) {
        let S = k[j];
        S || (S = k.then), S.call(k, ot);
      } else e[U](ot, 0);
    }
    function St(ot) {
      wt === 0 && W.length === 0 && at(At), ot && W.push(ot);
    }
    function At() {
      if (!nt) {
        for (nt = !0; W.length; ) {
          const ot = W;
          W = [];
          for (let S = 0; S < ot.length; S++) {
            const h = ot[S];
            try {
              h.zone.runTask(h, null, null);
            } catch (y) {
              Ot.onUnhandledError(y);
            }
          }
        }
        Ot.microtaskDrainDone(), nt = !1;
      }
    }
    const ft = { name: "NO ZONE" }, pt = "notScheduled", z = "scheduling", D = "scheduled", _t = "running", it = "canceling", Et = "unknown", rt = "microTask", R = "macroTask", K = "eventTask", I = {}, Ot = { symbol: t, currentZoneFrame: () => tt, onUnhandledError: ht, microtaskDrainDone: ht, scheduleMicroTask: St, showUncaughtError: () => !_[t("ignoreConsoleErrorUncaughtError")], patchEventTarget: () => [], patchOnProperties: ht, patchMethod: () => ht, bindArguments: () => [], patchThen: () => ht, patchMacroTask: () => ht, patchEventPrototype: () => ht, isIEOrEdge: () => !1, getGlobalObjects: () => {
    }, ObjectDefineProperty: () => ht, ObjectGetOwnPropertyDescriptor: () => {
    }, ObjectCreate: () => {
    }, ArraySlice: () => [], patchClass: () => ht, wrapWithCurrentZone: () => ht, filterProperties: () => [], attachOriginToPatched: () => ht, _redefineProperty: () => ht, patchCallbacks: () => ht, nativeScheduleMicroTask: at };
    let tt = { parent: null, zone: new _(null, null) }, Lt = null, wt = 0;
    function ht() {
    }
    return m("Zone", "Zone"), _;
  }
  const r = Object.getOwnPropertyDescriptor, o = Object.defineProperty, i = Object.getPrototypeOf, a = Object.create, u = Array.prototype.slice, c = "addEventListener", l = "removeEventListener", s = t(c), p = t(l), v = "true", g = "false", b = t("");
  function H(f, E) {
    return Zone.current.wrap(f, E);
  }
  function P(f, E, m, _, d) {
    return Zone.current.scheduleMacroTask(f, E, m, _, d);
  }
  const N = t, J = typeof window < "u", ct = J ? window : void 0, X = J && ct || globalThis;
  function lt(f, E) {
    for (let m = f.length - 1; m >= 0; m--) typeof f[m] == "function" && (f[m] = H(f[m], E + "_" + m));
    return f;
  }
  function xt(f) {
    return !f || f.writable !== !1 && !(typeof f.get == "function" && f.set === void 0);
  }
  const Rt = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope, jt = !("nw" in X) && X.process !== void 0 && X.process.toString() === "[object process]", jn = !jt && !Rt && !(!J || !ct.HTMLElement), Qr = X.process !== void 0 && X.process.toString() === "[object process]" && !Rt && !(!J || !ct.HTMLElement), $e = {}, __ = N("enable_beforeunload"), Jr = function(f) {
    if (!(f = f || X.event)) return;
    let E = $e[f.type];
    E || (E = $e[f.type] = N("ON_PROPERTY" + f.type));
    const m = this || f.target || X, _ = m[E];
    let d;
    if (jn && m === ct && f.type === "error") {
      const O = f;
      d = _ && _.call(this, O.message, O.filename, O.lineno, O.colno, O.error), d === !0 && f.preventDefault();
    } else d = _ && _.apply(this, arguments), f.type === "beforeunload" && X[__] && typeof d == "string" ? f.returnValue = d : d == null || d || f.preventDefault();
    return d;
  };
  function $r(f, E, m) {
    let _ = r(f, E);
    if (!_ && m && r(m, E) && (_ = { enumerable: !0, configurable: !0 }), !_ || !_.configurable) return;
    const d = N("on" + E + "patched");
    if (f.hasOwnProperty(d) && f[d]) return;
    delete _.writable, delete _.value;
    const O = _.get, L = _.set, U = E.slice(2);
    let Y = $e[U];
    Y || (Y = $e[U] = N("ON_PROPERTY" + U)), _.set = function(j) {
      let k = this;
      k || f !== X || (k = X), k && (typeof k[Y] == "function" && k.removeEventListener(U, Jr), L && L.call(k, null), k[Y] = j, typeof j == "function" && k.addEventListener(U, Jr, !1));
    }, _.get = function() {
      let j = this;
      if (j || f !== X || (j = X), !j) return null;
      const k = j[Y];
      if (k) return k;
      if (O) {
        let W = O.call(this);
        if (W) return _.set.call(this, W), typeof j.removeAttribute == "function" && j.removeAttribute(E), W;
      }
      return null;
    }, o(f, E, _), f[d] = !0;
  }
  function to(f, E, m) {
    if (E) for (let _ = 0; _ < E.length; _++) $r(f, "on" + E[_], m);
    else {
      const _ = [];
      for (const d in f) d.slice(0, 2) == "on" && _.push(d);
      for (let d = 0; d < _.length; d++) $r(f, _[d], m);
    }
  }
  const Vt = N("originalInstance");
  function Me(f) {
    const E = X[f];
    if (!E) return;
    X[N(f)] = E, X[f] = function() {
      const d = lt(arguments, f);
      switch (d.length) {
        case 0:
          this[Vt] = new E();
          break;
        case 1:
          this[Vt] = new E(d[0]);
          break;
        case 2:
          this[Vt] = new E(d[0], d[1]);
          break;
        case 3:
          this[Vt] = new E(d[0], d[1], d[2]);
          break;
        case 4:
          this[Vt] = new E(d[0], d[1], d[2], d[3]);
          break;
        default:
          throw new Error("Arg list too long.");
      }
    }, Qt(X[f], E);
    const m = new E(function() {
    });
    let _;
    for (_ in m) f === "XMLHttpRequest" && _ === "responseBlob" || function(d) {
      typeof m[d] == "function" ? X[f].prototype[d] = function() {
        return this[Vt][d].apply(this[Vt], arguments);
      } : o(X[f].prototype, d, { set: function(O) {
        typeof O == "function" ? (this[Vt][d] = H(O, f + "." + d), Qt(this[Vt][d], O)) : this[Vt][d] = O;
      }, get: function() {
        return this[Vt][d];
      } });
    }(_);
    for (_ in E) _ !== "prototype" && E.hasOwnProperty(_) && (X[f][_] = E[_]);
  }
  function qt(f, E, m) {
    let _ = f;
    for (; _ && !_.hasOwnProperty(E); ) _ = i(_);
    !_ && f[E] && (_ = f);
    const d = N(E);
    let O = null;
    if (_ && (!(O = _[d]) || !_.hasOwnProperty(d)) && (O = _[d] = _[E], xt(_ && r(_, E)))) {
      const L = m(O, d, E);
      _[E] = function() {
        return L(this, arguments);
      }, Qt(_[E], O);
    }
    return O;
  }
  function h_(f, E, m) {
    let _ = null;
    function d(O) {
      const L = O.data;
      return L.args[L.cbIdx] = function() {
        O.invoke.apply(this, arguments);
      }, _.apply(L.target, L.args), O;
    }
    _ = qt(f, E, (O) => function(L, U) {
      const Y = m(L, U);
      return Y.cbIdx >= 0 && typeof U[Y.cbIdx] == "function" ? P(Y.name, U[Y.cbIdx], Y, d) : O.apply(L, U);
    });
  }
  function Qt(f, E) {
    f[N("OriginalDelegate")] = E;
  }
  let eo = !1, Fn = !1;
  function E_() {
    try {
      const f = ct.navigator.userAgent;
      if (f.indexOf("MSIE ") !== -1 || f.indexOf("Trident/") !== -1) return !0;
    } catch {
    }
    return !1;
  }
  function d_() {
    if (eo) return Fn;
    eo = !0;
    try {
      const f = ct.navigator.userAgent;
      f.indexOf("MSIE ") === -1 && f.indexOf("Trident/") === -1 && f.indexOf("Edge/") === -1 || (Fn = !0);
    } catch {
    }
    return Fn;
  }
  function no(f) {
    return typeof f == "function";
  }
  function ro(f) {
    return typeof f == "number";
  }
  let me = !1;
  if (typeof window < "u") try {
    const f = Object.defineProperty({}, "passive", { get: function() {
      me = !0;
    } });
    window.addEventListener("test", f, f), window.removeEventListener("test", f, f);
  } catch {
    me = !1;
  }
  const T_ = { useG: !0 }, Ct = {}, oo = {}, io = new RegExp("^" + b + "(\\w+)(true|false)$"), ao = N("propagationStopped");
  function so(f, E) {
    const m = (E ? E(f) : f) + g, _ = (E ? E(f) : f) + v, d = b + m, O = b + _;
    Ct[f] = {}, Ct[f][g] = d, Ct[f][v] = O;
  }
  function S_(f, E, m, _) {
    const d = _ && _.add || c, O = _ && _.rm || l, L = _ && _.listeners || "eventListeners", U = _ && _.rmAll || "removeAllListeners", Y = N(d), j = "." + d + ":", k = "prependListener", W = "." + k + ":", nt = function(z, D, _t) {
      if (z.isRemoved) return;
      const it = z.callback;
      let Et;
      typeof it == "object" && it.handleEvent && (z.callback = (R) => it.handleEvent(R), z.originalDelegate = it);
      try {
        z.invoke(z, D, [_t]);
      } catch (R) {
        Et = R;
      }
      const rt = z.options;
      if (rt && typeof rt == "object" && rt.once) {
        const R = z.originalDelegate ? z.originalDelegate : z.callback;
        D[O].call(D, _t.type, R, rt);
      }
      return Et;
    };
    function at(z, D, _t) {
      if (!(D = D || f.event)) return;
      const it = z || D.target || f, Et = it[Ct[D.type][_t ? v : g]];
      if (Et) {
        const rt = [];
        if (Et.length === 1) {
          const R = nt(Et[0], it, D);
          R && rt.push(R);
        } else {
          const R = Et.slice();
          for (let K = 0; K < R.length && (!D || D[ao] !== !0); K++) {
            const I = nt(R[K], it, D);
            I && rt.push(I);
          }
        }
        if (rt.length === 1) throw rt[0];
        for (let R = 0; R < rt.length; R++) {
          const K = rt[R];
          E.nativeScheduleMicroTask(() => {
            throw K;
          });
        }
      }
    }
    const St = function(z) {
      return at(this, z, !1);
    }, At = function(z) {
      return at(this, z, !0);
    };
    function ft(z, D) {
      if (!z) return !1;
      let _t = !0;
      D && D.useG !== void 0 && (_t = D.useG);
      const it = D && D.vh;
      let Et = !0;
      D && D.chkDup !== void 0 && (Et = D.chkDup);
      let rt = !1;
      D && D.rt !== void 0 && (rt = D.rt);
      let R = z;
      for (; R && !R.hasOwnProperty(d); ) R = i(R);
      if (!R && z[d] && (R = z), !R || R[Y]) return !1;
      const K = D && D.eventNameToString, I = {}, Ot = R[Y] = R[d], tt = R[N(O)] = R[O], Lt = R[N(L)] = R[L], wt = R[N(U)] = R[U];
      let ht;
      D && D.prepend && (ht = R[N(D.prepend)] = R[D.prepend]);
      const ot = function(T) {
        return ht.call(I.target, I.eventName, T.invoke, I.options);
      }, S = _t ? function(T) {
        if (!I.isExisting) return Ot.call(I.target, I.eventName, I.capture ? At : St, I.options);
      } : function(T) {
        return Ot.call(I.target, I.eventName, T.invoke, I.options);
      }, h = _t ? function(T) {
        if (!T.isRemoved) {
          const A = Ct[T.eventName];
          let M;
          A && (M = A[T.capture ? v : g]);
          const x = M && T.target[M];
          if (x) {
            for (let F = 0; F < x.length; F++)
              if (x[F] === T) {
                x.splice(F, 1), T.isRemoved = !0, T.removeAbortListener && (T.removeAbortListener(), T.removeAbortListener = null), x.length === 0 && (T.allRemoved = !0, T.target[M] = null);
                break;
              }
          }
        }
        if (T.allRemoved) return tt.call(T.target, T.eventName, T.capture ? At : St, T.options);
      } : function(T) {
        return tt.call(T.target, T.eventName, T.invoke, T.options);
      }, y = D && D.diff ? D.diff : function(T, A) {
        const M = typeof A;
        return M === "function" && T.callback === A || M === "object" && T.originalDelegate === A;
      }, B = Zone[N("UNPATCHED_EVENTS")], st = f[N("PASSIVE_EVENTS")], C = function(T, A, M, x, F = !1, G = !1) {
        return function() {
          const V = this || f;
          let q = arguments[0];
          D && D.transferEventName && (q = D.transferEventName(q));
          let et = arguments[1];
          if (!et) return T.apply(this, arguments);
          if (jt && q === "uncaughtException") return T.apply(this, arguments);
          let Tt = !1;
          if (typeof et != "function") {
            if (!et.handleEvent) return T.apply(this, arguments);
            Tt = !0;
          }
          if (it && !it(T, et, V, arguments)) return;
          const bt = me && !!st && st.indexOf(q) !== -1, Ft = function(ut) {
            if (typeof ut == "object" && ut !== null) {
              const nn = { ...ut };
              return ut.signal && (nn.signal = ut.signal), nn;
            }
            return ut;
          }(function(ut, nn) {
            return !me && typeof ut == "object" && ut ? !!ut.capture : me && nn ? typeof ut == "boolean" ? { capture: ut, passive: !0 } : ut ? typeof ut == "object" && ut.passive !== !1 ? { ...ut, passive: !0 } : ut : { passive: !0 } : ut;
          }(arguments[2], bt)), Ae = Ft?.signal;
          if (Ae?.aborted) return;
          if (B) {
            for (let ut = 0; ut < B.length; ut++) if (q === B[ut]) return bt ? T.call(V, q, et, Ft) : T.apply(this, arguments);
          }
          const zn = !!Ft && (typeof Ft == "boolean" || Ft.capture), fo = !(!Ft || typeof Ft != "object") && Ft.once, R_ = Zone.current;
          let Zn = Ct[q];
          Zn || (so(q, K), Zn = Ct[q]);
          const _o = Zn[zn ? v : g];
          let en, Oe = V[_o], ho = !1;
          if (Oe) {
            if (ho = !0, Et) {
              for (let ut = 0; ut < Oe.length; ut++) if (y(Oe[ut], et)) return;
            }
          } else Oe = V[_o] = [];
          const Eo = V.constructor.name, To = oo[Eo];
          To && (en = To[q]), en || (en = Eo + A + (K ? K(q) : q)), I.options = Ft, fo && (I.options.once = !1), I.target = V, I.capture = zn, I.eventName = q, I.isExisting = ho;
          const Pe = _t ? T_ : void 0;
          Pe && (Pe.taskData = I), Ae && (I.options.signal = void 0);
          const Bt = R_.scheduleEventTask(en, et, Pe, M, x);
          if (Ae) {
            I.options.signal = Ae;
            const ut = () => Bt.zone.cancelTask(Bt);
            T.call(Ae, "abort", ut, { once: !0 }), Bt.removeAbortListener = () => Ae.removeEventListener("abort", ut);
          }
          return I.target = null, Pe && (Pe.taskData = null), fo && (I.options.once = !0), (me || typeof Bt.options != "boolean") && (Bt.options = Ft), Bt.target = V, Bt.capture = zn, Bt.eventName = q, Tt && (Bt.originalDelegate = et), G ? Oe.unshift(Bt) : Oe.push(Bt), F ? V : void 0;
        };
      };
      return R[d] = C(Ot, j, S, h, rt), ht && (R[k] = C(ht, W, ot, h, rt, !0)), R[O] = function() {
        const T = this || f;
        let A = arguments[0];
        D && D.transferEventName && (A = D.transferEventName(A));
        const M = arguments[2], x = !!M && (typeof M == "boolean" || M.capture), F = arguments[1];
        if (!F) return tt.apply(this, arguments);
        if (it && !it(tt, F, T, arguments)) return;
        const G = Ct[A];
        let V;
        G && (V = G[x ? v : g]);
        const q = V && T[V];
        if (q) for (let et = 0; et < q.length; et++) {
          const Tt = q[et];
          if (y(Tt, F))
            return q.splice(et, 1), Tt.isRemoved = !0, q.length === 0 && (Tt.allRemoved = !0, T[V] = null, !x && typeof A == "string") && (T[b + "ON_PROPERTY" + A] = null), Tt.zone.cancelTask(Tt), rt ? T : void 0;
        }
        return tt.apply(this, arguments);
      }, R[L] = function() {
        const T = this || f;
        let A = arguments[0];
        D && D.transferEventName && (A = D.transferEventName(A));
        const M = [], x = uo(T, K ? K(A) : A);
        for (let F = 0; F < x.length; F++) {
          const G = x[F];
          let V = G.originalDelegate ? G.originalDelegate : G.callback;
          M.push(V);
        }
        return M;
      }, R[U] = function() {
        const T = this || f;
        let A = arguments[0];
        if (A) {
          D && D.transferEventName && (A = D.transferEventName(A));
          const M = Ct[A];
          if (M) {
            const x = M[g], F = M[v], G = T[x], V = T[F];
            if (G) {
              const q = G.slice();
              for (let et = 0; et < q.length; et++) {
                const Tt = q[et];
                let bt = Tt.originalDelegate ? Tt.originalDelegate : Tt.callback;
                this[O].call(this, A, bt, Tt.options);
              }
            }
            if (V) {
              const q = V.slice();
              for (let et = 0; et < q.length; et++) {
                const Tt = q[et];
                let bt = Tt.originalDelegate ? Tt.originalDelegate : Tt.callback;
                this[O].call(this, A, bt, Tt.options);
              }
            }
          }
        } else {
          const M = Object.keys(T);
          for (let x = 0; x < M.length; x++) {
            const F = M[x], G = io.exec(F);
            let V = G && G[1];
            V && V !== "removeListener" && this[U].call(this, V);
          }
          this[U].call(this, "removeListener");
        }
        if (rt) return this;
      }, Qt(R[d], Ot), Qt(R[O], tt), wt && Qt(R[U], wt), Lt && Qt(R[L], Lt), !0;
    }
    let pt = [];
    for (let z = 0; z < m.length; z++) pt[z] = ft(m[z], _);
    return pt;
  }
  function uo(f, E) {
    if (!E) {
      const O = [];
      for (let L in f) {
        const U = io.exec(L);
        let Y = U && U[1];
        if (Y && (!E || Y === E)) {
          const j = f[L];
          if (j) for (let k = 0; k < j.length; k++) O.push(j[k]);
        }
      }
      return O;
    }
    let m = Ct[E];
    m || (so(E), m = Ct[E]);
    const _ = f[m[g]], d = f[m[v]];
    return _ ? d ? _.concat(d) : _.slice() : d ? d.slice() : [];
  }
  function y_(f, E) {
    const m = f.Event;
    m && m.prototype && E.patchMethod(m.prototype, "stopImmediatePropagation", (_) => function(d, O) {
      d[ao] = !0, _ && _.apply(d, O);
    });
  }
  function v_(f, E) {
    E.patchMethod(f, "queueMicrotask", (m) => function(_, d) {
      Zone.current.scheduleMicroTask("queueMicrotask", d[0]);
    });
  }
  const tn = N("zoneTask");
  function ge(f, E, m, _) {
    let d = null, O = null;
    m += _;
    const L = {};
    function U(j) {
      const k = j.data;
      k.args[0] = function() {
        return j.invoke.apply(this, arguments);
      };
      const W = d.apply(f, k.args);
      return ro(W) ? k.handleId = W : (k.handle = W, k.isRefreshable = no(W.refresh)), j;
    }
    function Y(j) {
      const { handle: k, handleId: W } = j.data;
      return O.call(f, k ?? W);
    }
    d = qt(f, E += _, (j) => function(k, W) {
      if (no(W[0])) {
        const nt = { isRefreshable: !1, isPeriodic: _ === "Interval", delay: _ === "Timeout" || _ === "Interval" ? W[1] || 0 : void 0, args: W }, at = W[0];
        W[0] = function() {
          try {
            return at.apply(this, arguments);
          } finally {
            const { handle: D, handleId: _t, isPeriodic: it, isRefreshable: Et } = nt;
            it || Et || (_t ? delete L[_t] : D && (D[tn] = null));
          }
        };
        const St = P(E, W[0], nt, U, Y);
        if (!St) return St;
        const { handleId: At, handle: ft, isRefreshable: pt, isPeriodic: z } = St.data;
        if (At) L[At] = St;
        else if (ft && (ft[tn] = St, pt && !z)) {
          const D = ft.refresh;
          ft.refresh = function() {
            const { zone: _t, state: it } = St;
            return it === "notScheduled" ? (St._state = "scheduled", _t._updateTaskCount(St, 1)) : it === "running" && (St._state = "scheduling"), D.call(this);
          };
        }
        return ft ?? At ?? St;
      }
      return j.apply(f, W);
    }), O = qt(f, m, (j) => function(k, W) {
      const nt = W[0];
      let at;
      ro(nt) ? (at = L[nt], delete L[nt]) : (at = nt?.[tn], at ? nt[tn] = null : at = nt), at?.type ? at.cancelFn && at.zone.cancelTask(at) : j.apply(f, W);
    });
  }
  function m_(f, E) {
    if (Zone[E.symbol("patchEventTarget")]) return;
    const { eventNames: m, zoneSymbolEventNames: _, TRUE_STR: d, FALSE_STR: O, ZONE_SYMBOL_PREFIX: L } = E.getGlobalObjects();
    for (let Y = 0; Y < m.length; Y++) {
      const j = m[Y], k = L + (j + O), W = L + (j + d);
      _[j] = {}, _[j][O] = k, _[j][d] = W;
    }
    const U = f.EventTarget;
    return U && U.prototype ? (E.patchEventTarget(f, E, [U && U.prototype]), !0) : void 0;
  }
  function co(f, E, m) {
    if (!m || m.length === 0) return E;
    const _ = m.filter((O) => O.target === f);
    if (!_ || _.length === 0) return E;
    const d = _[0].ignoreProperties;
    return E.filter((O) => d.indexOf(O) === -1);
  }
  function lo(f, E, m, _) {
    f && to(f, co(f, E, m), _);
  }
  function Yn(f) {
    return Object.getOwnPropertyNames(f).filter((E) => E.startsWith("on") && E.length > 2).map((E) => E.substring(2));
  }
  function g_(f, E) {
    if (jt && !Qr || Zone[f.symbol("patchEvents")]) return;
    const m = E.__Zone_ignore_on_properties;
    let _ = [];
    if (jn) {
      const d = window;
      _ = _.concat(["Document", "SVGElement", "Element", "HTMLElement", "HTMLBodyElement", "HTMLMediaElement", "HTMLFrameSetElement", "HTMLFrameElement", "HTMLIFrameElement", "HTMLMarqueeElement", "Worker"]);
      const O = E_() ? [{ target: d, ignoreProperties: ["error"] }] : [];
      lo(d, Yn(d), m && m.concat(O), i(d));
    }
    _ = _.concat(["XMLHttpRequest", "XMLHttpRequestEventTarget", "IDBIndex", "IDBRequest", "IDBOpenDBRequest", "IDBDatabase", "IDBTransaction", "IDBCursor", "WebSocket"]);
    for (let d = 0; d < _.length; d++) {
      const O = E[_[d]];
      O && O.prototype && lo(O.prototype, Yn(O.prototype), m);
    }
  }
  function A_(f) {
    f.__load_patch("ZoneAwarePromise", (E, m, _) => {
      const d = Object.getOwnPropertyDescriptor, O = Object.defineProperty, L = _.symbol, U = [], Y = E[L("DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION")] !== !1, j = L("Promise"), k = L("then");
      _.onUnhandledError = (C) => {
        if (_.showUncaughtError()) {
          const T = C && C.rejection;
          T ? console.error("Unhandled Promise rejection:", T instanceof Error ? T.message : T, "; Zone:", C.zone.name, "; Task:", C.task && C.task.source, "; Value:", T, T instanceof Error ? T.stack : void 0) : console.error(C);
        }
      }, _.microtaskDrainDone = () => {
        for (; U.length; ) {
          const C = U.shift();
          try {
            C.zone.runGuarded(() => {
              throw C.throwOriginal ? C.rejection : C;
            });
          } catch (T) {
            nt(T);
          }
        }
      };
      const W = L("unhandledPromiseRejectionHandler");
      function nt(C) {
        _.onUnhandledError(C);
        try {
          const T = m[W];
          typeof T == "function" && T.call(this, C);
        } catch {
        }
      }
      function at(C) {
        return C && C.then;
      }
      function St(C) {
        return C;
      }
      function At(C) {
        return h.reject(C);
      }
      const ft = L("state"), pt = L("value"), z = L("finally"), D = L("parentPromiseValue"), _t = L("parentPromiseState"), it = null, Et = !0, rt = !1;
      function R(C, T) {
        return (A) => {
          try {
            tt(C, T, A);
          } catch (M) {
            tt(C, !1, M);
          }
        };
      }
      const K = function() {
        let C = !1;
        return function(T) {
          return function() {
            C || (C = !0, T.apply(null, arguments));
          };
        };
      }, I = "Promise resolved with itself", Ot = L("currentTaskTrace");
      function tt(C, T, A) {
        const M = K();
        if (C === A) throw new TypeError(I);
        if (C[ft] === it) {
          let x = null;
          try {
            typeof A != "object" && typeof A != "function" || (x = A && A.then);
          } catch (F) {
            return M(() => {
              tt(C, !1, F);
            })(), C;
          }
          if (T !== rt && A instanceof h && A.hasOwnProperty(ft) && A.hasOwnProperty(pt) && A[ft] !== it) wt(A), tt(C, A[ft], A[pt]);
          else if (T !== rt && typeof x == "function") try {
            x.call(A, M(R(C, T)), M(R(C, !1)));
          } catch (F) {
            M(() => {
              tt(C, !1, F);
            })();
          }
          else {
            C[ft] = T;
            const F = C[pt];
            if (C[pt] = A, C[z] === z && T === Et && (C[ft] = C[_t], C[pt] = C[D]), T === rt && A instanceof Error) {
              const G = m.currentTask && m.currentTask.data && m.currentTask.data.__creationTrace__;
              G && O(A, Ot, { configurable: !0, enumerable: !1, writable: !0, value: G });
            }
            for (let G = 0; G < F.length; ) ht(C, F[G++], F[G++], F[G++], F[G++]);
            if (F.length == 0 && T == rt) {
              C[ft] = 0;
              let G = A;
              try {
                throw new Error("Uncaught (in promise): " + function(V) {
                  return V && V.toString === Object.prototype.toString ? (V.constructor && V.constructor.name || "") + ": " + JSON.stringify(V) : V ? V.toString() : Object.prototype.toString.call(V);
                }(A) + (A && A.stack ? `
` + A.stack : ""));
              } catch (V) {
                G = V;
              }
              Y && (G.throwOriginal = !0), G.rejection = A, G.promise = C, G.zone = m.current, G.task = m.currentTask, U.push(G), _.scheduleMicroTask();
            }
          }
        }
        return C;
      }
      const Lt = L("rejectionHandledHandler");
      function wt(C) {
        if (C[ft] === 0) {
          try {
            const T = m[Lt];
            T && typeof T == "function" && T.call(this, { rejection: C[pt], promise: C });
          } catch {
          }
          C[ft] = rt;
          for (let T = 0; T < U.length; T++) C === U[T].promise && U.splice(T, 1);
        }
      }
      function ht(C, T, A, M, x) {
        wt(C);
        const F = C[ft], G = F ? typeof M == "function" ? M : St : typeof x == "function" ? x : At;
        T.scheduleMicroTask("Promise.then", () => {
          try {
            const V = C[pt], q = !!A && z === A[z];
            q && (A[D] = V, A[_t] = F);
            const et = T.run(G, void 0, q && G !== At && G !== St ? [] : [V]);
            tt(A, !0, et);
          } catch (V) {
            tt(A, !1, V);
          }
        }, A);
      }
      const ot = function() {
      }, S = E.AggregateError;
      class h {
        static toString() {
          return "function ZoneAwarePromise() { [native code] }";
        }
        static resolve(T) {
          return T instanceof h ? T : tt(new this(null), Et, T);
        }
        static reject(T) {
          return tt(new this(null), rt, T);
        }
        static withResolvers() {
          const T = {};
          return T.promise = new h((A, M) => {
            T.resolve = A, T.reject = M;
          }), T;
        }
        static any(T) {
          if (!T || typeof T[Symbol.iterator] != "function") return Promise.reject(new S([], "All promises were rejected"));
          const A = [];
          let M = 0;
          try {
            for (let G of T) M++, A.push(h.resolve(G));
          } catch {
            return Promise.reject(new S([], "All promises were rejected"));
          }
          if (M === 0) return Promise.reject(new S([], "All promises were rejected"));
          let x = !1;
          const F = [];
          return new h((G, V) => {
            for (let q = 0; q < A.length; q++) A[q].then((et) => {
              x || (x = !0, G(et));
            }, (et) => {
              F.push(et), M--, M === 0 && (x = !0, V(new S(F, "All promises were rejected")));
            });
          });
        }
        static race(T) {
          let A, M, x = new this((V, q) => {
            A = V, M = q;
          });
          function F(V) {
            A(V);
          }
          function G(V) {
            M(V);
          }
          for (let V of T) at(V) || (V = this.resolve(V)), V.then(F, G);
          return x;
        }
        static all(T) {
          return h.allWithCallback(T);
        }
        static allSettled(T) {
          return (this && this.prototype instanceof h ? this : h).allWithCallback(T, { thenCallback: (A) => ({ status: "fulfilled", value: A }), errorCallback: (A) => ({ status: "rejected", reason: A }) });
        }
        static allWithCallback(T, A) {
          let M, x, F = new this((et, Tt) => {
            M = et, x = Tt;
          }), G = 2, V = 0;
          const q = [];
          for (let et of T) {
            at(et) || (et = this.resolve(et));
            const Tt = V;
            try {
              et.then((bt) => {
                q[Tt] = A ? A.thenCallback(bt) : bt, G--, G === 0 && M(q);
              }, (bt) => {
                A ? (q[Tt] = A.errorCallback(bt), G--, G === 0 && M(q)) : x(bt);
              });
            } catch (bt) {
              x(bt);
            }
            G++, V++;
          }
          return G -= 2, G === 0 && M(q), F;
        }
        constructor(T) {
          const A = this;
          if (!(A instanceof h)) throw new Error("Must be an instanceof Promise.");
          A[ft] = it, A[pt] = [];
          try {
            const M = K();
            T && T(M(R(A, Et)), M(R(A, rt)));
          } catch (M) {
            tt(A, !1, M);
          }
        }
        get [Symbol.toStringTag]() {
          return "Promise";
        }
        get [Symbol.species]() {
          return h;
        }
        then(T, A) {
          let M = this.constructor?.[Symbol.species];
          M && typeof M == "function" || (M = this.constructor || h);
          const x = new M(ot), F = m.current;
          return this[ft] == it ? this[pt].push(F, x, T, A) : ht(this, F, x, T, A), x;
        }
        catch(T) {
          return this.then(null, T);
        }
        finally(T) {
          let A = this.constructor?.[Symbol.species];
          A && typeof A == "function" || (A = h);
          const M = new A(ot);
          M[z] = z;
          const x = m.current;
          return this[ft] == it ? this[pt].push(x, M, T, T) : ht(this, x, M, T, T), M;
        }
      }
      h.resolve = h.resolve, h.reject = h.reject, h.race = h.race, h.all = h.all;
      const y = E[j] = E.Promise;
      E.Promise = h;
      const B = L("thenPatched");
      function st(C) {
        const T = C.prototype, A = d(T, "then");
        if (A && (A.writable === !1 || !A.configurable)) return;
        const M = T.then;
        T[k] = M, C.prototype.then = function(x, F) {
          return new h((G, V) => {
            M.call(this, G, V);
          }).then(x, F);
        }, C[B] = !0;
      }
      return _.patchThen = st, y && (st(y), qt(E, "fetch", (C) => {
        return T = C, function(A, M) {
          let x = T.apply(A, M);
          if (x instanceof h) return x;
          let F = x.constructor;
          return F[B] || st(F), x;
        };
        var T;
      })), Promise[m.__symbol__("uncaughtPromiseErrors")] = U, h;
    });
  }
  function O_(f, E, m, _, d) {
    const O = Zone.__symbol__(_);
    if (E[O]) return;
    const L = E[O] = E[_];
    E[_] = function(U, Y, j) {
      return Y && Y.prototype && d.forEach(function(k) {
        const W = `${m}.${_}::` + k, nt = Y.prototype;
        try {
          if (nt.hasOwnProperty(k)) {
            const at = f.ObjectGetOwnPropertyDescriptor(nt, k);
            at && at.value ? (at.value = f.wrapWithCurrentZone(at.value, W), f._redefineProperty(Y.prototype, k, at)) : nt[k] && (nt[k] = f.wrapWithCurrentZone(nt[k], W));
          } else nt[k] && (nt[k] = f.wrapWithCurrentZone(nt[k], W));
        } catch {
        }
      }), L.call(E, U, Y, j);
    }, f.attachOriginToPatched(E[_], L);
  }
  const po = function() {
    const f = globalThis, E = f[t("forceDuplicateZoneCheck")] === !0;
    if (f.Zone && (E || typeof f.Zone.__symbol__ != "function")) throw new Error("Zone already loaded.");
    return f.Zone ??= n(), f.Zone;
  }();
  (function(f) {
    A_(f), function(E) {
      E.__load_patch("toString", (m) => {
        const _ = Function.prototype.toString, d = N("OriginalDelegate"), O = N("Promise"), L = N("Error"), U = function() {
          if (typeof this == "function") {
            const j = this[d];
            if (j) return typeof j == "function" ? _.call(j) : Object.prototype.toString.call(j);
            if (this === Promise) {
              const k = m[O];
              if (k) return _.call(k);
            }
            if (this === Error) {
              const k = m[L];
              if (k) return _.call(k);
            }
          }
          return _.call(this);
        };
        U[d] = _, Function.prototype.toString = U;
        const Y = Object.prototype.toString;
        Object.prototype.toString = function() {
          return typeof Promise == "function" && this instanceof Promise ? "[object Promise]" : Y.call(this);
        };
      });
    }(f), function(E) {
      E.__load_patch("util", (m, _, d) => {
        const O = Yn(m);
        d.patchOnProperties = to, d.patchMethod = qt, d.bindArguments = lt, d.patchMacroTask = h_;
        const L = _.__symbol__("BLACK_LISTED_EVENTS"), U = _.__symbol__("UNPATCHED_EVENTS");
        m[U] && (m[L] = m[U]), m[L] && (_[L] = _[U] = m[L]), d.patchEventPrototype = y_, d.patchEventTarget = S_, d.isIEOrEdge = d_, d.ObjectDefineProperty = o, d.ObjectGetOwnPropertyDescriptor = r, d.ObjectCreate = a, d.ArraySlice = u, d.patchClass = Me, d.wrapWithCurrentZone = H, d.filterProperties = co, d.attachOriginToPatched = Qt, d._redefineProperty = Object.defineProperty, d.patchCallbacks = O_, d.getGlobalObjects = () => ({ globalSources: oo, zoneSymbolEventNames: Ct, eventNames: O, isBrowser: jn, isMix: Qr, isNode: jt, TRUE_STR: v, FALSE_STR: g, ZONE_SYMBOL_PREFIX: b, ADD_EVENT_LISTENER_STR: c, REMOVE_EVENT_LISTENER_STR: l });
      });
    }(f);
  })(po), function(f) {
    f.__load_patch("legacy", (E) => {
      const m = E[f.__symbol__("legacyPatch")];
      m && m();
    }), f.__load_patch("timers", (E) => {
      const m = "set", _ = "clear";
      ge(E, m, _, "Timeout"), ge(E, m, _, "Interval"), ge(E, m, _, "Immediate");
    }), f.__load_patch("requestAnimationFrame", (E) => {
      ge(E, "request", "cancel", "AnimationFrame"), ge(E, "mozRequest", "mozCancel", "AnimationFrame"), ge(E, "webkitRequest", "webkitCancel", "AnimationFrame");
    }), f.__load_patch("blocking", (E, m) => {
      const _ = ["alert", "prompt", "confirm"];
      for (let d = 0; d < _.length; d++)
        qt(E, _[d], (O, L, U) => function(Y, j) {
          return m.current.run(O, E, j, U);
        });
    }), f.__load_patch("EventTarget", (E, m, _) => {
      (function(O, L) {
        L.patchEventPrototype(O, L);
      })(E, _), m_(E, _);
      const d = E.XMLHttpRequestEventTarget;
      d && d.prototype && _.patchEventTarget(E, _, [d.prototype]);
    }), f.__load_patch("MutationObserver", (E, m, _) => {
      Me("MutationObserver"), Me("WebKitMutationObserver");
    }), f.__load_patch("IntersectionObserver", (E, m, _) => {
      Me("IntersectionObserver");
    }), f.__load_patch("FileReader", (E, m, _) => {
      Me("FileReader");
    }), f.__load_patch("on_property", (E, m, _) => {
      g_(_, E);
    }), f.__load_patch("customElements", (E, m, _) => {
      (function(d, O) {
        const { isBrowser: L, isMix: U } = O.getGlobalObjects();
        !L && !U || !d.customElements || !("customElements" in d) || O.patchCallbacks(O, d.customElements, "customElements", "define", ["connectedCallback", "disconnectedCallback", "adoptedCallback", "attributeChangedCallback", "formAssociatedCallback", "formDisabledCallback", "formResetCallback", "formStateRestoreCallback"]);
      })(E, _);
    }), f.__load_patch("XHR", (E, m) => {
      (function(j) {
        const k = j.XMLHttpRequest;
        if (!k) return;
        const W = k.prototype;
        let nt = W[s], at = W[p];
        if (!nt) {
          const R = j.XMLHttpRequestEventTarget;
          if (R) {
            const K = R.prototype;
            nt = K[s], at = K[p];
          }
        }
        const St = "readystatechange", At = "scheduled";
        function ft(R) {
          const K = R.data, I = K.target;
          I[L] = !1, I[Y] = !1;
          const Ot = I[O];
          nt || (nt = I[s], at = I[p]), Ot && at.call(I, St, Ot);
          const tt = I[O] = () => {
            if (I.readyState === I.DONE) if (!K.aborted && I[L] && R.state === At) {
              const Lt = I[m.__symbol__("loadfalse")];
              if (I.status !== 0 && Lt && Lt.length > 0) {
                const wt = R.invoke;
                R.invoke = function() {
                  const ht = I[m.__symbol__("loadfalse")];
                  for (let ot = 0; ot < ht.length; ot++) ht[ot] === R && ht.splice(ot, 1);
                  K.aborted || R.state !== At || wt.call(R);
                }, Lt.push(R);
              } else R.invoke();
            } else K.aborted || I[L] !== !1 || (I[Y] = !0);
          };
          return nt.call(I, St, tt), I[_] || (I[_] = R), Et.apply(I, K.args), I[L] = !0, R;
        }
        function pt() {
        }
        function z(R) {
          const K = R.data;
          return K.aborted = !0, rt.apply(K.target, K.args);
        }
        const D = qt(W, "open", () => function(R, K) {
          return R[d] = K[2] == 0, R[U] = K[1], D.apply(R, K);
        }), _t = N("fetchTaskAborting"), it = N("fetchTaskScheduling"), Et = qt(W, "send", () => function(R, K) {
          if (m.current[it] === !0 || R[d]) return Et.apply(R, K);
          {
            const I = { target: R, url: R[U], isPeriodic: !1, args: K, aborted: !1 }, Ot = P("XMLHttpRequest.send", pt, I, ft, z);
            R && R[Y] === !0 && !I.aborted && Ot.state === At && Ot.invoke();
          }
        }), rt = qt(W, "abort", () => function(R, K) {
          const I = R[_];
          if (I && typeof I.type == "string") {
            if (I.cancelFn == null || I.data && I.data.aborted) return;
            I.zone.cancelTask(I);
          } else if (m.current[_t] === !0) return rt.apply(R, K);
        });
      })(E);
      const _ = N("xhrTask"), d = N("xhrSync"), O = N("xhrListener"), L = N("xhrScheduled"), U = N("xhrURL"), Y = N("xhrErrorBeforeScheduled");
    }), f.__load_patch("geolocation", (E) => {
      E.navigator && E.navigator.geolocation && function(m, _) {
        const d = m.constructor.name;
        for (let O = 0; O < _.length; O++) {
          const L = _[O], U = m[L];
          if (U) {
            if (!xt(r(m, L))) continue;
            m[L] = ((Y) => {
              const j = function() {
                return Y.apply(this, lt(arguments, d + "." + L));
              };
              return Qt(j, Y), j;
            })(U);
          }
        }
      }(E.navigator.geolocation, ["getCurrentPosition", "watchPosition"]);
    }), f.__load_patch("PromiseRejectionEvent", (E, m) => {
      function _(d) {
        return function(O) {
          uo(E, d).forEach((L) => {
            const U = E.PromiseRejectionEvent;
            if (U) {
              const Y = new U(d, { promise: O.promise, reason: O.rejection });
              L.invoke(Y);
            }
          });
        };
      }
      E.PromiseRejectionEvent && (m[N("unhandledPromiseRejectionHandler")] = _("unhandledrejection"), m[N("rejectionHandledHandler")] = _("rejectionhandled"));
    }), f.__load_patch("queueMicrotask", (E, m, _) => {
      v_(E, _);
    });
  }(po);
})(), function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE";
}(Ht || (Ht = {})), function(e) {
  e[e.HISTOGRAM = 0] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 1] = "EXPONENTIAL_HISTOGRAM", e[e.GAUGE = 2] = "GAUGE", e[e.SUM = 3] = "SUM";
}(Xt || (Xt = {}));
var vd = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), qo = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, Qo = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, md = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, gd = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}, Ad = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function Od(e) {
  return e != null;
}
function Vf(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "" : (t = t.sort(), JSON.stringify(t.map(function(n) {
    return [n, e[n]];
  })));
}
var de, Bf = function(e) {
  function t(n) {
    var r = e.call(this, n) || this;
    return Object.setPrototypeOf(r, t.prototype), r;
  }
  return vd(t, e), t;
}(Error);
function Xe(e, t) {
  var n, r = new Promise(function(o, i) {
    n = setTimeout(function() {
      i(new Bf("Operation timed out."));
    }, t);
  });
  return Promise.race([e, r]).then(function(o) {
    return clearTimeout(n), o;
  }, function(o) {
    throw clearTimeout(n), o;
  });
}
function Rd(e) {
  return qo(this, void 0, void 0, function() {
    var t = this;
    return Qo(this, function(n) {
      return [2, Promise.all(e.map(function(r) {
        return qo(t, void 0, void 0, function() {
          return Qo(this, function(o) {
            switch (o.label) {
              case 0:
                return o.trys.push([0, 2, , 3]), [4, r];
              case 1:
                return [2, { status: "fulfilled", value: o.sent() }];
              case 2:
                return [2, { status: "rejected", reason: o.sent() }];
              case 3:
                return [2];
            }
          });
        });
      }))];
    });
  });
}
function bd(e) {
  return e.status === "rejected";
}
function Jo(e, t) {
  var n = [];
  return e.forEach(function(r) {
    n.push.apply(n, gd([], md(t(r)), !1));
  }), n;
}
(function(e) {
  e[e.DROP = 0] = "DROP", e[e.SUM = 1] = "SUM", e[e.LAST_VALUE = 2] = "LAST_VALUE", e[e.HISTOGRAM = 3] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 4] = "EXPONENTIAL_HISTOGRAM";
})(de || (de = {}));
var Q, Nd = function() {
  function e() {
    this.kind = de.DROP;
  }
  return e.prototype.createAccumulation = function() {
  }, e.prototype.merge = function(t, n) {
  }, e.prototype.diff = function(t, n) {
  }, e.prototype.toMetricData = function(t, n, r, o) {
  }, e;
}();
function ne(e, t, n) {
  var r, o, i, a;
  return function(u) {
    return u.match(Ld) != null;
  }(e) || w.warn('Invalid metric name: "' + e + '". The metric name should be a ASCII string with a length no greater than 255 characters.'), { name: e, type: t, description: (r = n?.description) !== null && r !== void 0 ? r : "", unit: (o = n?.unit) !== null && o !== void 0 ? o : "", valueType: (i = n?.valueType) !== null && i !== void 0 ? i : ae.DOUBLE, advice: (a = n?.advice) !== null && a !== void 0 ? a : {} };
}
(function(e) {
  e.COUNTER = "COUNTER", e.GAUGE = "GAUGE", e.HISTOGRAM = "HISTOGRAM", e.UP_DOWN_COUNTER = "UP_DOWN_COUNTER", e.OBSERVABLE_COUNTER = "OBSERVABLE_COUNTER", e.OBSERVABLE_GAUGE = "OBSERVABLE_GAUGE", e.OBSERVABLE_UP_DOWN_COUNTER = "OBSERVABLE_UP_DOWN_COUNTER";
})(Q || (Q = {}));
var Ld = /^[a-z][a-z0-9_.\-/]{0,254}$/i, Cd = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, _r = function() {
  function e(t, n, r, o) {
    var i, a;
    r === void 0 && (r = !0), o === void 0 && ((a = (i = n).map(function() {
      return 0;
    })).push(0), o = { buckets: { boundaries: i, counts: a }, sum: 0, count: 0, hasMinMax: !1, min: 1 / 0, max: -1 / 0 }), this.startTime = t, this._boundaries = n, this._recordMinMax = r, this._current = o;
  }
  return e.prototype.record = function(t) {
    if (!Number.isNaN(t)) {
      this._current.count += 1, this._current.sum += t, this._recordMinMax && (this._current.min = Math.min(t, this._current.min), this._current.max = Math.max(t, this._current.max), this._current.hasMinMax = !0);
      var n = function(r, o) {
        for (var i = 0, a = r.length - 1, u = r.length; a >= i; ) {
          var c = i + Math.trunc((a - i) / 2);
          r[c] < o ? i = c + 1 : (u = c, a = c - 1);
        }
        return u;
      }(this._boundaries, t);
      this._current.buckets.counts[n] += 1;
    }
  }, e.prototype.setStartTime = function(t) {
    this.startTime = t;
  }, e.prototype.toPointValue = function() {
    return this._current;
  }, e;
}(), Gf = function() {
  function e(t, n) {
    this._boundaries = t, this._recordMinMax = n, this.kind = de.HISTOGRAM;
  }
  return e.prototype.createAccumulation = function(t) {
    return new _r(t, this._boundaries, this._recordMinMax);
  }, e.prototype.merge = function(t, n) {
    for (var r = t.toPointValue(), o = n.toPointValue(), i = r.buckets.counts, a = o.buckets.counts, u = new Array(i.length), c = 0; c < i.length; c++) u[c] = i[c] + a[c];
    var l = 1 / 0, s = -1 / 0;
    return this._recordMinMax && (r.hasMinMax && o.hasMinMax ? (l = Math.min(r.min, o.min), s = Math.max(r.max, o.max)) : r.hasMinMax ? (l = r.min, s = r.max) : o.hasMinMax && (l = o.min, s = o.max)), new _r(t.startTime, r.buckets.boundaries, this._recordMinMax, { buckets: { boundaries: r.buckets.boundaries, counts: u }, count: r.count + o.count, sum: r.sum + o.sum, hasMinMax: this._recordMinMax && (r.hasMinMax || o.hasMinMax), min: l, max: s });
  }, e.prototype.diff = function(t, n) {
    for (var r = t.toPointValue(), o = n.toPointValue(), i = r.buckets.counts, a = o.buckets.counts, u = new Array(i.length), c = 0; c < i.length; c++) u[c] = a[c] - i[c];
    return new _r(n.startTime, r.buckets.boundaries, this._recordMinMax, { buckets: { boundaries: r.buckets.boundaries, counts: u }, count: o.count - r.count, sum: o.sum - r.sum, hasMinMax: !1, min: 1 / 0, max: -1 / 0 });
  }, e.prototype.toMetricData = function(t, n, r, o) {
    return { descriptor: t, aggregationTemporality: n, dataPointType: Xt.HISTOGRAM, dataPoints: r.map(function(i) {
      var a = Cd(i, 2), u = a[0], c = a[1], l = c.toPointValue(), s = t.type === Q.GAUGE || t.type === Q.UP_DOWN_COUNTER || t.type === Q.OBSERVABLE_GAUGE || t.type === Q.OBSERVABLE_UP_DOWN_COUNTER;
      return { attributes: u, startTime: c.startTime, endTime: o, value: { min: l.hasMinMax ? l.min : void 0, max: l.hasMinMax ? l.max : void 0, sum: s ? void 0 : l.sum, buckets: l.buckets, count: l.count } };
    }) };
  }, e;
}(), hr = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, Er = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}, $o = function() {
  function e(t, n, r, o) {
    t === void 0 && (t = new wd()), n === void 0 && (n = 0), r === void 0 && (r = 0), o === void 0 && (o = 0), this.backing = t, this.indexBase = n, this.indexStart = r, this.indexEnd = o;
  }
  return Object.defineProperty(e.prototype, "offset", { get: function() {
    return this.indexStart;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "length", { get: function() {
    return this.backing.length === 0 || this.indexEnd === this.indexStart && this.at(0) === 0 ? 0 : this.indexEnd - this.indexStart + 1;
  }, enumerable: !1, configurable: !0 }), e.prototype.counts = function() {
    var t = this;
    return Array.from({ length: this.length }, function(n, r) {
      return t.at(r);
    });
  }, e.prototype.at = function(t) {
    var n = this.indexBase - this.indexStart;
    return t < n && (t += this.backing.length), t -= n, this.backing.countAt(t);
  }, e.prototype.incrementBucket = function(t, n) {
    this.backing.increment(t, n);
  }, e.prototype.decrementBucket = function(t, n) {
    this.backing.decrement(t, n);
  }, e.prototype.trim = function() {
    for (var t = 0; t < this.length; t++) {
      if (this.at(t) !== 0) {
        this.indexStart += t;
        break;
      }
      if (t === this.length - 1) return void (this.indexStart = this.indexEnd = this.indexBase = 0);
    }
    for (t = this.length - 1; t >= 0; t--) if (this.at(t) !== 0) {
      this.indexEnd -= this.length - t - 1;
      break;
    }
    this._rotate();
  }, e.prototype.downscale = function(t) {
    this._rotate();
    for (var n = 1 + this.indexEnd - this.indexStart, r = 1 << t, o = 0, i = 0, a = this.indexStart; a <= this.indexEnd; ) {
      var u = a % r;
      u < 0 && (u += r);
      for (var c = u; c < r && o < n; c++) this._relocateBucket(i, o), o++, a++;
      i++;
    }
    this.indexStart >>= t, this.indexEnd >>= t, this.indexBase = this.indexStart;
  }, e.prototype.clone = function() {
    return new e(this.backing.clone(), this.indexBase, this.indexStart, this.indexEnd);
  }, e.prototype._rotate = function() {
    var t = this.indexBase - this.indexStart;
    t !== 0 && (t > 0 ? (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, t), this.backing.reverse(t, this.backing.length)) : (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, this.backing.length + t)), this.indexBase = this.indexStart);
  }, e.prototype._relocateBucket = function(t, n) {
    t !== n && this.incrementBucket(t, this.backing.emptyBucket(n));
  }, e;
}(), wd = function() {
  function e(t) {
    t === void 0 && (t = [0]), this._counts = t;
  }
  return Object.defineProperty(e.prototype, "length", { get: function() {
    return this._counts.length;
  }, enumerable: !1, configurable: !0 }), e.prototype.countAt = function(t) {
    return this._counts[t];
  }, e.prototype.growTo = function(t, n, r) {
    var o = new Array(t).fill(0);
    o.splice.apply(o, Er([r, this._counts.length - n], hr(this._counts.slice(n)), !1)), o.splice.apply(o, Er([0, n], hr(this._counts.slice(0, n)), !1)), this._counts = o;
  }, e.prototype.reverse = function(t, n) {
    for (var r = Math.floor((t + n) / 2) - t, o = 0; o < r; o++) {
      var i = this._counts[t + o];
      this._counts[t + o] = this._counts[n - o - 1], this._counts[n - o - 1] = i;
    }
  }, e.prototype.emptyBucket = function(t) {
    var n = this._counts[t];
    return this._counts[t] = 0, n;
  }, e.prototype.increment = function(t, n) {
    this._counts[t] += n;
  }, e.prototype.decrement = function(t, n) {
    this._counts[t] >= n ? this._counts[t] -= n : this._counts[t] = 0;
  }, e.prototype.clone = function() {
    return new e(Er([], hr(this._counts), !1));
  }, e;
}(), Ir = Math.pow(2, -1022);
function Hf(e) {
  var t = new DataView(new ArrayBuffer(8));
  return t.setFloat64(0, e), ((2146435072 & t.getUint32(0)) >> 20) - 1023;
}
function jf(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var n = t.getUint32(0), r = t.getUint32(4);
  return (1048575 & n) * Math.pow(2, 32) + r;
}
function Dr(e, t) {
  return e === 0 || e === Number.POSITIVE_INFINITY || e === Number.NEGATIVE_INFINITY || Number.isNaN(e) ? e : e * Math.pow(2, t);
}
var Md = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), We = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Md(t, e), t;
}(Error), Pd = function() {
  function e(t) {
    this._shift = -t;
  }
  return e.prototype.mapToIndex = function(t) {
    return t < Ir ? this._minNormalLowerBoundaryIndex() : Hf(t) + this._rightShift(jf(t) - 1, 52) >> this._shift;
  }, e.prototype.lowerBoundary = function(t) {
    var n = this._minNormalLowerBoundaryIndex();
    if (t < n) throw new We("underflow: " + t + " is < minimum lower boundary: " + n);
    var r = this._maxNormalLowerBoundaryIndex();
    if (t > r) throw new We("overflow: " + t + " is > maximum lower boundary: " + r);
    return Dr(1, t << this._shift);
  }, Object.defineProperty(e.prototype, "scale", { get: function() {
    return this._shift === 0 ? 0 : -this._shift;
  }, enumerable: !1, configurable: !0 }), e.prototype._minNormalLowerBoundaryIndex = function() {
    var t = -1022 >> this._shift;
    return this._shift < 2 && t--, t;
  }, e.prototype._maxNormalLowerBoundaryIndex = function() {
    return 1023 >> this._shift;
  }, e.prototype._rightShift = function(t, n) {
    return Math.floor(t * Math.pow(2, -n));
  }, e;
}(), Id = function() {
  function e(t) {
    this._scale = t, this._scaleFactor = Dr(Math.LOG2E, t), this._inverseFactor = Dr(Math.LN2, -t);
  }
  return e.prototype.mapToIndex = function(t) {
    if (t <= Ir) return this._minNormalLowerBoundaryIndex() - 1;
    if (jf(t) === 0) return (Hf(t) << this._scale) - 1;
    var n = Math.floor(Math.log(t) * this._scaleFactor), r = this._maxNormalLowerBoundaryIndex();
    return n >= r ? r : n;
  }, e.prototype.lowerBoundary = function(t) {
    var n = this._maxNormalLowerBoundaryIndex();
    if (t >= n) {
      if (t === n) return 2 * Math.exp((t - (1 << this._scale)) / this._scaleFactor);
      throw new We("overflow: " + t + " is > maximum lower boundary: " + n);
    }
    var r = this._minNormalLowerBoundaryIndex();
    if (t <= r) {
      if (t === r) return Ir;
      if (t === r - 1) return Math.exp((t + (1 << this._scale)) / this._scaleFactor) / 2;
      throw new We("overflow: " + t + " is < minimum lower boundary: " + r);
    }
    return Math.exp(t * this._inverseFactor);
  }, Object.defineProperty(e.prototype, "scale", { get: function() {
    return this._scale;
  }, enumerable: !1, configurable: !0 }), e.prototype._minNormalLowerBoundaryIndex = function() {
    return -1022 << this._scale;
  }, e.prototype._maxNormalLowerBoundaryIndex = function() {
    return (1024 << this._scale) - 1;
  }, e;
}(), Dd = Array.from({ length: 31 }, function(e, t) {
  return t > 10 ? new Id(t - 10) : new Pd(t - 10);
});
function ti(e) {
  if (e > 20 || e < -10) throw new We("expected scale >= -10 && <= 20, got: " + e);
  return Dd[e + 10];
}
var Ud = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, ln = function() {
  function e(t, n) {
    this.low = t, this.high = n;
  }
  return e.combine = function(t, n) {
    return new e(Math.min(t.low, n.low), Math.max(t.high, n.high));
  }, e;
}(), kd = function() {
  function e(t, n, r, o, i, a, u, c, l, s, p) {
    n === void 0 && (n = 160), r === void 0 && (r = !0), o === void 0 && (o = 0), i === void 0 && (i = 0), a === void 0 && (a = 0), u === void 0 && (u = Number.POSITIVE_INFINITY), c === void 0 && (c = Number.NEGATIVE_INFINITY), l === void 0 && (l = new $o()), s === void 0 && (s = new $o()), p === void 0 && (p = ti(20)), this.startTime = t, this._maxSize = n, this._recordMinMax = r, this._sum = o, this._count = i, this._zeroCount = a, this._min = u, this._max = c, this._positive = l, this._negative = s, this._mapping = p, this._maxSize < 2 && (w.warn("Exponential Histogram Max Size set to " + this._maxSize + ",                 changing to the minimum size of: 2"), this._maxSize = 2);
  }
  return e.prototype.record = function(t) {
    this.updateByIncrement(t, 1);
  }, e.prototype.setStartTime = function(t) {
    this.startTime = t;
  }, e.prototype.toPointValue = function() {
    return { hasMinMax: this._recordMinMax, min: this.min, max: this.max, sum: this.sum, positive: { offset: this.positive.offset, bucketCounts: this.positive.counts() }, negative: { offset: this.negative.offset, bucketCounts: this.negative.counts() }, count: this.count, scale: this.scale, zeroCount: this.zeroCount };
  }, Object.defineProperty(e.prototype, "sum", { get: function() {
    return this._sum;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "min", { get: function() {
    return this._min;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "max", { get: function() {
    return this._max;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "count", { get: function() {
    return this._count;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "zeroCount", { get: function() {
    return this._zeroCount;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "scale", { get: function() {
    return this._count === this._zeroCount ? 0 : this._mapping.scale;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "positive", { get: function() {
    return this._positive;
  }, enumerable: !1, configurable: !0 }), Object.defineProperty(e.prototype, "negative", { get: function() {
    return this._negative;
  }, enumerable: !1, configurable: !0 }), e.prototype.updateByIncrement = function(t, n) {
    Number.isNaN(t) || (t > this._max && (this._max = t), t < this._min && (this._min = t), this._count += n, t !== 0 ? (this._sum += t * n, t > 0 ? this._updateBuckets(this._positive, t, n) : this._updateBuckets(this._negative, -t, n)) : this._zeroCount += n);
  }, e.prototype.merge = function(t) {
    this._count === 0 ? (this._min = t.min, this._max = t.max) : t.count !== 0 && (t.min < this.min && (this._min = t.min), t.max > this.max && (this._max = t.max)), this.startTime = t.startTime, this._sum += t.sum, this._count += t.count, this._zeroCount += t.zeroCount;
    var n = this._minScale(t);
    this._downscale(this.scale - n), this._mergeBuckets(this.positive, t, t.positive, n), this._mergeBuckets(this.negative, t, t.negative, n);
  }, e.prototype.diff = function(t) {
    this._min = 1 / 0, this._max = -1 / 0, this._sum -= t.sum, this._count -= t.count, this._zeroCount -= t.zeroCount;
    var n = this._minScale(t);
    this._downscale(this.scale - n), this._diffBuckets(this.positive, t, t.positive, n), this._diffBuckets(this.negative, t, t.negative, n);
  }, e.prototype.clone = function() {
    return new e(this.startTime, this._maxSize, this._recordMinMax, this._sum, this._count, this._zeroCount, this._min, this._max, this.positive.clone(), this.negative.clone(), this._mapping);
  }, e.prototype._updateBuckets = function(t, n, r) {
    var o = this._mapping.mapToIndex(n), i = !1, a = 0, u = 0;
    if (t.length === 0 ? (t.indexStart = o, t.indexEnd = t.indexStart, t.indexBase = t.indexStart) : o < t.indexStart && t.indexEnd - o >= this._maxSize ? (i = !0, u = o, a = t.indexEnd) : o > t.indexEnd && o - t.indexStart >= this._maxSize && (i = !0, u = t.indexStart, a = o), i) {
      var c = this._changeScale(a, u);
      this._downscale(c), o = this._mapping.mapToIndex(n);
    }
    this._incrementIndexBy(t, o, r);
  }, e.prototype._incrementIndexBy = function(t, n, r) {
    if (r !== 0) {
      if (t.length === 0 && (t.indexStart = t.indexEnd = t.indexBase = n), n < t.indexStart) (o = t.indexEnd - n) >= t.backing.length && this._grow(t, o + 1), t.indexStart = n;
      else if (n > t.indexEnd) {
        var o;
        (o = n - t.indexStart) >= t.backing.length && this._grow(t, o + 1), t.indexEnd = n;
      }
      var i = n - t.indexBase;
      i < 0 && (i += t.backing.length), t.incrementBucket(i, r);
    }
  }, e.prototype._grow = function(t, n) {
    var r = t.backing.length, o = t.indexBase - t.indexStart, i = r - o, a = function(c) {
      return c--, c |= c >> 1, c |= c >> 2, c |= c >> 4, c |= c >> 8, c |= c >> 16, ++c;
    }(n);
    a > this._maxSize && (a = this._maxSize);
    var u = a - o;
    t.backing.growTo(a, i, u);
  }, e.prototype._changeScale = function(t, n) {
    for (var r = 0; t - n >= this._maxSize; ) t >>= 1, n >>= 1, r++;
    return r;
  }, e.prototype._downscale = function(t) {
    if (t !== 0) {
      if (t < 0) throw new Error("impossible change of scale: " + this.scale);
      var n = this._mapping.scale - t;
      this._positive.downscale(t), this._negative.downscale(t), this._mapping = ti(n);
    }
  }, e.prototype._minScale = function(t) {
    var n = Math.min(this.scale, t.scale), r = ln.combine(this._highLowAtScale(this.positive, this.scale, n), this._highLowAtScale(t.positive, t.scale, n)), o = ln.combine(this._highLowAtScale(this.negative, this.scale, n), this._highLowAtScale(t.negative, t.scale, n));
    return Math.min(n - this._changeScale(r.high, r.low), n - this._changeScale(o.high, o.low));
  }, e.prototype._highLowAtScale = function(t, n, r) {
    if (t.length === 0) return new ln(0, -1);
    var o = n - r;
    return new ln(t.indexStart >> o, t.indexEnd >> o);
  }, e.prototype._mergeBuckets = function(t, n, r, o) {
    for (var i = r.offset, a = n.scale - o, u = 0; u < r.length; u++) this._incrementIndexBy(t, i + u >> a, r.at(u));
  }, e.prototype._diffBuckets = function(t, n, r, o) {
    for (var i = r.offset, a = n.scale - o, u = 0; u < r.length; u++) {
      var c = (i + u >> a) - t.indexBase;
      c < 0 && (c += t.backing.length), t.decrementBucket(c, r.at(u));
    }
    t.trim();
  }, e;
}(), xd = function() {
  function e(t, n) {
    this._maxSize = t, this._recordMinMax = n, this.kind = de.EXPONENTIAL_HISTOGRAM;
  }
  return e.prototype.createAccumulation = function(t) {
    return new kd(t, this._maxSize, this._recordMinMax);
  }, e.prototype.merge = function(t, n) {
    var r = n.clone();
    return r.merge(t), r;
  }, e.prototype.diff = function(t, n) {
    var r = n.clone();
    return r.diff(t), r;
  }, e.prototype.toMetricData = function(t, n, r, o) {
    return { descriptor: t, aggregationTemporality: n, dataPointType: Xt.EXPONENTIAL_HISTOGRAM, dataPoints: r.map(function(i) {
      var a = Ud(i, 2), u = a[0], c = a[1], l = c.toPointValue(), s = t.type === Q.GAUGE || t.type === Q.UP_DOWN_COUNTER || t.type === Q.OBSERVABLE_GAUGE || t.type === Q.OBSERVABLE_UP_DOWN_COUNTER;
      return { attributes: u, startTime: c.startTime, endTime: o, value: { min: l.hasMinMax ? l.min : void 0, max: l.hasMinMax ? l.max : void 0, sum: s ? void 0 : l.sum, positive: { offset: l.positive.offset, bucketCounts: l.positive.bucketCounts }, negative: { offset: l.negative.offset, bucketCounts: l.negative.bucketCounts }, count: l.count, scale: l.scale, zeroCount: l.zeroCount } };
    }) };
  }, e;
}(), Vd = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, dr = function() {
  function e(t, n, r) {
    n === void 0 && (n = 0), r === void 0 && (r = [0, 0]), this.startTime = t, this._current = n, this.sampleTime = r;
  }
  return e.prototype.record = function(t) {
    this._current = t, this.sampleTime = Dt(Date.now());
  }, e.prototype.setStartTime = function(t) {
    this.startTime = t;
  }, e.prototype.toPointValue = function() {
    return this._current;
  }, e;
}(), Bd = function() {
  function e() {
    this.kind = de.LAST_VALUE;
  }
  return e.prototype.createAccumulation = function(t) {
    return new dr(t);
  }, e.prototype.merge = function(t, n) {
    var r = on(n.sampleTime) >= on(t.sampleTime) ? n : t;
    return new dr(t.startTime, r.toPointValue(), r.sampleTime);
  }, e.prototype.diff = function(t, n) {
    var r = on(n.sampleTime) >= on(t.sampleTime) ? n : t;
    return new dr(n.startTime, r.toPointValue(), r.sampleTime);
  }, e.prototype.toMetricData = function(t, n, r, o) {
    return { descriptor: t, aggregationTemporality: n, dataPointType: Xt.GAUGE, dataPoints: r.map(function(i) {
      var a = Vd(i, 2), u = a[0], c = a[1];
      return { attributes: u, startTime: c.startTime, endTime: o, value: c.toPointValue() };
    }) };
  }, e;
}(), Gd = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, Ve = function() {
  function e(t, n, r, o) {
    r === void 0 && (r = 0), o === void 0 && (o = !1), this.startTime = t, this.monotonic = n, this._current = r, this.reset = o;
  }
  return e.prototype.record = function(t) {
    this.monotonic && t < 0 || (this._current += t);
  }, e.prototype.setStartTime = function(t) {
    this.startTime = t;
  }, e.prototype.toPointValue = function() {
    return this._current;
  }, e;
}(), ei = function() {
  function e(t) {
    this.monotonic = t, this.kind = de.SUM;
  }
  return e.prototype.createAccumulation = function(t) {
    return new Ve(t, this.monotonic);
  }, e.prototype.merge = function(t, n) {
    var r = t.toPointValue(), o = n.toPointValue();
    return n.reset ? new Ve(n.startTime, this.monotonic, o, n.reset) : new Ve(t.startTime, this.monotonic, r + o);
  }, e.prototype.diff = function(t, n) {
    var r = t.toPointValue(), o = n.toPointValue();
    return this.monotonic && r > o ? new Ve(n.startTime, this.monotonic, o, !0) : new Ve(n.startTime, this.monotonic, o - r);
  }, e.prototype.toMetricData = function(t, n, r, o) {
    return { descriptor: t, aggregationTemporality: n, dataPointType: Xt.SUM, dataPoints: r.map(function(i) {
      var a = Gd(i, 2), u = a[0], c = a[1];
      return { attributes: u, startTime: c.startTime, endTime: o, value: c.toPointValue() };
    }), isMonotonic: this.monotonic };
  }, e;
}(), Se = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ee = function() {
  function e() {
  }
  return e.Drop = function() {
    return Ff;
  }, e.Sum = function() {
    return Yf;
  }, e.LastValue = function() {
    return zf;
  }, e.Histogram = function() {
    return Zf;
  }, e.ExponentialHistogram = function() {
    return Wd;
  }, e.Default = function() {
    return Kd;
  }, e;
}(), Hd = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Se(t, e), t.prototype.createAggregator = function(n) {
    return t.DEFAULT_INSTANCE;
  }, t.DEFAULT_INSTANCE = new Nd(), t;
}(ee), jd = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Se(t, e), t.prototype.createAggregator = function(n) {
    switch (n.type) {
      case Q.COUNTER:
      case Q.OBSERVABLE_COUNTER:
      case Q.HISTOGRAM:
        return t.MONOTONIC_INSTANCE;
      default:
        return t.NON_MONOTONIC_INSTANCE;
    }
  }, t.MONOTONIC_INSTANCE = new ei(!0), t.NON_MONOTONIC_INSTANCE = new ei(!1), t;
}(ee), Fd = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Se(t, e), t.prototype.createAggregator = function(n) {
    return t.DEFAULT_INSTANCE;
  }, t.DEFAULT_INSTANCE = new Bd(), t;
}(ee), Yd = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Se(t, e), t.prototype.createAggregator = function(n) {
    return t.DEFAULT_INSTANCE;
  }, t.DEFAULT_INSTANCE = new Gf([0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4], !0), t;
}(ee), zd = function(e) {
  function t(n, r) {
    r === void 0 && (r = !0);
    var o = e.call(this) || this;
    if (o._recordMinMax = r, n == null) throw new Error("ExplicitBucketHistogramAggregation should be created with explicit boundaries, if a single bucket histogram is required, please pass an empty array");
    n = (n = n.concat()).sort(function(u, c) {
      return u - c;
    });
    var i = n.lastIndexOf(-1 / 0), a = n.indexOf(1 / 0);
    return a === -1 && (a = void 0), o._boundaries = n.slice(i + 1, a), o;
  }
  return Se(t, e), t.prototype.createAggregator = function(n) {
    return new Gf(this._boundaries, this._recordMinMax);
  }, t;
}(ee), Zd = function(e) {
  function t(n, r) {
    n === void 0 && (n = 160), r === void 0 && (r = !0);
    var o = e.call(this) || this;
    return o._maxSize = n, o._recordMinMax = r, o;
  }
  return Se(t, e), t.prototype.createAggregator = function(n) {
    return new xd(this._maxSize, this._recordMinMax);
  }, t;
}(ee), Xd = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return Se(t, e), t.prototype._resolve = function(n) {
    switch (n.type) {
      case Q.COUNTER:
      case Q.UP_DOWN_COUNTER:
      case Q.OBSERVABLE_COUNTER:
      case Q.OBSERVABLE_UP_DOWN_COUNTER:
        return Yf;
      case Q.GAUGE:
      case Q.OBSERVABLE_GAUGE:
        return zf;
      case Q.HISTOGRAM:
        return n.advice.explicitBucketBoundaries ? new zd(n.advice.explicitBucketBoundaries) : Zf;
    }
    return w.warn("Unable to recognize instrument type: " + n.type), Ff;
  }, t.prototype.createAggregator = function(n) {
    return this._resolve(n).createAggregator(n);
  }, t;
}(ee), Ff = new Hd(), Yf = new jd(), zf = new Fd(), Zf = new Yd(), Wd = new Zd(), Kd = new Xd(), qd = function(e) {
  return ee.Default();
}, Qd = function(e) {
  return Ht.CUMULATIVE;
}, Tr = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, Sr = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, ni = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, Jd = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}, $d = function() {
  function e(t) {
    var n, r, o;
    this._shutdown = !1, this._aggregationSelector = (n = t?.aggregationSelector) !== null && n !== void 0 ? n : qd, this._aggregationTemporalitySelector = (r = t?.aggregationTemporalitySelector) !== null && r !== void 0 ? r : Qd, this._metricProducers = (o = t?.metricProducers) !== null && o !== void 0 ? o : [], this._cardinalitySelector = t?.cardinalitySelector;
  }
  return e.prototype.setMetricProducer = function(t) {
    if (this._sdkMetricProducer) throw new Error("MetricReader can not be bound to a MeterProvider again.");
    this._sdkMetricProducer = t, this.onInitialized();
  }, e.prototype.selectAggregation = function(t) {
    return this._aggregationSelector(t);
  }, e.prototype.selectAggregationTemporality = function(t) {
    return this._aggregationTemporalitySelector(t);
  }, e.prototype.selectCardinalityLimit = function(t) {
    return this._cardinalitySelector ? this._cardinalitySelector(t) : 2e3;
  }, e.prototype.onInitialized = function() {
  }, e.prototype.collect = function(t) {
    return Tr(this, void 0, void 0, function() {
      var n, r, o, i, a, u;
      return Sr(this, function(c) {
        switch (c.label) {
          case 0:
            if (this._sdkMetricProducer === void 0) throw new Error("MetricReader is not bound to a MetricProducer");
            if (this._shutdown) throw new Error("MetricReader is shutdown");
            return [4, Promise.all(Jd([this._sdkMetricProducer.collect({ timeoutMillis: t?.timeoutMillis })], ni(this._metricProducers.map(function(l) {
              return l.collect({ timeoutMillis: t?.timeoutMillis });
            })), !1))];
          case 1:
            return n = ni.apply(void 0, [c.sent()]), r = n[0], o = n.slice(1), i = r.errors.concat(Jo(o, function(l) {
              return l.errors;
            })), a = r.resourceMetrics.resource, u = r.resourceMetrics.scopeMetrics.concat(Jo(o, function(l) {
              return l.resourceMetrics.scopeMetrics;
            })), [2, { resourceMetrics: { resource: a, scopeMetrics: u }, errors: i }];
        }
      });
    });
  }, e.prototype.shutdown = function(t) {
    return Tr(this, void 0, void 0, function() {
      return Sr(this, function(n) {
        switch (n.label) {
          case 0:
            return this._shutdown ? (w.error("Cannot call shutdown twice."), [2]) : t?.timeoutMillis != null ? [3, 2] : [4, this.onShutdown()];
          case 1:
            return n.sent(), [3, 4];
          case 2:
            return [4, Xe(this.onShutdown(), t.timeoutMillis)];
          case 3:
            n.sent(), n.label = 4;
          case 4:
            return this._shutdown = !0, [2];
        }
      });
    });
  }, e.prototype.forceFlush = function(t) {
    return Tr(this, void 0, void 0, function() {
      return Sr(this, function(n) {
        switch (n.label) {
          case 0:
            return this._shutdown ? (w.warn("Cannot forceFlush on already shutdown MetricReader."), [2]) : t?.timeoutMillis != null ? [3, 2] : [4, this.onForceFlush()];
          case 1:
          case 3:
            return n.sent(), [2];
          case 2:
            return [4, Xe(this.onForceFlush(), t.timeoutMillis)];
        }
      });
    });
  }, e;
}(), tT = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), pn = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, fn = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, eT = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, nT = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}, UL = function(e) {
  function t(n) {
    var r, o, i, a, u = e.call(this, { aggregationSelector: (r = n.exporter.selectAggregation) === null || r === void 0 ? void 0 : r.bind(n.exporter), aggregationTemporalitySelector: (o = n.exporter.selectAggregationTemporality) === null || o === void 0 ? void 0 : o.bind(n.exporter), metricProducers: n.metricProducers }) || this;
    if (n.exportIntervalMillis !== void 0 && n.exportIntervalMillis <= 0) throw Error("exportIntervalMillis must be greater than 0");
    if (n.exportTimeoutMillis !== void 0 && n.exportTimeoutMillis <= 0) throw Error("exportTimeoutMillis must be greater than 0");
    if (n.exportTimeoutMillis !== void 0 && n.exportIntervalMillis !== void 0 && n.exportIntervalMillis < n.exportTimeoutMillis) throw Error("exportIntervalMillis must be greater than or equal to exportTimeoutMillis");
    return u._exportInterval = (i = n.exportIntervalMillis) !== null && i !== void 0 ? i : 6e4, u._exportTimeout = (a = n.exportTimeoutMillis) !== null && a !== void 0 ? a : 3e4, u._exporter = n.exporter, u;
  }
  return tT(t, e), t.prototype._runOnce = function() {
    return pn(this, void 0, void 0, function() {
      var n;
      return fn(this, function(r) {
        switch (r.label) {
          case 0:
            return r.trys.push([0, 2, , 3]), [4, Xe(this._doRun(), this._exportTimeout)];
          case 1:
            return r.sent(), [3, 3];
          case 2:
            return (n = r.sent()) instanceof Bf ? (w.error("Export took longer than %s milliseconds and timed out.", this._exportTimeout), [2]) : (Gt(n), [3, 3]);
          case 3:
            return [2];
        }
      });
    });
  }, t.prototype._doRun = function() {
    var n, r;
    return pn(this, void 0, void 0, function() {
      var o, i, a, u, c, l;
      return fn(this, function(s) {
        switch (s.label) {
          case 0:
            return [4, this.collect({ timeoutMillis: this._exportTimeout })];
          case 1:
            if (o = s.sent(), i = o.resourceMetrics, (a = o.errors).length > 0 && (l = w).error.apply(l, nT(["PeriodicExportingMetricReader: metrics collection errors"], eT(a), !1)), !i.resource.asyncAttributesPending) return [3, 5];
            s.label = 2;
          case 2:
            return s.trys.push([2, 4, , 5]), [4, (r = (n = i.resource).waitForAsyncAttributes) === null || r === void 0 ? void 0 : r.call(n)];
          case 3:
            return s.sent(), [3, 5];
          case 4:
            return u = s.sent(), w.debug("Error while resolving async portion of resource: ", u), Gt(u), [3, 5];
          case 5:
            return i.scopeMetrics.length === 0 ? [2] : [4, $i._export(this._exporter, i)];
          case 6:
            if ((c = s.sent()).code !== Mt.SUCCESS) throw new Error("PeriodicExportingMetricReader: metrics export failed (error " + c.error + ")");
            return [2];
        }
      });
    });
  }, t.prototype.onInitialized = function() {
    var n = this;
    this._interval = setInterval(function() {
      n._runOnce();
    }, this._exportInterval), this._interval;
  }, t.prototype.onForceFlush = function() {
    return pn(this, void 0, void 0, function() {
      return fn(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, this._runOnce()];
          case 1:
            return n.sent(), [4, this._exporter.forceFlush()];
          case 2:
            return n.sent(), [2];
        }
      });
    });
  }, t.prototype.onShutdown = function() {
    return pn(this, void 0, void 0, function() {
      return fn(this, function(n) {
        switch (n.label) {
          case 0:
            return this._interval && clearInterval(this._interval), [4, this.onForceFlush()];
          case 1:
            return n.sent(), [4, this._exporter.shutdown()];
          case 2:
            return n.sent(), [2];
        }
      });
    });
  }, t;
}($d), rT = function() {
  function e() {
    this._registeredViews = [];
  }
  return e.prototype.addView = function(t) {
    this._registeredViews.push(t);
  }, e.prototype.findViews = function(t, n) {
    var r = this;
    return this._registeredViews.filter(function(o) {
      return r._matchInstrument(o.instrumentSelector, t) && r._matchMeter(o.meterSelector, n);
    });
  }, e.prototype._matchInstrument = function(t, n) {
    return (t.getType() === void 0 || n.type === t.getType()) && t.getNameFilter().match(n.name) && t.getUnitFilter().match(n.unit);
  }, e.prototype._matchMeter = function(t, n) {
    return t.getNameFilter().match(n.name) && (n.version === void 0 || t.getVersionFilter().match(n.version)) && (n.schemaUrl === void 0 || t.getSchemaUrlFilter().match(n.schemaUrl));
  }, e;
}(), ye = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Vn = function() {
  function e(t, n) {
    this._writableMetricStorage = t, this._descriptor = n;
  }
  return e.prototype._record = function(t, n, r) {
    n === void 0 && (n = {}), r === void 0 && (r = $.active()), typeof t == "number" ? (this._descriptor.valueType !== ae.INT || Number.isInteger(t) || (w.warn("INT value type cannot accept a floating-point value for " + this._descriptor.name + ", ignoring the fractional digits."), t = Math.trunc(t), Number.isInteger(t))) && this._writableMetricStorage.record(t, n, r, Dt(Date.now())) : w.warn("non-number value provided to metric " + this._descriptor.name + ": " + t);
  }, e;
}(), oT = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return ye(t, e), t.prototype.add = function(n, r, o) {
    this._record(n, r, o);
  }, t;
}(Vn), iT = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return ye(t, e), t.prototype.add = function(n, r, o) {
    n < 0 ? w.warn("negative value provided to counter " + this._descriptor.name + ": " + n) : this._record(n, r, o);
  }, t;
}(Vn), aT = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return ye(t, e), t.prototype.record = function(n, r, o) {
    this._record(n, r, o);
  }, t;
}(Vn), sT = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return ye(t, e), t.prototype.record = function(n, r, o) {
    n < 0 ? w.warn("negative value provided to histogram " + this._descriptor.name + ": " + n) : this._record(n, r, o);
  }, t;
}(Vn), Bn = function() {
  function e(t, n, r) {
    this._observableRegistry = r, this._descriptor = t, this._metricStorages = n;
  }
  return e.prototype.addCallback = function(t) {
    this._observableRegistry.addCallback(t, this);
  }, e.prototype.removeCallback = function(t) {
    this._observableRegistry.removeCallback(t, this);
  }, e;
}(), uT = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return ye(t, e), t;
}(Bn), cT = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return ye(t, e), t;
}(Bn), lT = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return ye(t, e), t;
}(Bn);
function Ur(e) {
  return e instanceof Bn;
}
var pT = function() {
  function e(t) {
    this._meterSharedState = t;
  }
  return e.prototype.createGauge = function(t, n) {
    var r = ne(t, Q.GAUGE, n), o = this._meterSharedState.registerMetricStorage(r);
    return new aT(o, r);
  }, e.prototype.createHistogram = function(t, n) {
    var r = ne(t, Q.HISTOGRAM, n), o = this._meterSharedState.registerMetricStorage(r);
    return new sT(o, r);
  }, e.prototype.createCounter = function(t, n) {
    var r = ne(t, Q.COUNTER, n), o = this._meterSharedState.registerMetricStorage(r);
    return new iT(o, r);
  }, e.prototype.createUpDownCounter = function(t, n) {
    var r = ne(t, Q.UP_DOWN_COUNTER, n), o = this._meterSharedState.registerMetricStorage(r);
    return new oT(o, r);
  }, e.prototype.createObservableGauge = function(t, n) {
    var r = ne(t, Q.OBSERVABLE_GAUGE, n), o = this._meterSharedState.registerAsyncMetricStorage(r);
    return new cT(r, o, this._meterSharedState.observableRegistry);
  }, e.prototype.createObservableCounter = function(t, n) {
    var r = ne(t, Q.OBSERVABLE_COUNTER, n), o = this._meterSharedState.registerAsyncMetricStorage(r);
    return new uT(r, o, this._meterSharedState.observableRegistry);
  }, e.prototype.createObservableUpDownCounter = function(t, n) {
    var r = ne(t, Q.OBSERVABLE_UP_DOWN_COUNTER, n), o = this._meterSharedState.registerAsyncMetricStorage(r);
    return new lT(r, o, this._meterSharedState.observableRegistry);
  }, e.prototype.addBatchObservableCallback = function(t, n) {
    this._meterSharedState.observableRegistry.addBatchCallback(t, n);
  }, e.prototype.removeBatchObservableCallback = function(t, n) {
    this._meterSharedState.observableRegistry.removeBatchCallback(t, n);
  }, e;
}(), Xf = function() {
  function e(t) {
    this._instrumentDescriptor = t;
  }
  return e.prototype.getInstrumentDescriptor = function() {
    return this._instrumentDescriptor;
  }, e.prototype.updateDescription = function(t) {
    this._instrumentDescriptor = ne(this._instrumentDescriptor.name, this._instrumentDescriptor.type, { description: t, valueType: this._instrumentDescriptor.valueType, unit: this._instrumentDescriptor.unit, advice: this._instrumentDescriptor.advice });
  }, e;
}(), fT = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ri = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, _T = function() {
  function e(t) {
    this._hash = t, this._valueMap = /* @__PURE__ */ new Map(), this._keyMap = /* @__PURE__ */ new Map();
  }
  return e.prototype.get = function(t, n) {
    return n != null || (n = this._hash(t)), this._valueMap.get(n);
  }, e.prototype.getOrDefault = function(t, n) {
    var r = this._hash(t);
    if (this._valueMap.has(r)) return this._valueMap.get(r);
    var o = n();
    return this._keyMap.has(r) || this._keyMap.set(r, t), this._valueMap.set(r, o), o;
  }, e.prototype.set = function(t, n, r) {
    r != null || (r = this._hash(t)), this._keyMap.has(r) || this._keyMap.set(r, t), this._valueMap.set(r, n);
  }, e.prototype.has = function(t, n) {
    return n != null || (n = this._hash(t)), this._valueMap.has(n);
  }, e.prototype.keys = function() {
    var t, n;
    return ri(this, function(r) {
      switch (r.label) {
        case 0:
          t = this._keyMap.entries(), n = t.next(), r.label = 1;
        case 1:
          return n.done === !0 ? [3, 3] : [4, [n.value[1], n.value[0]]];
        case 2:
          return r.sent(), n = t.next(), [3, 1];
        case 3:
          return [2];
      }
    });
  }, e.prototype.entries = function() {
    var t, n;
    return ri(this, function(r) {
      switch (r.label) {
        case 0:
          t = this._valueMap.entries(), n = t.next(), r.label = 1;
        case 1:
          return n.done === !0 ? [3, 3] : [4, [this._keyMap.get(n.value[0]), n.value[1], n.value[0]]];
        case 2:
          return r.sent(), n = t.next(), [3, 1];
        case 3:
          return [2];
      }
    });
  }, Object.defineProperty(e.prototype, "size", { get: function() {
    return this._valueMap.size;
  }, enumerable: !1, configurable: !0 }), e;
}(), le = function(e) {
  function t() {
    return e.call(this, Vf) || this;
  }
  return fT(t, e), t;
}(_T), hT = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, Wf = function() {
  function e(t, n) {
    this._aggregator = t, this._activeCollectionStorage = new le(), this._cumulativeMemoStorage = new le(), this._overflowAttributes = { "otel.metric.overflow": !0 }, this._cardinalityLimit = (n ?? 2e3) - 1, this._overflowHashCode = Vf(this._overflowAttributes);
  }
  return e.prototype.record = function(t, n, r, o) {
    var i = this, a = this._activeCollectionStorage.get(n);
    if (!a) {
      if (this._activeCollectionStorage.size >= this._cardinalityLimit) {
        var u = this._activeCollectionStorage.getOrDefault(this._overflowAttributes, function() {
          return i._aggregator.createAccumulation(o);
        });
        return void (u == null || u.record(t));
      }
      a = this._aggregator.createAccumulation(o), this._activeCollectionStorage.set(n, a);
    }
    a?.record(t);
  }, e.prototype.batchCumulate = function(t, n) {
    var r = this;
    Array.from(t.entries()).forEach(function(o) {
      var i = hT(o, 3), a = i[0], u = i[1], c = i[2], l = r._aggregator.createAccumulation(n);
      l?.record(u);
      var s = l;
      if (r._cumulativeMemoStorage.has(a, c)) {
        var p = r._cumulativeMemoStorage.get(a, c);
        s = r._aggregator.diff(p, l);
      } else r._cumulativeMemoStorage.size >= r._cardinalityLimit && (a = r._overflowAttributes, c = r._overflowHashCode, r._cumulativeMemoStorage.has(a, c)) && (p = r._cumulativeMemoStorage.get(a, c), s = r._aggregator.diff(p, l));
      if (r._activeCollectionStorage.has(a, c)) {
        var v = r._activeCollectionStorage.get(a, c);
        s = r._aggregator.merge(v, s);
      }
      r._cumulativeMemoStorage.set(a, l, c), r._activeCollectionStorage.set(a, s, c);
    });
  }, e.prototype.collect = function() {
    var t = this._activeCollectionStorage;
    return this._activeCollectionStorage = new le(), t;
  }, e;
}(), yr = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, oi = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, Kf = function() {
  function e(t, n) {
    var r = this;
    this._aggregator = t, this._unreportedAccumulations = /* @__PURE__ */ new Map(), this._reportHistory = /* @__PURE__ */ new Map(), n.forEach(function(o) {
      r._unreportedAccumulations.set(o, []);
    });
  }
  return e.prototype.buildMetrics = function(t, n, r, o) {
    this._stashAccumulations(r);
    var i, a = this._getMergedUnreportedAccumulations(t), u = a;
    if (this._reportHistory.has(t)) {
      var c = this._reportHistory.get(t), l = c.collectionTime;
      u = (i = c.aggregationTemporality) === Ht.CUMULATIVE ? e.merge(c.accumulations, a, this._aggregator) : e.calibrateStartTime(c.accumulations, a, l);
    } else i = t.selectAggregationTemporality(n.type);
    this._reportHistory.set(t, { accumulations: u, collectionTime: o, aggregationTemporality: i });
    var s, p = (s = u, Array.from(s.entries()));
    if (p.length !== 0) return this._aggregator.toMetricData(n, i, p, o);
  }, e.prototype._stashAccumulations = function(t) {
    var n, r, o = this._unreportedAccumulations.keys();
    try {
      for (var i = yr(o), a = i.next(); !a.done; a = i.next()) {
        var u = a.value, c = this._unreportedAccumulations.get(u);
        c === void 0 && (c = [], this._unreportedAccumulations.set(u, c)), c.push(t);
      }
    } catch (l) {
      n = { error: l };
    } finally {
      try {
        a && !a.done && (r = i.return) && r.call(i);
      } finally {
        if (n) throw n.error;
      }
    }
  }, e.prototype._getMergedUnreportedAccumulations = function(t) {
    var n, r, o = new le(), i = this._unreportedAccumulations.get(t);
    if (this._unreportedAccumulations.set(t, []), i === void 0) return o;
    try {
      for (var a = yr(i), u = a.next(); !u.done; u = a.next()) {
        var c = u.value;
        o = e.merge(o, c, this._aggregator);
      }
    } catch (l) {
      n = { error: l };
    } finally {
      try {
        u && !u.done && (r = a.return) && r.call(a);
      } finally {
        if (n) throw n.error;
      }
    }
    return o;
  }, e.merge = function(t, n, r) {
    for (var o = t, i = n.entries(), a = i.next(); a.done !== !0; ) {
      var u = oi(a.value, 3), c = u[0], l = u[1], s = u[2];
      if (t.has(c, s)) {
        var p = t.get(c, s), v = r.merge(p, l);
        o.set(c, v, s);
      } else o.set(c, l, s);
      a = i.next();
    }
    return o;
  }, e.calibrateStartTime = function(t, n, r) {
    var o, i;
    try {
      for (var a = yr(t.keys()), u = a.next(); !u.done; u = a.next()) {
        var c = oi(u.value, 2), l = c[0], s = c[1], p = n.get(l, s);
        p?.setStartTime(r);
      }
    } catch (v) {
      o = { error: v };
    } finally {
      try {
        u && !u.done && (i = a.return) && i.call(a);
      } finally {
        if (o) throw o.error;
      }
    }
    return n;
  }, e;
}(), ET = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), dT = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, TT = function(e) {
  function t(n, r, o, i, a) {
    var u = e.call(this, n) || this;
    return u._attributesProcessor = o, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new Wf(r, u._aggregationCardinalityLimit), u._temporalMetricStorage = new Kf(r, i), u;
  }
  return ET(t, e), t.prototype.record = function(n, r) {
    var o = this, i = new le();
    Array.from(n.entries()).forEach(function(a) {
      var u = dT(a, 2), c = u[0], l = u[1];
      i.set(o._attributesProcessor.process(c), l);
    }), this._deltaMetricStorage.batchCumulate(i, r);
  }, t.prototype.collect = function(n, r) {
    var o = this._deltaMetricStorage.collect();
    return this._temporalMetricStorage.buildMetrics(n, this._instrumentDescriptor, o, r);
  }, t;
}(Xf);
function ii(e, t) {
  var n = "";
  return e.unit !== t.unit && (n += "	- Unit '" + e.unit + "' does not match '" + t.unit + `'
`), e.type !== t.type && (n += "	- Type '" + e.type + "' does not match '" + t.type + `'
`), e.valueType !== t.valueType && (n += "	- Value Type '" + e.valueType + "' does not match '" + t.valueType + `'
`), e.description !== t.description && (n += "	- Description '" + e.description + "' does not match '" + t.description + `'
`), n;
}
function ai(e, t) {
  return e.valueType !== t.valueType ? function(n, r) {
    return "	- use valueType '" + n.valueType + "' on instrument creation or use an instrument name other than '" + r.name + "'";
  }(e, t) : e.unit !== t.unit ? function(n, r) {
    return "	- use unit '" + n.unit + "' on instrument creation or use an instrument name other than '" + r.name + "'";
  }(e, t) : e.type !== t.type ? function(n, r) {
    var o = { name: r.name, type: r.type, unit: r.unit }, i = JSON.stringify(o);
    return "	- create a new view with a name other than '" + n.name + "' and InstrumentSelector '" + i + "'";
  }(e, t) : e.description !== t.description ? function(n, r) {
    var o = { name: r.name, type: r.type, unit: r.unit }, i = JSON.stringify(o);
    return "	- create a new view with a name other than '" + n.name + "' and InstrumentSelector '" + i + `'
    	- OR - create a new view with the name ` + n.name + " and description '" + n.description + "' and InstrumentSelector " + i + `
    	- OR - create a new view with the name ` + r.name + " and description '" + n.description + "' and InstrumentSelector " + i;
  }(e, t) : "";
}
var vr = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ST = function() {
  function e() {
    this._sharedRegistry = /* @__PURE__ */ new Map(), this._perCollectorRegistry = /* @__PURE__ */ new Map();
  }
  return e.create = function() {
    return new e();
  }, e.prototype.getStorages = function(t) {
    var n, r, o, i, a = [];
    try {
      for (var u = vr(this._sharedRegistry.values()), c = u.next(); !c.done; c = u.next()) {
        var l = c.value;
        a = a.concat(l);
      }
    } catch (g) {
      n = { error: g };
    } finally {
      try {
        c && !c.done && (r = u.return) && r.call(u);
      } finally {
        if (n) throw n.error;
      }
    }
    var s = this._perCollectorRegistry.get(t);
    if (s != null) try {
      for (var p = vr(s.values()), v = p.next(); !v.done; v = p.next())
        l = v.value, a = a.concat(l);
    } catch (g) {
      o = { error: g };
    } finally {
      try {
        v && !v.done && (i = p.return) && i.call(p);
      } finally {
        if (o) throw o.error;
      }
    }
    return a;
  }, e.prototype.register = function(t) {
    this._registerStorage(t, this._sharedRegistry);
  }, e.prototype.registerForCollector = function(t, n) {
    var r = this._perCollectorRegistry.get(t);
    r == null && (r = /* @__PURE__ */ new Map(), this._perCollectorRegistry.set(t, r)), this._registerStorage(n, r);
  }, e.prototype.findOrUpdateCompatibleStorage = function(t) {
    var n = this._sharedRegistry.get(t.name);
    return n === void 0 ? null : this._findOrUpdateCompatibleStorage(t, n);
  }, e.prototype.findOrUpdateCompatibleCollectorStorage = function(t, n) {
    var r = this._perCollectorRegistry.get(t);
    if (r === void 0) return null;
    var o = r.get(n.name);
    return o === void 0 ? null : this._findOrUpdateCompatibleStorage(n, o);
  }, e.prototype._registerStorage = function(t, n) {
    var r = t.getInstrumentDescriptor(), o = n.get(r.name);
    o !== void 0 ? o.push(t) : n.set(r.name, [t]);
  }, e.prototype._findOrUpdateCompatibleStorage = function(t, n) {
    var r, o, i, a, u, c, l = null;
    try {
      for (var s = vr(n), p = s.next(); !p.done; p = s.next()) {
        var v = p.value, g = v.getInstrumentDescriptor();
        a = t, u = void 0, c = void 0, u = (i = g).name, c = a.name, u.toLowerCase() === c.toLowerCase() && i.unit === a.unit && i.type === a.type && i.valueType === a.valueType ? (g.description !== t.description && (t.description.length > g.description.length && v.updateDescription(t.description), w.warn("A view or instrument with the name ", t.name, ` has already been registered, but has a different description and is incompatible with another registered view.
`, `Details:
`, ii(g, t), `The longer description will be used.
To resolve the conflict:`, ai(g, t))), l = v) : w.warn("A view or instrument with the name ", t.name, ` has already been registered and is incompatible with another registered view.
`, `Details:
`, ii(g, t), `To resolve the conflict:
`, ai(g, t));
      }
    } catch (b) {
      r = { error: b };
    } finally {
      try {
        p && !p.done && (o = s.return) && o.call(s);
      } finally {
        if (r) throw r.error;
      }
    }
    return l;
  }, e;
}(), yT = function() {
  function e(t) {
    this._backingStorages = t;
  }
  return e.prototype.record = function(t, n, r, o) {
    this._backingStorages.forEach(function(i) {
      i.record(t, n, r, o);
    });
  }, e;
}(), vT = function() {
  function e(t, n) {
    this._instrumentName = t, this._valueType = n, this._buffer = new le();
  }
  return e.prototype.observe = function(t, n) {
    n === void 0 && (n = {}), typeof t == "number" ? (this._valueType !== ae.INT || Number.isInteger(t) || (w.warn("INT value type cannot accept a floating-point value for " + this._instrumentName + ", ignoring the fractional digits."), t = Math.trunc(t), Number.isInteger(t))) && this._buffer.set(n, t) : w.warn("non-number value provided to metric " + this._instrumentName + ": " + t);
  }, e;
}(), mT = function() {
  function e() {
    this._buffer = /* @__PURE__ */ new Map();
  }
  return e.prototype.observe = function(t, n, r) {
    if (r === void 0 && (r = {}), Ur(t)) {
      var o = this._buffer.get(t);
      o == null && (o = new le(), this._buffer.set(t, o)), typeof n == "number" ? (t._descriptor.valueType !== ae.INT || Number.isInteger(n) || (w.warn("INT value type cannot accept a floating-point value for " + t._descriptor.name + ", ignoring the fractional digits."), n = Math.trunc(n), Number.isInteger(n))) && o.set(r, n) : w.warn("non-number value provided to metric " + t._descriptor.name + ": " + n);
    }
  }, e;
}(), mr = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, gr = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, si = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, ui = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}, gT = function() {
  function e() {
    this._callbacks = [], this._batchCallbacks = [];
  }
  return e.prototype.addCallback = function(t, n) {
    this._findCallback(t, n) >= 0 || this._callbacks.push({ callback: t, instrument: n });
  }, e.prototype.removeCallback = function(t, n) {
    var r = this._findCallback(t, n);
    r < 0 || this._callbacks.splice(r, 1);
  }, e.prototype.addBatchCallback = function(t, n) {
    var r = new Set(n.filter(Ur));
    r.size !== 0 ? this._findBatchCallback(t, r) >= 0 || this._batchCallbacks.push({ callback: t, instruments: r }) : w.error("BatchObservableCallback is not associated with valid instruments", n);
  }, e.prototype.removeBatchCallback = function(t, n) {
    var r = new Set(n.filter(Ur)), o = this._findBatchCallback(t, r);
    o < 0 || this._batchCallbacks.splice(o, 1);
  }, e.prototype.observe = function(t, n) {
    return mr(this, void 0, void 0, function() {
      var r, o, i;
      return gr(this, function(a) {
        switch (a.label) {
          case 0:
            return r = this._observeCallbacks(t, n), o = this._observeBatchCallbacks(t, n), [4, Rd(ui(ui([], si(r), !1), si(o), !1))];
          case 1:
            return i = a.sent(), [2, i.filter(bd).map(function(u) {
              return u.reason;
            })];
        }
      });
    });
  }, e.prototype._observeCallbacks = function(t, n) {
    var r = this;
    return this._callbacks.map(function(o) {
      var i = o.callback, a = o.instrument;
      return mr(r, void 0, void 0, function() {
        var u, c;
        return gr(this, function(l) {
          switch (l.label) {
            case 0:
              return u = new vT(a._descriptor.name, a._descriptor.valueType), c = Promise.resolve(i(u)), n != null && (c = Xe(c, n)), [4, c];
            case 1:
              return l.sent(), a._metricStorages.forEach(function(s) {
                s.record(u._buffer, t);
              }), [2];
          }
        });
      });
    });
  }, e.prototype._observeBatchCallbacks = function(t, n) {
    var r = this;
    return this._batchCallbacks.map(function(o) {
      var i = o.callback, a = o.instruments;
      return mr(r, void 0, void 0, function() {
        var u, c;
        return gr(this, function(l) {
          switch (l.label) {
            case 0:
              return u = new mT(), c = Promise.resolve(i(u)), n != null && (c = Xe(c, n)), [4, c];
            case 1:
              return l.sent(), a.forEach(function(s) {
                var p = u._buffer.get(s);
                p != null && s._metricStorages.forEach(function(v) {
                  v.record(p, t);
                });
              }), [2];
          }
        });
      });
    });
  }, e.prototype._findCallback = function(t, n) {
    return this._callbacks.findIndex(function(r) {
      return r.callback === t && r.instrument === n;
    });
  }, e.prototype._findBatchCallback = function(t, n) {
    return this._batchCallbacks.findIndex(function(r) {
      return r.callback === t && function(o, i) {
        var a, u;
        if (o.size !== i.size) return !1;
        try {
          for (var c = Ad(o), l = c.next(); !l.done; l = c.next()) {
            var s = l.value;
            if (!i.has(s)) return !1;
          }
        } catch (p) {
          a = { error: p };
        } finally {
          try {
            l && !l.done && (u = c.return) && u.call(c);
          } finally {
            if (a) throw a.error;
          }
        }
        return !0;
      }(r.instruments, n);
    });
  }, e;
}(), AT = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), OT = function(e) {
  function t(n, r, o, i, a) {
    var u = e.call(this, n) || this;
    return u._attributesProcessor = o, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new Wf(r, u._aggregationCardinalityLimit), u._temporalMetricStorage = new Kf(r, i), u;
  }
  return AT(t, e), t.prototype.record = function(n, r, o, i) {
    r = this._attributesProcessor.process(r, o), this._deltaMetricStorage.record(n, r, o, i);
  }, t.prototype.collect = function(n, r) {
    var o = this._deltaMetricStorage.collect();
    return this._temporalMetricStorage.buildMetrics(n, this._instrumentDescriptor, o, r);
  }, t;
}(Xf), qf = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Xr = function() {
  function e() {
  }
  return e.Noop = function() {
    return bT;
  }, e;
}(), RT = function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return qf(t, e), t.prototype.process = function(n, r) {
    return n;
  }, t;
}(Xr);
(function(e) {
  function t(n) {
    var r = e.call(this) || this;
    return r._allowedAttributeNames = n, r;
  }
  qf(t, e), t.prototype.process = function(n, r) {
    var o = this, i = {};
    return Object.keys(n).filter(function(a) {
      return o._allowedAttributeNames.includes(a);
    }).forEach(function(a) {
      return i[a] = n[a];
    }), i;
  };
})(Xr);
var bT = new RT(), NT = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, LT = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, CT = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, wT = function() {
  function e(t, n) {
    this._meterProviderSharedState = t, this._instrumentationScope = n, this.metricStorageRegistry = new ST(), this.observableRegistry = new gT(), this.meter = new pT(this);
  }
  return e.prototype.registerMetricStorage = function(t) {
    var n = this._registerMetricStorage(t, OT);
    return n.length === 1 ? n[0] : new yT(n);
  }, e.prototype.registerAsyncMetricStorage = function(t) {
    return this._registerMetricStorage(t, TT);
  }, e.prototype.collect = function(t, n, r) {
    return NT(this, void 0, void 0, function() {
      var o, i, a;
      return LT(this, function(u) {
        switch (u.label) {
          case 0:
            return [4, this.observableRegistry.observe(n, r?.timeoutMillis)];
          case 1:
            return o = u.sent(), (i = this.metricStorageRegistry.getStorages(t)).length === 0 ? [2, null] : (a = i.map(function(c) {
              return c.collect(t, n);
            }).filter(Od)).length === 0 ? [2, { errors: o }] : [2, { scopeMetrics: { scope: this._instrumentationScope, metrics: a }, errors: o }];
        }
      });
    });
  }, e.prototype._registerMetricStorage = function(t, n) {
    var r = this, o = this._meterProviderSharedState.viewRegistry.findViews(t, this._instrumentationScope).map(function(a) {
      var u = function(p, v) {
        var g, b;
        return { name: (g = p.name) !== null && g !== void 0 ? g : v.name, description: (b = p.description) !== null && b !== void 0 ? b : v.description, type: v.type, unit: v.unit, valueType: v.valueType, advice: v.advice };
      }(a, t), c = r.metricStorageRegistry.findOrUpdateCompatibleStorage(u);
      if (c != null) return c;
      var l = a.aggregation.createAggregator(u), s = new n(u, l, a.attributesProcessor, r._meterProviderSharedState.metricCollectors, a.aggregationCardinalityLimit);
      return r.metricStorageRegistry.register(s), s;
    });
    if (o.length === 0) {
      var i = this._meterProviderSharedState.selectAggregations(t.type).map(function(a) {
        var u = CT(a, 2), c = u[0], l = u[1], s = r.metricStorageRegistry.findOrUpdateCompatibleCollectorStorage(c, t);
        if (s != null) return s;
        var p = l.createAggregator(t), v = c.selectCardinalityLimit(t.type), g = new n(t, p, Xr.Noop(), [c], v);
        return r.metricStorageRegistry.registerForCollector(c, g), g;
      });
      o = o.concat(i);
    }
    return o;
  }, e;
}(), MT = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, PT = function() {
  function e(t) {
    this.resource = t, this.viewRegistry = new rT(), this.metricCollectors = [], this.meterSharedStates = /* @__PURE__ */ new Map();
  }
  return e.prototype.getMeterSharedState = function(t) {
    var n = function(o) {
      var i, a;
      return o.name + ":" + ((i = o.version) !== null && i !== void 0 ? i : "") + ":" + ((a = o.schemaUrl) !== null && a !== void 0 ? a : "");
    }(t), r = this.meterSharedStates.get(n);
    return r == null && (r = new wT(this, t), this.meterSharedStates.set(n, r)), r;
  }, e.prototype.selectAggregations = function(t) {
    var n, r, o = [];
    try {
      for (var i = MT(this.metricCollectors), a = i.next(); !a.done; a = i.next()) {
        var u = a.value;
        o.push([u, u.selectAggregation(t)]);
      }
    } catch (c) {
      n = { error: c };
    } finally {
      try {
        a && !a.done && (r = i.return) && r.call(i);
      } finally {
        if (n) throw n.error;
      }
    }
    return o;
  }, e;
}(), _n = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, hn = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, IT = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, DT = function(e, t, n) {
  if (n || arguments.length === 2) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}, UT = function() {
  function e(t, n) {
    this._sharedState = t, this._metricReader = n;
  }
  return e.prototype.collect = function(t) {
    return _n(this, void 0, void 0, function() {
      var n, r, o, i, a = this;
      return hn(this, function(u) {
        switch (u.label) {
          case 0:
            return n = Dt(Date.now()), r = [], o = [], i = Array.from(this._sharedState.meterSharedStates.values()).map(function(c) {
              return _n(a, void 0, void 0, function() {
                var l;
                return hn(this, function(s) {
                  switch (s.label) {
                    case 0:
                      return [4, c.collect(this, n, t)];
                    case 1:
                      return ((l = s.sent()) == null ? void 0 : l.scopeMetrics) != null && r.push(l.scopeMetrics), l?.errors != null && o.push.apply(o, DT([], IT(l.errors), !1)), [2];
                  }
                });
              });
            }), [4, Promise.all(i)];
          case 1:
            return u.sent(), [2, { resourceMetrics: { resource: this._sharedState.resource, scopeMetrics: r }, errors: o }];
        }
      });
    });
  }, e.prototype.forceFlush = function(t) {
    return _n(this, void 0, void 0, function() {
      return hn(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, this._metricReader.forceFlush(t)];
          case 1:
            return n.sent(), [2];
        }
      });
    });
  }, e.prototype.shutdown = function(t) {
    return _n(this, void 0, void 0, function() {
      return hn(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, this._metricReader.shutdown(t)];
          case 1:
            return n.sent(), [2];
        }
      });
    });
  }, e.prototype.selectAggregationTemporality = function(t) {
    return this._metricReader.selectAggregationTemporality(t);
  }, e.prototype.selectAggregation = function(t) {
    return this._metricReader.selectAggregation(t);
  }, e.prototype.selectCardinalityLimit = function(t) {
    var n, r, o;
    return (o = (r = (n = this._metricReader).selectCardinalityLimit) === null || r === void 0 ? void 0 : r.call(n, t)) !== null && o !== void 0 ? o : 2e3;
  }, e;
}(), ci = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, li = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, pi = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Cn, kL = function() {
  function e(t) {
    var n, r, o, i, a, u, c, l;
    if (this._shutdown = !1, this._sharedState = new PT((u = (a = t?.mergeResourceWithDefaults) === null || a === void 0 || a, c = t?.resource, l = c ?? Nt.empty(), u ? Nt.default().merge(l) : l)), t?.views != null && t.views.length > 0) try {
      for (var s = pi(t.views), p = s.next(); !p.done; p = s.next()) {
        var v = p.value;
        this._sharedState.viewRegistry.addView(v);
      }
    } catch (P) {
      n = { error: P };
    } finally {
      try {
        p && !p.done && (r = s.return) && r.call(s);
      } finally {
        if (n) throw n.error;
      }
    }
    if (t?.readers != null && t.readers.length > 0) try {
      for (var g = pi(t.readers), b = g.next(); !b.done; b = g.next()) {
        var H = b.value;
        this.addMetricReader(H);
      }
    } catch (P) {
      o = { error: P };
    } finally {
      try {
        b && !b.done && (i = g.return) && i.call(g);
      } finally {
        if (o) throw o.error;
      }
    }
  }
  return e.prototype.getMeter = function(t, n, r) {
    return n === void 0 && (n = ""), r === void 0 && (r = {}), this._shutdown ? (w.warn("A shutdown MeterProvider cannot provide a Meter"), rh()) : this._sharedState.getMeterSharedState({ name: t, version: n, schemaUrl: r.schemaUrl }).meter;
  }, e.prototype.addMetricReader = function(t) {
    var n = new UT(this._sharedState, t);
    t.setMetricProducer(n), this._sharedState.metricCollectors.push(n);
  }, e.prototype.shutdown = function(t) {
    return ci(this, void 0, void 0, function() {
      return li(this, function(n) {
        switch (n.label) {
          case 0:
            return this._shutdown ? (w.warn("shutdown may only be called once per MeterProvider"), [2]) : (this._shutdown = !0, [4, Promise.all(this._sharedState.metricCollectors.map(function(r) {
              return r.shutdown(t);
            }))]);
          case 1:
            return n.sent(), [2];
        }
      });
    });
  }, e.prototype.forceFlush = function(t) {
    return ci(this, void 0, void 0, function() {
      return li(this, function(n) {
        switch (n.label) {
          case 0:
            return this._shutdown ? (w.warn("invalid attempt to force flush after MeterProvider shutdown"), [2]) : [4, Promise.all(this._sharedState.metricCollectors.map(function(r) {
              return r.forceFlush(t);
            }))];
          case 1:
            return n.sent(), [2];
        }
      });
    });
  }, e;
}();
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE", e[e.LOWMEMORY = 2] = "LOWMEMORY";
})(Cn || (Cn = {}));
var Qf = function() {
  function e(t) {
    this._delegate = t;
  }
  return e.prototype.export = function(t, n) {
    this._delegate.export(t, n);
  }, e.prototype.forceFlush = function() {
    return this._delegate.forceFlush();
  }, e.prototype.shutdown = function() {
    return this._delegate.shutdown();
  }, e;
}(), kT = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), fi = function(e) {
  function t(n, r, o) {
    var i = e.call(this, n) || this;
    return i.name = "OTLPExporterError", i.data = o, i.code = r, i;
  }
  return kT(t, e), t;
}(Error);
function xT(e) {
  if (!Number.isNaN(e) && Number.isFinite(e) && e > 0) return e;
  throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + e + "')");
}
function VT(e) {
  if (e != null) return function() {
    return e;
  };
}
var BT = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, GT = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, HT = function() {
  function e(t) {
    this._sendingPromises = [], this._concurrencyLimit = t;
  }
  return e.prototype.pushPromise = function(t) {
    var n = this;
    if (this.hasReachedLimit()) throw new Error("Concurrency Limit reached");
    this._sendingPromises.push(t);
    var r = function() {
      var o = n._sendingPromises.indexOf(t);
      n._sendingPromises.splice(o, 1);
    };
    t.then(r, r);
  }, e.prototype.hasReachedLimit = function() {
    return this._sendingPromises.length >= this._concurrencyLimit;
  }, e.prototype.awaitAll = function() {
    return BT(this, void 0, void 0, function() {
      return GT(this, function(t) {
        switch (t.label) {
          case 0:
            return [4, Promise.all(this._sendingPromises)];
          case 1:
            return t.sent(), [2];
        }
      });
    });
  }, e;
}();
function jT(e) {
  return new HT(e.concurrencyLimit);
}
function FT() {
  return { handleResponse: function(e) {
    e != null && function(t) {
      return Object.prototype.hasOwnProperty.call(t, "partialSuccess");
    }(e) && e.partialSuccess != null && Object.keys(e.partialSuccess).length !== 0 && w.warn("Received Partial Success response:", JSON.stringify(e.partialSuccess));
  } };
}
var YT = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, zT = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, ZT = function() {
  function e(t, n, r, o, i) {
    this._transport = t, this._serializer = n, this._responseHandler = r, this._promiseQueue = o, this._timeout = i, this._diagLogger = w.createComponentLogger({ namespace: "OTLPExportDelegate" });
  }
  return e.prototype.export = function(t, n) {
    var r = this;
    if (this._diagLogger.debug("items to be sent", t), this._promiseQueue.hasReachedLimit()) n({ code: Mt.FAILED, error: new Error("Concurrent export limit reached") });
    else {
      var o = this._serializer.serializeRequest(t);
      o != null ? this._promiseQueue.pushPromise(this._transport.send(o, this._timeout).then(function(i) {
        if (i.status !== "success") i.status === "failure" && i.error ? n({ code: Mt.FAILED, error: i.error }) : i.status === "retryable" ? n({ code: Mt.FAILED, error: new fi("Export failed with retryable status") }) : n({ code: Mt.FAILED, error: new fi("Export failed with unknown error") });
        else {
          if (i.data != null) try {
            r._responseHandler.handleResponse(r._serializer.deserializeResponse(i.data));
          } catch (a) {
            r._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", a, i.data);
          }
          n({ code: Mt.SUCCESS });
        }
      }, function(i) {
        return n({ code: Mt.FAILED, error: i });
      })) : n({ code: Mt.FAILED, error: new Error("Nothing to send") });
    }
  }, e.prototype.forceFlush = function() {
    return this._promiseQueue.awaitAll();
  }, e.prototype.shutdown = function() {
    return YT(this, void 0, void 0, function() {
      return zT(this, function(t) {
        switch (t.label) {
          case 0:
            return this._diagLogger.debug("shutdown started"), [4, this.forceFlush()];
          case 1:
            return t.sent(), this._transport.shutdown(), [2];
        }
      });
    });
  }, e;
}();
function _i(e, t, n) {
  return r = { transport: n, serializer: t, promiseHandler: jT(e) }, o = { timeout: e.timeoutMillis }, new ZT(r.transport, r.serializer, FT(), r.promiseHandler, o.timeout);
  var r, o;
}
var XT = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Ar = function() {
  return Ht.CUMULATIVE;
}, hi = function(e) {
  switch (e) {
    case Q.COUNTER:
    case Q.OBSERVABLE_COUNTER:
    case Q.GAUGE:
    case Q.HISTOGRAM:
    case Q.OBSERVABLE_GAUGE:
      return Ht.DELTA;
    case Q.UP_DOWN_COUNTER:
    case Q.OBSERVABLE_UP_DOWN_COUNTER:
      return Ht.CUMULATIVE;
  }
}, Ei = function(e) {
  switch (e) {
    case Q.COUNTER:
    case Q.HISTOGRAM:
      return Ht.DELTA;
    case Q.GAUGE:
    case Q.UP_DOWN_COUNTER:
    case Q.OBSERVABLE_UP_DOWN_COUNTER:
    case Q.OBSERVABLE_COUNTER:
    case Q.OBSERVABLE_GAUGE:
      return Ht.CUMULATIVE;
  }
};
function WT(e) {
  return e != null ? e === Cn.DELTA ? hi : e === Cn.LOWMEMORY ? Ei : Ar : (t = he(), (n = t.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE.trim().toLowerCase()) === "cumulative" ? Ar : n === "delta" ? hi : n === "lowmemory" ? Ei : (w.warn("OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE is set to '" + t.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE + "', but only 'cumulative' and 'delta' are allowed. Using default ('cumulative') instead."), Ar));
  var t, n;
}
var KT = function(e) {
  function t(n, r) {
    var o = e.call(this, n) || this;
    return o._aggregationSelector = function(i) {
      return i?.aggregationPreference ? i.aggregationPreference : function(a) {
        return ee.Default();
      };
    }(r), o._aggregationTemporalitySelector = WT(r?.temporalityPreference), o;
  }
  return XT(t, e), t.prototype.selectAggregation = function(n) {
    return this._aggregationSelector(n);
  }, t.prototype.selectAggregationTemporality = function(n) {
    return this._aggregationTemporalitySelector(n);
  }, t;
}(Qf);
function Jf(e) {
  var t = BigInt(1e9);
  return BigInt(e[0]) * t + BigInt(e[1]);
}
function $f(e) {
  var t, n = Jf(e);
  return t = n, { low: Number(BigInt.asUintN(32, t)), high: Number(BigInt.asUintN(32, t >> BigInt(32))) };
}
var qT = typeof BigInt < "u" ? function(e) {
  return Jf(e).toString();
} : Jt;
function di(e) {
  return e;
}
function t_(e) {
  if (e !== void 0) return Yr(e);
}
var QT = { encodeHrTime: $f, encodeSpanContext: Yr, encodeOptionalSpanContext: t_ };
function e_(e) {
  var t, n;
  if (e === void 0) return QT;
  var r = (t = e.useLongBits) === null || t === void 0 || t, o = (n = e.useHex) !== null && n !== void 0 && n;
  return { encodeHrTime: r ? $f : qT, encodeSpanContext: o ? di : Yr, encodeOptionalSpanContext: o ? di : t_ };
}
var JT = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
};
function n_(e) {
  return { attributes: pe(e.attributes), droppedAttributesCount: 0 };
}
function r_(e) {
  return { name: e.name, version: e.version };
}
function pe(e) {
  return Object.keys(e).map(function(t) {
    return o_(t, e[t]);
  });
}
function o_(e, t) {
  return { key: e, value: i_(t) };
}
function i_(e) {
  var t = typeof e;
  return t === "string" ? { stringValue: e } : t === "number" ? Number.isInteger(e) ? { intValue: e } : { doubleValue: e } : t === "boolean" ? { boolValue: e } : e instanceof Uint8Array ? { bytesValue: e } : Array.isArray(e) ? { arrayValue: { values: e.map(i_) } } : t === "object" && e != null ? { kvlistValue: { values: Object.entries(e).map(function(n) {
    var r = JT(n, 2);
    return o_(r[0], r[1]);
  }) } } : {};
}
function $T(e, t) {
  return Array.from(e.map(function(n) {
    return { scope: r_(n.scope), metrics: n.metrics.map(function(r) {
      return function(o, i) {
        var a = { name: o.descriptor.name, description: o.descriptor.description, unit: o.descriptor.unit }, u = function(c) {
          switch (c) {
            case Ht.DELTA:
              return 1;
            case Ht.CUMULATIVE:
              return 2;
          }
        }(o.aggregationTemporality);
        switch (o.dataPointType) {
          case Xt.SUM:
            a.sum = { aggregationTemporality: u, isMonotonic: o.isMonotonic, dataPoints: Ti(o, i) };
            break;
          case Xt.GAUGE:
            a.gauge = { dataPoints: Ti(o, i) };
            break;
          case Xt.HISTOGRAM:
            a.histogram = { aggregationTemporality: u, dataPoints: tS(o, i) };
            break;
          case Xt.EXPONENTIAL_HISTOGRAM:
            a.exponentialHistogram = { aggregationTemporality: u, dataPoints: eS(o, i) };
        }
        return a;
      }(r, t);
    }), schemaUrl: n.scope.schemaUrl };
  }));
}
function Ti(e, t) {
  return e.dataPoints.map(function(n) {
    return function(r, o, i) {
      var a = { attributes: pe(r.attributes), startTimeUnixNano: i.encodeHrTime(r.startTime), timeUnixNano: i.encodeHrTime(r.endTime) };
      switch (o) {
        case ae.INT:
          a.asInt = r.value;
          break;
        case ae.DOUBLE:
          a.asDouble = r.value;
      }
      return a;
    }(n, e.descriptor.valueType, t);
  });
}
function tS(e, t) {
  return e.dataPoints.map(function(n) {
    var r = n.value;
    return { attributes: pe(n.attributes), bucketCounts: r.buckets.counts, explicitBounds: r.buckets.boundaries, count: r.count, sum: r.sum, min: r.min, max: r.max, startTimeUnixNano: t.encodeHrTime(n.startTime), timeUnixNano: t.encodeHrTime(n.endTime) };
  });
}
function eS(e, t) {
  return e.dataPoints.map(function(n) {
    var r = n.value;
    return { attributes: pe(n.attributes), count: r.count, min: r.min, max: r.max, sum: r.sum, positive: { offset: r.positive.offset, bucketCounts: r.positive.bucketCounts }, negative: { offset: r.negative.offset, bucketCounts: r.negative.bucketCounts }, scale: r.scale, zeroCount: r.zeroCount, startTimeUnixNano: t.encodeHrTime(n.startTime), timeUnixNano: t.encodeHrTime(n.endTime) };
  });
}
function nS(e, t) {
  return { resourceMetrics: e.map(function(n) {
    return function(r, o) {
      var i = e_(o);
      return { resource: n_(r.resource), schemaUrl: void 0, scopeMetrics: $T(r.scopeMetrics, i) };
    }(n, t);
  }) };
}
var rS = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return { next: function() {
    return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
  } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, oS = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
};
function iS(e, t) {
  var n, r = e.spanContext(), o = e.status;
  return { traceId: t.encodeSpanContext(r.traceId), spanId: t.encodeSpanContext(r.spanId), parentSpanId: t.encodeOptionalSpanContext(e.parentSpanId), traceState: (n = r.traceState) === null || n === void 0 ? void 0 : n.serialize(), name: e.name, kind: e.kind == null ? 0 : e.kind + 1, startTimeUnixNano: t.encodeHrTime(e.startTime), endTimeUnixNano: t.encodeHrTime(e.endTime), attributes: pe(e.attributes), droppedAttributesCount: e.droppedAttributesCount, events: e.events.map(function(i) {
    return function(a, u) {
      return { attributes: a.attributes ? pe(a.attributes) : [], name: a.name, timeUnixNano: u.encodeHrTime(a.time), droppedAttributesCount: a.droppedAttributesCount || 0 };
    }(i, t);
  }), droppedEventsCount: e.droppedEventsCount, status: { code: o.code, message: o.message }, links: e.links.map(function(i) {
    return function(a, u) {
      var c;
      return { attributes: a.attributes ? pe(a.attributes) : [], spanId: u.encodeSpanContext(a.context.spanId), traceId: u.encodeSpanContext(a.context.traceId), traceState: (c = a.context.traceState) === null || c === void 0 ? void 0 : c.serialize(), droppedAttributesCount: a.droppedAttributesCount || 0 };
    }(i, t);
  }), droppedLinksCount: e.droppedLinksCount };
}
function aS(e, t) {
  for (var n = function(b) {
    var H, P, N = /* @__PURE__ */ new Map();
    try {
      for (var J = rS(b), ct = J.next(); !ct.done; ct = J.next()) {
        var X = ct.value, lt = N.get(X.resource);
        lt || (lt = /* @__PURE__ */ new Map(), N.set(X.resource, lt));
        var xt = X.instrumentationLibrary.name + "@" + (X.instrumentationLibrary.version || "") + ":" + (X.instrumentationLibrary.schemaUrl || ""), Rt = lt.get(xt);
        Rt || (Rt = [], lt.set(xt, Rt)), Rt.push(X);
      }
    } catch (jt) {
      H = { error: jt };
    } finally {
      try {
        ct && !ct.done && (P = J.return) && P.call(J);
      } finally {
        if (H) throw H.error;
      }
    }
    return N;
  }(e), r = [], o = n.entries(), i = o.next(); !i.done; ) {
    for (var a = oS(i.value, 2), u = a[0], c = [], l = a[1].values(), s = l.next(); !s.done; ) {
      var p = s.value;
      if (p.length > 0) {
        var v = p.map(function(b) {
          return iS(b, t);
        });
        c.push({ scope: r_(p[0].instrumentationLibrary), spans: v, schemaUrl: p[0].instrumentationLibrary.schemaUrl });
      }
      s = l.next();
    }
    var g = { resource: n_(u), scopeSpans: c, schemaUrl: void 0 };
    r.push(g), i = o.next();
  }
  return r;
}
var sS = { serializeRequest: function(e) {
  var t = nS([e], { useLongBits: !1 });
  return new TextEncoder().encode(JSON.stringify(t));
}, deserializeResponse: function(e) {
  var t = new TextDecoder();
  return JSON.parse(t.decode(e));
} }, uS = { serializeRequest: function(e) {
  var t = { resourceSpans: aS(e, e_({ useHex: !0, useLongBits: !1 })) };
  return new TextEncoder().encode(JSON.stringify(t));
}, deserializeResponse: function(e) {
  var t = new TextDecoder();
  return JSON.parse(t.decode(e));
} }, cS = function(e, t, n, r) {
  return new (n || (n = Promise))(function(o, i) {
    function a(l) {
      try {
        c(r.next(l));
      } catch (s) {
        i(s);
      }
    }
    function u(l) {
      try {
        c(r.throw(l));
      } catch (s) {
        i(s);
      }
    }
    function c(l) {
      var s;
      l.done ? o(l.value) : (s = l.value, s instanceof n ? s : new n(function(p) {
        p(s);
      })).then(a, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}, lS = function(e, t) {
  var n, r, o, i, a = { label: 0, sent: function() {
    if (1 & o[0]) throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function u(c) {
    return function(l) {
      return function(s) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; a; ) try {
          if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
          switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
            case 0:
            case 1:
              o = s;
              break;
            case 4:
              return a.label++, { value: s[1], done: !1 };
            case 5:
              a.label++, r = s[1], s = [0];
              continue;
            case 7:
              s = a.ops.pop(), a.trys.pop();
              continue;
            default:
              if (o = a.trys, !((o = o.length > 0 && o[o.length - 1]) || s[0] !== 6 && s[0] !== 2)) {
                a = 0;
                continue;
              }
              if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
                a.label = s[1];
                break;
              }
              if (s[0] === 6 && a.label < o[1]) {
                a.label = o[1], o = s;
                break;
              }
              if (o && a.label < o[2]) {
                a.label = o[2], a.ops.push(s);
                break;
              }
              o[2] && a.ops.pop(), a.trys.pop();
              continue;
          }
          s = t.call(e, a);
        } catch (p) {
          s = [6, p], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & s[0]) throw s[1];
        return { value: s[0] ? s[1] : void 0, done: !0 };
      }([c, l]);
    };
  }
}, pS = function() {
  function e(t) {
    this._transport = t;
  }
  return e.prototype.retry = function(t, n, r) {
    var o = this;
    return new Promise(function(i, a) {
      setTimeout(function() {
        o._transport.send(t, n).then(i, a);
      }, r);
    });
  }, e.prototype.send = function(t, n) {
    var r;
    return cS(this, void 0, void 0, function() {
      var o, i, a, u, c, l, s;
      return lS(this, function(p) {
        switch (p.label) {
          case 0:
            return o = Date.now() + n, [4, this._transport.send(t, n)];
          case 1:
            i = p.sent(), a = 5, u = 1e3, p.label = 2;
          case 2:
            return i.status === "retryable" && a > 0 ? (a--, c = Math.max(Math.min(u, 5e3) + (0.4 * Math.random() - 0.2), 0), u *= 1.5, l = (r = i.retryInMillis) !== null && r !== void 0 ? r : c, s = o - Date.now(), l > s ? [2, i] : [4, this.retry(t, s, l)]) : [3, 4];
          case 3:
            return i = p.sent(), [3, 2];
          case 4:
            return [2, i];
        }
      });
    });
  }, e.prototype.shutdown = function() {
    return this._transport.shutdown();
  }, e;
}();
function Si(e) {
  return new pS(e.transport);
}
function fS(e) {
  if (e != null) {
    var t = Number.parseInt(e, 10);
    if (Number.isInteger(t)) return t > 0 ? 1e3 * t : -1;
    var n = new Date(e).getTime() - Date.now();
    return n >= 0 ? n : 0;
  }
}
var _S = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, hS = function() {
  function e(t) {
    this._parameters = t;
  }
  return e.prototype.send = function(t, n) {
    var r = this;
    return new Promise(function(o) {
      var i = new XMLHttpRequest();
      i.timeout = n, i.open("POST", r._parameters.url);
      var a = r._parameters.headers();
      Object.entries(a).forEach(function(u) {
        var c = _S(u, 2), l = c[0], s = c[1];
        i.setRequestHeader(l, s);
      }), i.ontimeout = function(u) {
        o({ status: "failure", error: new Error("XHR request timed out") });
      }, i.onreadystatechange = function() {
        var u;
        i.status >= 200 && i.status <= 299 ? (w.debug("XHR success"), o({ status: "success" })) : i.status && (u = i.status, [429, 502, 503, 504].includes(u)) ? o({ status: "retryable", retryInMillis: fS(i.getResponseHeader("Retry-After")) }) : i.status !== 0 && o({ status: "failure", error: new Error("XHR request failed with non-retryable status") });
      }, i.onabort = function() {
        o({ status: "failure", error: new Error("XHR request aborted") });
      }, i.onerror = function() {
        o({ status: "failure", error: new Error("XHR request errored") });
      }, i.send(t);
    });
  }, e.prototype.shutdown = function() {
  }, e;
}(), ES = function() {
  function e(t) {
    this._params = t;
  }
  return e.prototype.send = function(t) {
    var n = this;
    return new Promise(function(r) {
      navigator.sendBeacon(n._params.url, new Blob([t], { type: n._params.blobType })) ? (w.debug("SendBeacon success"), r({ status: "success" })) : r({ status: "failure", error: new Error("SendBeacon failed") });
    });
  }, e.prototype.shutdown = function() {
  }, e;
}(), dS = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r, o, i = n.call(e), a = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) a.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, fe = function() {
  return fe = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    return e;
  }, fe.apply(this, arguments);
};
function TS(e) {
  if (e != null) try {
    return new URL(e), e;
  } catch {
    throw new Error("Configuration: Could not parse user-provided export URL: '" + e + "'");
  }
}
function SS(e, t, n) {
  var r, o, i, a, u, c, l, s, p, v;
  return fe(fe({}, function(g, b, H) {
    var P, N, J, ct, X, lt;
    return { timeoutMillis: xT((N = (P = g.timeoutMillis) !== null && P !== void 0 ? P : b.timeoutMillis) !== null && N !== void 0 ? N : H.timeoutMillis), concurrencyLimit: (ct = (J = g.concurrencyLimit) !== null && J !== void 0 ? J : b.concurrencyLimit) !== null && ct !== void 0 ? ct : H.concurrencyLimit, compression: (lt = (X = g.compression) !== null && X !== void 0 ? X : b.compression) !== null && lt !== void 0 ? lt : H.compression };
  }(e, t, n)), { headers: (v = e.headers, u = function() {
    var g, b = {};
    return Object.entries((g = v?.()) !== null && g !== void 0 ? g : {}).forEach(function(H) {
      var P = dS(H, 2), N = P[0], J = P[1];
      J !== void 0 ? b[N] = String(J) : w.warn('Header "' + N + '" has invalid value (' + J + ") and will be ignored");
    }), b;
  }, c = t.headers, l = n.headers, s = fe({}, l()), p = {}, function() {
    return c != null && Object.assign(p, c()), u != null && Object.assign(p, u()), Object.assign(p, s);
  }), url: (o = (r = TS(e.url)) !== null && r !== void 0 ? r : t.url) !== null && o !== void 0 ? o : n.url, agentOptions: (a = (i = e.agentOptions) !== null && i !== void 0 ? i : t.agentOptions) !== null && a !== void 0 ? a : n.agentOptions });
}
function yS(e, t, n) {
  return SS({ url: e.url, timeoutMillis: e.timeoutMillis, headers: VT(e.headers), concurrencyLimit: e.concurrencyLimit }, {}, function(r, o) {
    return fe(fe({}, { timeoutMillis: 1e4, concurrencyLimit: 30, compression: "none" }), { headers: function() {
      return r;
    }, url: "http://localhost:4318/" + o, agentOptions: { keepAlive: !0 } });
  }(n, t));
}
function a_(e, t, n, r) {
  var o = !!e.headers || typeof navigator.sendBeacon != "function", i = yS(e, n, r);
  return o ? function(a, u) {
    return _i(a, u, Si({ transport: (c = a, new hS(c)) }));
    var c;
  }(i, t) : function(a, u) {
    return _i(a, u, Si({ transport: (c = { url: a.url, blobType: a.headers()["Content-Type"] }, new ES(c)) }));
    var c;
  }(i, t);
}
var kr, ie, Fe, s_, wn, vS = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), xL = function(e) {
  function t(n) {
    return e.call(this, a_(n ?? {}, sS, "v1/metrics", { "Content-Type": "application/json" }), n) || this;
  }
  return vS(t, e), t;
}(KT), mS = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function r() {
      this.constructor = t;
    }
    e(t, n), t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), VL = function(e) {
  function t(n) {
    return n === void 0 && (n = {}), e.call(this, a_(n, uS, "v1/traces", { "Content-Type": "application/json" })) || this;
  }
  return mS(t, e), t;
}(Qf), u_ = -1, ve = function(e) {
  addEventListener("pageshow", function(t) {
    t.persisted && (u_ = t.timeStamp, e(t));
  }, !0);
}, Wr = function() {
  var e = self.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
  if (e && e.responseStart > 0 && e.responseStart < performance.now()) return e;
}, Gn = function() {
  var e = Wr();
  return e && e.activationStart || 0;
}, Ut = function(e, t) {
  var n = Wr(), r = "navigate";
  return u_ >= 0 ? r = "back-forward-cache" : n && (document.prerendering || Gn() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : n.type && (r = n.type.replace(/_/g, "-"))), { name: e, value: t === void 0 ? -1 : t, rating: "good", delta: 0, entries: [], id: "v4-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: r };
}, we = function(e, t, n) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var r = new PerformanceObserver(function(o) {
        Promise.resolve().then(function() {
          t(o.getEntries());
        });
      });
      return r.observe(Object.assign({ type: e, buffered: !0 }, n || {})), r;
    }
  } catch {
  }
}, kt = function(e, t, n, r) {
  var o, i;
  return function(a) {
    t.value >= 0 && (a || r) && ((i = t.value - (o || 0)) || o === void 0) && (o = t.value, t.delta = i, t.rating = function(u, c) {
      return u > c[1] ? "poor" : u > c[0] ? "needs-improvement" : "good";
    }(t.value, n), e(t));
  };
}, Kr = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, Qe = function(e) {
  document.addEventListener("visibilitychange", function() {
    document.visibilityState === "hidden" && e();
  });
}, Hn = function(e) {
  var t = !1;
  return function() {
    t || (e(), t = !0);
  };
}, be = -1, yi = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, Mn = function(e) {
  document.visibilityState === "hidden" && be > -1 && (be = e.type === "visibilitychange" ? e.timeStamp : 0, gS());
}, vi = function() {
  addEventListener("visibilitychange", Mn, !0), addEventListener("prerenderingchange", Mn, !0);
}, gS = function() {
  removeEventListener("visibilitychange", Mn, !0), removeEventListener("prerenderingchange", Mn, !0);
}, qr = function() {
  return be < 0 && (be = yi(), vi(), ve(function() {
    setTimeout(function() {
      be = yi(), vi();
    }, 0);
  })), { get firstHiddenTime() {
    return be;
  } };
}, Je = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, mi = [1800, 3e3], AS = function(e, t) {
  t = t || {}, Je(function() {
    var n, r = qr(), o = Ut("FCP"), i = we("paint", function(a) {
      a.forEach(function(u) {
        u.name === "first-contentful-paint" && (i.disconnect(), u.startTime < r.firstHiddenTime && (o.value = Math.max(u.startTime - Gn(), 0), o.entries.push(u), n(!0)));
      });
    });
    i && (n = kt(e, o, mi, t.reportAllChanges), ve(function(a) {
      o = Ut("FCP"), n = kt(e, o, mi, t.reportAllChanges), Kr(function() {
        o.value = performance.now() - a.timeStamp, n(!0);
      });
    }));
  });
}, gi = [0.1, 0.25], BL = function(e, t) {
  t = t || {}, AS(Hn(function() {
    var n, r = Ut("CLS", 0), o = 0, i = [], a = function(c) {
      c.forEach(function(l) {
        if (!l.hadRecentInput) {
          var s = i[0], p = i[i.length - 1];
          o && l.startTime - p.startTime < 1e3 && l.startTime - s.startTime < 5e3 ? (o += l.value, i.push(l)) : (o = l.value, i = [l]);
        }
      }), o > r.value && (r.value = o, r.entries = i, n());
    }, u = we("layout-shift", a);
    u && (n = kt(e, r, gi, t.reportAllChanges), Qe(function() {
      a(u.takeRecords()), n(!0);
    }), ve(function() {
      o = 0, r = Ut("CLS", 0), n = kt(e, r, gi, t.reportAllChanges), Kr(function() {
        return n();
      });
    }), setTimeout(n, 0));
  }));
}, c_ = 0, Or = 1 / 0, En = 0, OS = function(e) {
  e.forEach(function(t) {
    t.interactionId && (Or = Math.min(Or, t.interactionId), En = Math.max(En, t.interactionId), c_ = En ? (En - Or) / 7 + 1 : 0);
  });
}, Ai = function() {
  return kr ? c_ : performance.interactionCount || 0;
}, RS = function() {
  "interactionCount" in performance || kr || (kr = we("event", OS, { type: "event", buffered: !0, durationThreshold: 0 }));
}, Yt = [], mn = /* @__PURE__ */ new Map(), Oi = 0, bS = [], NS = function(e) {
  if (bS.forEach(function(o) {
    return o(e);
  }), e.interactionId || e.entryType === "first-input") {
    var t = Yt[Yt.length - 1], n = mn.get(e.interactionId);
    if (n || Yt.length < 10 || e.duration > t.latency) {
      if (n) e.duration > n.latency ? (n.entries = [e], n.latency = e.duration) : e.duration === n.latency && e.startTime === n.entries[0].startTime && n.entries.push(e);
      else {
        var r = { id: e.interactionId, latency: e.duration, entries: [e] };
        mn.set(r.id, r), Yt.push(r);
      }
      Yt.sort(function(o, i) {
        return i.latency - o.latency;
      }), Yt.length > 10 && Yt.splice(10).forEach(function(o) {
        return mn.delete(o.id);
      });
    }
  }
}, l_ = function(e) {
  var t = self.requestIdleCallback || self.setTimeout, n = -1;
  return e = Hn(e), document.visibilityState === "hidden" ? e() : (n = t(e), Qe(e)), n;
}, Ri = [200, 500], GL = function(e, t) {
  "PerformanceEventTiming" in self && "interactionId" in PerformanceEventTiming.prototype && (t = t || {}, Je(function() {
    var n;
    RS();
    var r, o = Ut("INP"), i = function(u) {
      l_(function() {
        u.forEach(NS);
        var c = function() {
          var l = Math.min(Yt.length - 1, Math.floor((Ai() - Oi) / 50));
          return Yt[l];
        }();
        c && c.latency !== o.value && (o.value = c.latency, o.entries = c.entries, r());
      });
    }, a = we("event", i, { durationThreshold: (n = t.durationThreshold) !== null && n !== void 0 ? n : 40 });
    r = kt(e, o, Ri, t.reportAllChanges), a && (a.observe({ type: "first-input", buffered: !0 }), Qe(function() {
      i(a.takeRecords()), r(!0);
    }), ve(function() {
      Oi = Ai(), Yt.length = 0, mn.clear(), o = Ut("INP"), r = kt(e, o, Ri, t.reportAllChanges);
    }));
  }));
}, bi = [2500, 4e3], Rr = {}, HL = function(e, t) {
  t = t || {}, Je(function() {
    var n, r = qr(), o = Ut("LCP"), i = function(c) {
      t.reportAllChanges || (c = c.slice(-1)), c.forEach(function(l) {
        l.startTime < r.firstHiddenTime && (o.value = Math.max(l.startTime - Gn(), 0), o.entries = [l], n());
      });
    }, a = we("largest-contentful-paint", i);
    if (a) {
      n = kt(e, o, bi, t.reportAllChanges);
      var u = Hn(function() {
        Rr[o.id] || (i(a.takeRecords()), a.disconnect(), Rr[o.id] = !0, n(!0));
      });
      ["keydown", "click"].forEach(function(c) {
        addEventListener(c, function() {
          return l_(u);
        }, { once: !0, capture: !0 });
      }), Qe(u), ve(function(c) {
        o = Ut("LCP"), n = kt(e, o, bi, t.reportAllChanges), Kr(function() {
          o.value = performance.now() - c.timeStamp, Rr[o.id] = !0, n(!0);
        });
      });
    }
  });
}, Ni = [800, 1800], LS = function e(t) {
  document.prerendering ? Je(function() {
    return e(t);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(t);
  }, !0) : setTimeout(t, 0);
}, jL = function(e, t) {
  t = t || {};
  var n = Ut("TTFB"), r = kt(e, n, Ni, t.reportAllChanges);
  LS(function() {
    var o = Wr();
    o && (n.value = Math.max(o.responseStart - Gn(), 0), n.entries = [o], r(!0), ve(function() {
      n = Ut("TTFB", 0), (r = kt(e, n, Ni, t.reportAllChanges))(!0);
    }));
  });
}, Be = { passive: !0, capture: !0 }, CS = /* @__PURE__ */ new Date(), Li = function(e, t) {
  ie || (ie = t, Fe = e, s_ = /* @__PURE__ */ new Date(), f_(removeEventListener), p_());
}, p_ = function() {
  if (Fe >= 0 && Fe < s_ - CS) {
    var e = { entryType: "first-input", name: ie.type, target: ie.target, cancelable: ie.cancelable, startTime: ie.timeStamp, processingStart: ie.timeStamp + Fe };
    wn.forEach(function(t) {
      t(e);
    }), wn = [];
  }
}, wS = function(e) {
  if (e.cancelable) {
    var t = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(n, r) {
      var o = function() {
        Li(n, r), a();
      }, i = function() {
        a();
      }, a = function() {
        removeEventListener("pointerup", o, Be), removeEventListener("pointercancel", i, Be);
      };
      addEventListener("pointerup", o, Be), addEventListener("pointercancel", i, Be);
    }(t, e) : Li(t, e);
  }
}, f_ = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(t) {
    return e(t, wS, Be);
  });
}, Ci = [100, 300], FL = function(e, t) {
  t = t || {}, Je(function() {
    var n, r = qr(), o = Ut("FID"), i = function(c) {
      c.startTime < r.firstHiddenTime && (o.value = c.processingStart - c.startTime, o.entries.push(c), n(!0));
    }, a = function(c) {
      c.forEach(i);
    }, u = we("first-input", a);
    n = kt(e, o, Ci, t.reportAllChanges), u && (Qe(Hn(function() {
      a(u.takeRecords()), u.disconnect();
    })), ve(function() {
      var c;
      o = Ut("FID"), n = kt(e, o, Ci, t.reportAllChanges), wn = [], Fe = -1, ie = null, f_(addEventListener), c = i, wn.push(c), p_();
    }));
  });
};
export {
  wb as ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_ABORTED,
  Mb as ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_HANDLED,
  Pb as ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_SKIPPED,
  Ib as ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_UNHANDLED,
  xb as ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ACQUIRED,
  Vb as ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ENDPOINT_LIMITER,
  Bb as ASPNETCORE_RATE_LIMITING_RESULT_VALUE_GLOBAL_LIMITER,
  Gb as ASPNETCORE_RATE_LIMITING_RESULT_VALUE_REQUEST_CANCELED,
  Yb as ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_FAILURE,
  zb as ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_SUCCESS,
  Cb as ATTR_ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT,
  Db as ATTR_ASPNETCORE_DIAGNOSTICS_HANDLER_TYPE,
  Ub as ATTR_ASPNETCORE_RATE_LIMITING_POLICY,
  kb as ATTR_ASPNETCORE_RATE_LIMITING_RESULT,
  Hb as ATTR_ASPNETCORE_REQUEST_IS_UNHANDLED,
  jb as ATTR_ASPNETCORE_ROUTING_IS_FALLBACK,
  Fb as ATTR_ASPNETCORE_ROUTING_MATCH_STATUS,
  Zb as ATTR_CLIENT_ADDRESS,
  Xb as ATTR_CLIENT_PORT,
  Wb as ATTR_DOTNET_GC_HEAP_GENERATION,
  t0 as ATTR_ERROR_TYPE,
  n0 as ATTR_EXCEPTION_ESCAPED,
  r0 as ATTR_EXCEPTION_MESSAGE,
  o0 as ATTR_EXCEPTION_STACKTRACE,
  i0 as ATTR_EXCEPTION_TYPE,
  a0 as ATTR_HTTP_REQUEST_HEADER,
  s0 as ATTR_HTTP_REQUEST_METHOD,
  S0 as ATTR_HTTP_REQUEST_METHOD_ORIGINAL,
  y0 as ATTR_HTTP_REQUEST_RESEND_COUNT,
  v0 as ATTR_HTTP_RESPONSE_HEADER,
  m0 as ATTR_HTTP_RESPONSE_STATUS_CODE,
  g0 as ATTR_HTTP_ROUTE,
  A0 as ATTR_JVM_GC_ACTION,
  O0 as ATTR_JVM_GC_NAME,
  R0 as ATTR_JVM_MEMORY_POOL_NAME,
  b0 as ATTR_JVM_MEMORY_TYPE,
  C0 as ATTR_JVM_THREAD_DAEMON,
  w0 as ATTR_JVM_THREAD_STATE,
  x0 as ATTR_NETWORK_LOCAL_ADDRESS,
  V0 as ATTR_NETWORK_LOCAL_PORT,
  B0 as ATTR_NETWORK_PEER_ADDRESS,
  G0 as ATTR_NETWORK_PEER_PORT,
  H0 as ATTR_NETWORK_PROTOCOL_NAME,
  j0 as ATTR_NETWORK_PROTOCOL_VERSION,
  F0 as ATTR_NETWORK_TRANSPORT,
  K0 as ATTR_NETWORK_TYPE,
  J0 as ATTR_OTEL_SCOPE_NAME,
  $0 as ATTR_OTEL_SCOPE_VERSION,
  tN as ATTR_OTEL_STATUS_CODE,
  rN as ATTR_OTEL_STATUS_DESCRIPTION,
  oN as ATTR_SERVER_ADDRESS,
  iN as ATTR_SERVER_PORT,
  aN as ATTR_SERVICE_NAME,
  sN as ATTR_SERVICE_VERSION,
  uN as ATTR_SIGNALR_CONNECTION_STATUS,
  fN as ATTR_SIGNALR_TRANSPORT,
  dN as ATTR_TELEMETRY_SDK_LANGUAGE,
  CN as ATTR_TELEMETRY_SDK_NAME,
  wN as ATTR_TELEMETRY_SDK_VERSION,
  MN as ATTR_URL_FRAGMENT,
  PN as ATTR_URL_FULL,
  IN as ATTR_URL_PATH,
  DN as ATTR_URL_QUERY,
  UN as ATTR_URL_SCHEME,
  kN as ATTR_USER_AGENT_ORIGINAL,
  KR as AWSECSLAUNCHTYPEVALUES_EC2,
  qR as AWSECSLAUNCHTYPEVALUES_FARGATE,
  Cn as AggregationTemporalityPreference,
  QR as AwsEcsLaunchtypeValues,
  MR as CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS,
  PR as CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC,
  IR as CLOUDPLATFORMVALUES_AWS_EC2,
  DR as CLOUDPLATFORMVALUES_AWS_ECS,
  UR as CLOUDPLATFORMVALUES_AWS_EKS,
  xR as CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK,
  kR as CLOUDPLATFORMVALUES_AWS_LAMBDA,
  GR as CLOUDPLATFORMVALUES_AZURE_AKS,
  jR as CLOUDPLATFORMVALUES_AZURE_APP_SERVICE,
  BR as CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES,
  HR as CLOUDPLATFORMVALUES_AZURE_FUNCTIONS,
  VR as CLOUDPLATFORMVALUES_AZURE_VM,
  XR as CLOUDPLATFORMVALUES_GCP_APP_ENGINE,
  ZR as CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS,
  YR as CLOUDPLATFORMVALUES_GCP_CLOUD_RUN,
  FR as CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE,
  zR as CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE,
  bR as CLOUDPROVIDERVALUES_ALIBABA_CLOUD,
  NR as CLOUDPROVIDERVALUES_AWS,
  LR as CLOUDPROVIDERVALUES_AZURE,
  CR as CLOUDPROVIDERVALUES_GCP,
  gi as CLSThresholds,
  WR as CloudPlatformValues,
  wR as CloudProviderValues,
  Ar as CumulativeTemporalitySelector,
  lg as DBCASSANDRACONSISTENCYLEVELVALUES_ALL,
  Sg as DBCASSANDRACONSISTENCYLEVELVALUES_ANY,
  pg as DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM,
  Tg as DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE,
  _g as DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM,
  vg as DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL,
  hg as DBCASSANDRACONSISTENCYLEVELVALUES_ONE,
  fg as DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM,
  yg as DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL,
  dg as DBCASSANDRACONSISTENCYLEVELVALUES_THREE,
  Eg as DBCASSANDRACONSISTENCYLEVELVALUES_TWO,
  Im as DBSYSTEMVALUES_ADABAS,
  Pm as DBSYSTEMVALUES_CACHE,
  qm as DBSYSTEMVALUES_CASSANDRA,
  Om as DBSYSTEMVALUES_CLOUDSCAPE,
  ug as DBSYSTEMVALUES_COCKROACHDB,
  Km as DBSYSTEMVALUES_COLDFUSION,
  ng as DBSYSTEMVALUES_COSMOSDB,
  tg as DBSYSTEMVALUES_COUCHBASE,
  eg as DBSYSTEMVALUES_COUCHDB,
  vm as DBSYSTEMVALUES_DB2,
  Um as DBSYSTEMVALUES_DERBY,
  rg as DBSYSTEMVALUES_DYNAMODB,
  Mm as DBSYSTEMVALUES_EDB,
  ag as DBSYSTEMVALUES_ELASTICSEARCH,
  km as DBSYSTEMVALUES_FILEMAKER,
  Dm as DBSYSTEMVALUES_FIREBIRD,
  wm as DBSYSTEMVALUES_FIRSTSQL,
  ig as DBSYSTEMVALUES_GEODE,
  Wm as DBSYSTEMVALUES_H2,
  Lm as DBSYSTEMVALUES_HANADB,
  Qm as DBSYSTEMVALUES_HBASE,
  Am as DBSYSTEMVALUES_HIVE,
  Rm as DBSYSTEMVALUES_HSQLDB,
  xm as DBSYSTEMVALUES_INFORMIX,
  Cm as DBSYSTEMVALUES_INGRES,
  Vm as DBSYSTEMVALUES_INSTANTDB,
  Bm as DBSYSTEMVALUES_INTERBASE,
  Gm as DBSYSTEMVALUES_MARIADB,
  Nm as DBSYSTEMVALUES_MAXDB,
  sg as DBSYSTEMVALUES_MEMCACHED,
  Jm as DBSYSTEMVALUES_MONGODB,
  Tm as DBSYSTEMVALUES_MSSQL,
  Sm as DBSYSTEMVALUES_MYSQL,
  og as DBSYSTEMVALUES_NEO4J,
  Hm as DBSYSTEMVALUES_NETEZZA,
  ym as DBSYSTEMVALUES_ORACLE,
  dm as DBSYSTEMVALUES_OTHER_SQL,
  jm as DBSYSTEMVALUES_PERVASIVE,
  Fm as DBSYSTEMVALUES_POINTBASE,
  mm as DBSYSTEMVALUES_POSTGRESQL,
  bm as DBSYSTEMVALUES_PROGRESS,
  $m as DBSYSTEMVALUES_REDIS,
  gm as DBSYSTEMVALUES_REDSHIFT,
  Ym as DBSYSTEMVALUES_SQLITE,
  zm as DBSYSTEMVALUES_SYBASE,
  Zm as DBSYSTEMVALUES_TERADATA,
  Xm as DBSYSTEMVALUES_VERTICA,
  Kb as DOTNET_GC_HEAP_GENERATION_VALUE_GEN0,
  qb as DOTNET_GC_HEAP_GENERATION_VALUE_GEN1,
  Qb as DOTNET_GC_HEAP_GENERATION_VALUE_GEN2,
  Jb as DOTNET_GC_HEAP_GENERATION_VALUE_LOH,
  $b as DOTNET_GC_HEAP_GENERATION_VALUE_POH,
  mg as DbCassandraConsistencyLevelValues,
  cg as DbSystemValues,
  hi as DeltaTemporalitySelector,
  MS as DiagConsoleLogger,
  yt as DiagLogLevel,
  e0 as ERROR_TYPE_VALUE_OTHER,
  wg as FAASDOCUMENTOPERATIONVALUES_DELETE,
  Cg as FAASDOCUMENTOPERATIONVALUES_EDIT,
  Lg as FAASDOCUMENTOPERATIONVALUES_INSERT,
  Pg as FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD,
  Ig as FAASINVOKEDPROVIDERVALUES_AWS,
  Dg as FAASINVOKEDPROVIDERVALUES_AZURE,
  Ug as FAASINVOKEDPROVIDERVALUES_GCP,
  gg as FAASTRIGGERVALUES_DATASOURCE,
  Ag as FAASTRIGGERVALUES_HTTP,
  bg as FAASTRIGGERVALUES_OTHER,
  Og as FAASTRIGGERVALUES_PUBSUB,
  Rg as FAASTRIGGERVALUES_TIMER,
  mi as FCPThresholds,
  Ci as FIDThresholds,
  Mg as FaasDocumentOperationValues,
  kg as FaasInvokedProviderValues,
  Ng as FaasTriggerValues,
  JR as HOSTARCHVALUES_AMD64,
  $R as HOSTARCHVALUES_ARM32,
  tb as HOSTARCHVALUES_ARM64,
  eb as HOSTARCHVALUES_IA64,
  nb as HOSTARCHVALUES_PPC32,
  rb as HOSTARCHVALUES_PPC64,
  ob as HOSTARCHVALUES_X86,
  yA as HTTPFLAVORVALUES_HTTP_1_0,
  vA as HTTPFLAVORVALUES_HTTP_1_1,
  mA as HTTPFLAVORVALUES_HTTP_2_0,
  AA as HTTPFLAVORVALUES_QUIC,
  gA as HTTPFLAVORVALUES_SPDY,
  c0 as HTTP_REQUEST_METHOD_VALUE_CONNECT,
  l0 as HTTP_REQUEST_METHOD_VALUE_DELETE,
  p0 as HTTP_REQUEST_METHOD_VALUE_GET,
  f0 as HTTP_REQUEST_METHOD_VALUE_HEAD,
  _0 as HTTP_REQUEST_METHOD_VALUE_OPTIONS,
  u0 as HTTP_REQUEST_METHOD_VALUE_OTHER,
  h0 as HTTP_REQUEST_METHOD_VALUE_PATCH,
  E0 as HTTP_REQUEST_METHOD_VALUE_POST,
  d0 as HTTP_REQUEST_METHOD_VALUE_PUT,
  T0 as HTTP_REQUEST_METHOD_VALUE_TRACE,
  ib as HostArchValues,
  OA as HttpFlavorValues,
  Ri as INPThresholds,
  Mi as INVALID_SPANID,
  Ii as INVALID_SPAN_CONTEXT,
  Pi as INVALID_TRACEID,
  xn as InstrumentationBase,
  WS as InstrumentationNodeModuleDefinition,
  KS as InstrumentationNodeModuleFile,
  N0 as JVM_MEMORY_TYPE_VALUE_HEAP,
  L0 as JVM_MEMORY_TYPE_VALUE_NON_HEAP,
  M0 as JVM_THREAD_STATE_VALUE_BLOCKED,
  P0 as JVM_THREAD_STATE_VALUE_NEW,
  I0 as JVM_THREAD_STATE_VALUE_RUNNABLE,
  D0 as JVM_THREAD_STATE_VALUE_TERMINATED,
  U0 as JVM_THREAD_STATE_VALUE_TIMED_WAITING,
  k0 as JVM_THREAD_STATE_VALUE_WAITING,
  bi as LCPThresholds,
  Ei as LowMemoryTemporalitySelector,
  qA as MESSAGETYPEVALUES_RECEIVED,
  KA as MESSAGETYPEVALUES_SENT,
  RA as MESSAGINGDESTINATIONKINDVALUES_QUEUE,
  bA as MESSAGINGDESTINATIONKINDVALUES_TOPIC,
  CA as MESSAGINGOPERATIONVALUES_PROCESS,
  LA as MESSAGINGOPERATIONVALUES_RECEIVE,
  xN as METRIC_ASPNETCORE_DIAGNOSTICS_EXCEPTIONS,
  VN as METRIC_ASPNETCORE_RATE_LIMITING_ACTIVE_REQUEST_LEASES,
  BN as METRIC_ASPNETCORE_RATE_LIMITING_QUEUED_REQUESTS,
  jN as METRIC_ASPNETCORE_RATE_LIMITING_REQUESTS,
  HN as METRIC_ASPNETCORE_RATE_LIMITING_REQUEST_LEASE_DURATION,
  GN as METRIC_ASPNETCORE_RATE_LIMITING_REQUEST_TIME_IN_QUEUE,
  FN as METRIC_ASPNETCORE_ROUTING_MATCH_ATTEMPTS,
  YN as METRIC_DOTNET_ASSEMBLY_COUNT,
  zN as METRIC_DOTNET_EXCEPTIONS,
  ZN as METRIC_DOTNET_GC_COLLECTIONS,
  XN as METRIC_DOTNET_GC_HEAP_TOTAL_ALLOCATED,
  WN as METRIC_DOTNET_GC_LAST_COLLECTION_HEAP_FRAGMENTATION_SIZE,
  KN as METRIC_DOTNET_GC_LAST_COLLECTION_HEAP_SIZE,
  qN as METRIC_DOTNET_GC_LAST_COLLECTION_MEMORY_COMMITTED_SIZE,
  QN as METRIC_DOTNET_GC_PAUSE_TIME,
  JN as METRIC_DOTNET_JIT_COMPILATION_TIME,
  $N as METRIC_DOTNET_JIT_COMPILED_IL_SIZE,
  tL as METRIC_DOTNET_JIT_COMPILED_METHODS,
  eL as METRIC_DOTNET_MONITOR_LOCK_CONTENTIONS,
  nL as METRIC_DOTNET_PROCESS_CPU_COUNT,
  rL as METRIC_DOTNET_PROCESS_CPU_TIME,
  oL as METRIC_DOTNET_PROCESS_MEMORY_WORKING_SET,
  iL as METRIC_DOTNET_THREAD_POOL_QUEUE_LENGTH,
  aL as METRIC_DOTNET_THREAD_POOL_THREAD_COUNT,
  sL as METRIC_DOTNET_THREAD_POOL_WORK_ITEM_COUNT,
  uL as METRIC_DOTNET_TIMER_COUNT,
  cL as METRIC_HTTP_CLIENT_REQUEST_DURATION,
  lL as METRIC_HTTP_SERVER_REQUEST_DURATION,
  pL as METRIC_JVM_CLASS_COUNT,
  fL as METRIC_JVM_CLASS_LOADED,
  _L as METRIC_JVM_CLASS_UNLOADED,
  hL as METRIC_JVM_CPU_COUNT,
  EL as METRIC_JVM_CPU_RECENT_UTILIZATION,
  dL as METRIC_JVM_CPU_TIME,
  TL as METRIC_JVM_GC_DURATION,
  SL as METRIC_JVM_MEMORY_COMMITTED,
  yL as METRIC_JVM_MEMORY_LIMIT,
  vL as METRIC_JVM_MEMORY_USED,
  mL as METRIC_JVM_MEMORY_USED_AFTER_LAST_GC,
  gL as METRIC_JVM_THREAD_COUNT,
  AL as METRIC_KESTREL_ACTIVE_CONNECTIONS,
  OL as METRIC_KESTREL_ACTIVE_TLS_HANDSHAKES,
  RL as METRIC_KESTREL_CONNECTION_DURATION,
  bL as METRIC_KESTREL_QUEUED_CONNECTIONS,
  NL as METRIC_KESTREL_QUEUED_REQUESTS,
  LL as METRIC_KESTREL_REJECTED_CONNECTIONS,
  CL as METRIC_KESTREL_TLS_HANDSHAKE_DURATION,
  wL as METRIC_KESTREL_UPGRADED_CONNECTIONS,
  ML as METRIC_SIGNALR_SERVER_ACTIVE_CONNECTIONS,
  PL as METRIC_SIGNALR_SERVER_CONNECTION_DURATION,
  QA as MessageTypeValues,
  NA as MessagingDestinationKindValues,
  wA as MessagingOperationValues,
  kL as MeterProvider,
  tA as NETHOSTCONNECTIONSUBTYPEVALUES_CDMA,
  rA as NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT,
  Jg as NETHOSTCONNECTIONSUBTYPEVALUES_EDGE,
  lA as NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD,
  eA as NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0,
  nA as NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A,
  uA as NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B,
  Qg as NETHOSTCONNECTIONSUBTYPEVALUES_GPRS,
  fA as NETHOSTCONNECTIONSUBTYPEVALUES_GSM,
  oA as NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA,
  aA as NETHOSTCONNECTIONSUBTYPEVALUES_HSPA,
  pA as NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP,
  iA as NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA,
  sA as NETHOSTCONNECTIONSUBTYPEVALUES_IDEN,
  hA as NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN,
  cA as NETHOSTCONNECTIONSUBTYPEVALUES_LTE,
  TA as NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA,
  EA as NETHOSTCONNECTIONSUBTYPEVALUES_NR,
  dA as NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA,
  _A as NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA,
  $g as NETHOSTCONNECTIONSUBTYPEVALUES_UMTS,
  Xg as NETHOSTCONNECTIONTYPEVALUES_CELL,
  Wg as NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE,
  Kg as NETHOSTCONNECTIONTYPEVALUES_UNKNOWN,
  zg as NETHOSTCONNECTIONTYPEVALUES_WIFI,
  Zg as NETHOSTCONNECTIONTYPEVALUES_WIRED,
  jg as NETTRANSPORTVALUES_INPROC,
  Bg as NETTRANSPORTVALUES_IP,
  xg as NETTRANSPORTVALUES_IP_TCP,
  Vg as NETTRANSPORTVALUES_IP_UDP,
  Fg as NETTRANSPORTVALUES_OTHER,
  Hg as NETTRANSPORTVALUES_PIPE,
  Gg as NETTRANSPORTVALUES_UNIX,
  Y0 as NETWORK_TRANSPORT_VALUE_PIPE,
  z0 as NETWORK_TRANSPORT_VALUE_QUIC,
  Z0 as NETWORK_TRANSPORT_VALUE_TCP,
  X0 as NETWORK_TRANSPORT_VALUE_UDP,
  W0 as NETWORK_TRANSPORT_VALUE_UNIX,
  q0 as NETWORK_TYPE_VALUE_IPV4,
  Q0 as NETWORK_TYPE_VALUE_IPV6,
  SA as NetHostConnectionSubtypeValues,
  qg as NetHostConnectionTypeValues,
  Yg as NetTransportValues,
  hb as OSTYPEVALUES_AIX,
  ub as OSTYPEVALUES_DARWIN,
  fb as OSTYPEVALUES_DRAGONFLYBSD,
  cb as OSTYPEVALUES_FREEBSD,
  _b as OSTYPEVALUES_HPUX,
  sb as OSTYPEVALUES_LINUX,
  lb as OSTYPEVALUES_NETBSD,
  pb as OSTYPEVALUES_OPENBSD,
  Eb as OSTYPEVALUES_SOLARIS,
  ab as OSTYPEVALUES_WINDOWS,
  db as OSTYPEVALUES_Z_OS,
  eN as OTEL_STATUS_CODE_VALUE_ERROR,
  nN as OTEL_STATUS_CODE_VALUE_OK,
  xL as OTLPMetricExporter,
  KT as OTLPMetricExporterBase,
  VL as OTLPTraceExporter,
  Tb as OsTypeValues,
  UL as PeriodicExportingMetricReader,
  vh as ProxyTracer,
  yo as ProxyTracerProvider,
  Zt as ROOT_CONTEXT,
  HA as RPCGRPCSTATUSCODEVALUES_ABORTED,
  xA as RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS,
  PA as RPCGRPCSTATUSCODEVALUES_CANCELLED,
  ZA as RPCGRPCSTATUSCODEVALUES_DATA_LOSS,
  UA as RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED,
  GA as RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION,
  YA as RPCGRPCSTATUSCODEVALUES_INTERNAL,
  DA as RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT,
  kA as RPCGRPCSTATUSCODEVALUES_NOT_FOUND,
  MA as RPCGRPCSTATUSCODEVALUES_OK,
  jA as RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE,
  VA as RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED,
  BA as RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED,
  XA as RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED,
  zA as RPCGRPCSTATUSCODEVALUES_UNAVAILABLE,
  FA as RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED,
  IA as RPCGRPCSTATUSCODEVALUES_UNKNOWN,
  Nt as Resource,
  WA as RpcGrpcStatusCodeValues,
  Ov as SEMATTRS_AWS_DYNAMODB_ATTRIBUTES_TO_GET,
  kv as SEMATTRS_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS,
  mv as SEMATTRS_AWS_DYNAMODB_CONSISTENT_READ,
  Tv as SEMATTRS_AWS_DYNAMODB_CONSUMED_CAPACITY,
  Dv as SEMATTRS_AWS_DYNAMODB_COUNT,
  Cv as SEMATTRS_AWS_DYNAMODB_EXCLUSIVE_START_TABLE,
  Nv as SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES,
  xv as SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES,
  Rv as SEMATTRS_AWS_DYNAMODB_INDEX_NAME,
  Sv as SEMATTRS_AWS_DYNAMODB_ITEM_COLLECTION_METRICS,
  Av as SEMATTRS_AWS_DYNAMODB_LIMIT,
  Lv as SEMATTRS_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES,
  gv as SEMATTRS_AWS_DYNAMODB_PROJECTION,
  yv as SEMATTRS_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY,
  vv as SEMATTRS_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY,
  Uv as SEMATTRS_AWS_DYNAMODB_SCANNED_COUNT,
  Mv as SEMATTRS_AWS_DYNAMODB_SCAN_FORWARD,
  Pv as SEMATTRS_AWS_DYNAMODB_SEGMENT,
  bv as SEMATTRS_AWS_DYNAMODB_SELECT,
  wv as SEMATTRS_AWS_DYNAMODB_TABLE_COUNT,
  dv as SEMATTRS_AWS_DYNAMODB_TABLE_NAMES,
  Iv as SEMATTRS_AWS_DYNAMODB_TOTAL_SEGMENTS,
  QS as SEMATTRS_AWS_LAMBDA_INVOKED_ARN,
  ev as SEMATTRS_CODE_FILEPATH,
  $y as SEMATTRS_CODE_FUNCTION,
  nv as SEMATTRS_CODE_LINENO,
  tv as SEMATTRS_CODE_NAMESPACE,
  uy as SEMATTRS_DB_CASSANDRA_CONSISTENCY_LEVEL,
  _y as SEMATTRS_DB_CASSANDRA_COORDINATOR_DC,
  fy as SEMATTRS_DB_CASSANDRA_COORDINATOR_ID,
  ly as SEMATTRS_DB_CASSANDRA_IDEMPOTENCE,
  ay as SEMATTRS_DB_CASSANDRA_KEYSPACE,
  sy as SEMATTRS_DB_CASSANDRA_PAGE_SIZE,
  py as SEMATTRS_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT,
  cy as SEMATTRS_DB_CASSANDRA_TABLE,
  $S as SEMATTRS_DB_CONNECTION_STRING,
  hy as SEMATTRS_DB_HBASE_NAMESPACE,
  ey as SEMATTRS_DB_JDBC_DRIVER_CLASSNAME,
  dy as SEMATTRS_DB_MONGODB_COLLECTION,
  iy as SEMATTRS_DB_MSSQL_INSTANCE_NAME,
  ny as SEMATTRS_DB_NAME,
  oy as SEMATTRS_DB_OPERATION,
  Ey as SEMATTRS_DB_REDIS_DATABASE_INDEX,
  Ty as SEMATTRS_DB_SQL_TABLE,
  ry as SEMATTRS_DB_STATEMENT,
  JS as SEMATTRS_DB_SYSTEM,
  ty as SEMATTRS_DB_USER,
  Wy as SEMATTRS_ENDUSER_ID,
  Ky as SEMATTRS_ENDUSER_ROLE,
  qy as SEMATTRS_ENDUSER_SCOPE,
  my as SEMATTRS_EXCEPTION_ESCAPED,
  yy as SEMATTRS_EXCEPTION_MESSAGE,
  vy as SEMATTRS_EXCEPTION_STACKTRACE,
  Sy as SEMATTRS_EXCEPTION_TYPE,
  wy as SEMATTRS_FAAS_COLDSTART,
  Cy as SEMATTRS_FAAS_CRON,
  Oy as SEMATTRS_FAAS_DOCUMENT_COLLECTION,
  Ny as SEMATTRS_FAAS_DOCUMENT_NAME,
  Ry as SEMATTRS_FAAS_DOCUMENT_OPERATION,
  by as SEMATTRS_FAAS_DOCUMENT_TIME,
  Ay as SEMATTRS_FAAS_EXECUTION,
  My as SEMATTRS_FAAS_INVOKED_NAME,
  Py as SEMATTRS_FAAS_INVOKED_PROVIDER,
  Iy as SEMATTRS_FAAS_INVOKED_REGION,
  Ly as SEMATTRS_FAAS_TIME,
  gy as SEMATTRS_FAAS_TRIGGER,
  Ev as SEMATTRS_HTTP_CLIENT_IP,
  uv as SEMATTRS_HTTP_FLAVOR,
  iv as SEMATTRS_HTTP_HOST,
  rv as SEMATTRS_HTTP_METHOD,
  cv as SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH,
  lv as SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED,
  pv as SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH,
  fv as SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED,
  hv as SEMATTRS_HTTP_ROUTE,
  av as SEMATTRS_HTTP_SCHEME,
  _v as SEMATTRS_HTTP_SERVER_NAME,
  sv as SEMATTRS_HTTP_STATUS_CODE,
  ov as SEMATTRS_HTTP_TARGET,
  cr as SEMATTRS_HTTP_URL,
  KE as SEMATTRS_HTTP_USER_AGENT,
  _m as SEMATTRS_MESSAGE_COMPRESSED_SIZE,
  fm as SEMATTRS_MESSAGE_ID,
  pm as SEMATTRS_MESSAGE_TYPE,
  hm as SEMATTRS_MESSAGE_UNCOMPRESSED_SIZE,
  qv as SEMATTRS_MESSAGING_CONSUMER_ID,
  Zv as SEMATTRS_MESSAGING_CONVERSATION_ID,
  Bv as SEMATTRS_MESSAGING_DESTINATION,
  Gv as SEMATTRS_MESSAGING_DESTINATION_KIND,
  tm as SEMATTRS_MESSAGING_KAFKA_CLIENT_ID,
  $v as SEMATTRS_MESSAGING_KAFKA_CONSUMER_GROUP,
  Jv as SEMATTRS_MESSAGING_KAFKA_MESSAGE_KEY,
  em as SEMATTRS_MESSAGING_KAFKA_PARTITION,
  nm as SEMATTRS_MESSAGING_KAFKA_TOMBSTONE,
  zv as SEMATTRS_MESSAGING_MESSAGE_ID,
  Wv as SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES,
  Xv as SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES,
  Kv as SEMATTRS_MESSAGING_OPERATION,
  jv as SEMATTRS_MESSAGING_PROTOCOL,
  Fv as SEMATTRS_MESSAGING_PROTOCOL_VERSION,
  Qv as SEMATTRS_MESSAGING_RABBITMQ_ROUTING_KEY,
  Vv as SEMATTRS_MESSAGING_SYSTEM,
  Hv as SEMATTRS_MESSAGING_TEMP_DESTINATION,
  Yv as SEMATTRS_MESSAGING_URL,
  Zy as SEMATTRS_NET_HOST_CARRIER_ICC,
  Yy as SEMATTRS_NET_HOST_CARRIER_MCC,
  zy as SEMATTRS_NET_HOST_CARRIER_MNC,
  Fy as SEMATTRS_NET_HOST_CARRIER_NAME,
  jy as SEMATTRS_NET_HOST_CONNECTION_SUBTYPE,
  Hy as SEMATTRS_NET_HOST_CONNECTION_TYPE,
  Vy as SEMATTRS_NET_HOST_IP,
  Gy as SEMATTRS_NET_HOST_NAME,
  By as SEMATTRS_NET_HOST_PORT,
  Uy as SEMATTRS_NET_PEER_IP,
  xy as SEMATTRS_NET_PEER_NAME,
  ky as SEMATTRS_NET_PEER_PORT,
  Dy as SEMATTRS_NET_TRANSPORT,
  Xy as SEMATTRS_PEER_SERVICE,
  am as SEMATTRS_RPC_GRPC_STATUS_CODE,
  cm as SEMATTRS_RPC_JSONRPC_ERROR_CODE,
  lm as SEMATTRS_RPC_JSONRPC_ERROR_MESSAGE,
  um as SEMATTRS_RPC_JSONRPC_REQUEST_ID,
  sm as SEMATTRS_RPC_JSONRPC_VERSION,
  im as SEMATTRS_RPC_METHOD,
  om as SEMATTRS_RPC_SERVICE,
  rm as SEMATTRS_RPC_SYSTEM,
  Qy as SEMATTRS_THREAD_ID,
  Jy as SEMATTRS_THREAD_NAME,
  oO as SEMRESATTRS_AWS_ECS_CLUSTER_ARN,
  rO as SEMRESATTRS_AWS_ECS_CONTAINER_ARN,
  iO as SEMRESATTRS_AWS_ECS_LAUNCHTYPE,
  aO as SEMRESATTRS_AWS_ECS_TASK_ARN,
  sO as SEMRESATTRS_AWS_ECS_TASK_FAMILY,
  uO as SEMRESATTRS_AWS_ECS_TASK_REVISION,
  cO as SEMRESATTRS_AWS_EKS_CLUSTER_ARN,
  pO as SEMRESATTRS_AWS_LOG_GROUP_ARNS,
  lO as SEMRESATTRS_AWS_LOG_GROUP_NAMES,
  _O as SEMRESATTRS_AWS_LOG_STREAM_ARNS,
  fO as SEMRESATTRS_AWS_LOG_STREAM_NAMES,
  $A as SEMRESATTRS_CLOUD_ACCOUNT_ID,
  eO as SEMRESATTRS_CLOUD_AVAILABILITY_ZONE,
  nO as SEMRESATTRS_CLOUD_PLATFORM,
  JA as SEMRESATTRS_CLOUD_PROVIDER,
  tO as SEMRESATTRS_CLOUD_REGION,
  EO as SEMRESATTRS_CONTAINER_ID,
  TO as SEMRESATTRS_CONTAINER_IMAGE_NAME,
  SO as SEMRESATTRS_CONTAINER_IMAGE_TAG,
  hO as SEMRESATTRS_CONTAINER_NAME,
  dO as SEMRESATTRS_CONTAINER_RUNTIME,
  yO as SEMRESATTRS_DEPLOYMENT_ENVIRONMENT,
  vO as SEMRESATTRS_DEVICE_ID,
  mO as SEMRESATTRS_DEVICE_MODEL_IDENTIFIER,
  gO as SEMRESATTRS_DEVICE_MODEL_NAME,
  OO as SEMRESATTRS_FAAS_ID,
  bO as SEMRESATTRS_FAAS_INSTANCE,
  NO as SEMRESATTRS_FAAS_MAX_MEMORY,
  AO as SEMRESATTRS_FAAS_NAME,
  RO as SEMRESATTRS_FAAS_VERSION,
  MO as SEMRESATTRS_HOST_ARCH,
  LO as SEMRESATTRS_HOST_ID,
  IO as SEMRESATTRS_HOST_IMAGE_ID,
  PO as SEMRESATTRS_HOST_IMAGE_NAME,
  DO as SEMRESATTRS_HOST_IMAGE_VERSION,
  CO as SEMRESATTRS_HOST_NAME,
  wO as SEMRESATTRS_HOST_TYPE,
  UO as SEMRESATTRS_K8S_CLUSTER_NAME,
  HO as SEMRESATTRS_K8S_CONTAINER_NAME,
  $O as SEMRESATTRS_K8S_CRONJOB_NAME,
  JO as SEMRESATTRS_K8S_CRONJOB_UID,
  KO as SEMRESATTRS_K8S_DAEMONSET_NAME,
  WO as SEMRESATTRS_K8S_DAEMONSET_UID,
  zO as SEMRESATTRS_K8S_DEPLOYMENT_NAME,
  YO as SEMRESATTRS_K8S_DEPLOYMENT_UID,
  QO as SEMRESATTRS_K8S_JOB_NAME,
  qO as SEMRESATTRS_K8S_JOB_UID,
  VO as SEMRESATTRS_K8S_NAMESPACE_NAME,
  kO as SEMRESATTRS_K8S_NODE_NAME,
  xO as SEMRESATTRS_K8S_NODE_UID,
  GO as SEMRESATTRS_K8S_POD_NAME,
  BO as SEMRESATTRS_K8S_POD_UID,
  FO as SEMRESATTRS_K8S_REPLICASET_NAME,
  jO as SEMRESATTRS_K8S_REPLICASET_UID,
  XO as SEMRESATTRS_K8S_STATEFULSET_NAME,
  ZO as SEMRESATTRS_K8S_STATEFULSET_UID,
  eR as SEMRESATTRS_OS_DESCRIPTION,
  nR as SEMRESATTRS_OS_NAME,
  tR as SEMRESATTRS_OS_TYPE,
  rR as SEMRESATTRS_OS_VERSION,
  sR as SEMRESATTRS_PROCESS_COMMAND,
  cR as SEMRESATTRS_PROCESS_COMMAND_ARGS,
  uR as SEMRESATTRS_PROCESS_COMMAND_LINE,
  iR as SEMRESATTRS_PROCESS_EXECUTABLE_NAME,
  aR as SEMRESATTRS_PROCESS_EXECUTABLE_PATH,
  lR as SEMRESATTRS_PROCESS_OWNER,
  oR as SEMRESATTRS_PROCESS_PID,
  _R as SEMRESATTRS_PROCESS_RUNTIME_DESCRIPTION,
  pR as SEMRESATTRS_PROCESS_RUNTIME_NAME,
  fR as SEMRESATTRS_PROCESS_RUNTIME_VERSION,
  dR as SEMRESATTRS_SERVICE_INSTANCE_ID,
  hR as SEMRESATTRS_SERVICE_NAME,
  ER as SEMRESATTRS_SERVICE_NAMESPACE,
  TR as SEMRESATTRS_SERVICE_VERSION,
  mR as SEMRESATTRS_TELEMETRY_AUTO_VERSION,
  yR as SEMRESATTRS_TELEMETRY_SDK_LANGUAGE,
  SR as SEMRESATTRS_TELEMETRY_SDK_NAME,
  vR as SEMRESATTRS_TELEMETRY_SDK_VERSION,
  OR as SEMRESATTRS_WEBENGINE_DESCRIPTION,
  gR as SEMRESATTRS_WEBENGINE_NAME,
  AR as SEMRESATTRS_WEBENGINE_VERSION,
  cN as SIGNALR_CONNECTION_STATUS_VALUE_APP_SHUTDOWN,
  lN as SIGNALR_CONNECTION_STATUS_VALUE_NORMAL_CLOSURE,
  pN as SIGNALR_CONNECTION_STATUS_VALUE_TIMEOUT,
  _N as SIGNALR_TRANSPORT_VALUE_LONG_POLLING,
  hN as SIGNALR_TRANSPORT_VALUE_SERVER_SENT_EVENTS,
  EN as SIGNALR_TRANSPORT_VALUE_WEB_SOCKETS,
  gn as SamplingDecision,
  Em as SemanticAttributes,
  RR as SemanticResourceAttributes,
  zS as SimpleSpanProcessor,
  Ze as SpanKind,
  br as SpanStatusCode,
  Sb as TELEMETRYSDKLANGUAGEVALUES_CPP,
  yb as TELEMETRYSDKLANGUAGEVALUES_DOTNET,
  vb as TELEMETRYSDKLANGUAGEVALUES_ERLANG,
  mb as TELEMETRYSDKLANGUAGEVALUES_GO,
  gb as TELEMETRYSDKLANGUAGEVALUES_JAVA,
  Ab as TELEMETRYSDKLANGUAGEVALUES_NODEJS,
  Ob as TELEMETRYSDKLANGUAGEVALUES_PHP,
  Rb as TELEMETRYSDKLANGUAGEVALUES_PYTHON,
  bb as TELEMETRYSDKLANGUAGEVALUES_RUBY,
  Nb as TELEMETRYSDKLANGUAGEVALUES_WEBJS,
  TN as TELEMETRY_SDK_LANGUAGE_VALUE_CPP,
  SN as TELEMETRY_SDK_LANGUAGE_VALUE_DOTNET,
  yN as TELEMETRY_SDK_LANGUAGE_VALUE_ERLANG,
  vN as TELEMETRY_SDK_LANGUAGE_VALUE_GO,
  mN as TELEMETRY_SDK_LANGUAGE_VALUE_JAVA,
  gN as TELEMETRY_SDK_LANGUAGE_VALUE_NODEJS,
  AN as TELEMETRY_SDK_LANGUAGE_VALUE_PHP,
  ON as TELEMETRY_SDK_LANGUAGE_VALUE_PYTHON,
  RN as TELEMETRY_SDK_LANGUAGE_VALUE_RUBY,
  bN as TELEMETRY_SDK_LANGUAGE_VALUE_RUST,
  NN as TELEMETRY_SDK_LANGUAGE_VALUE_SWIFT,
  LN as TELEMETRY_SDK_LANGUAGE_VALUE_WEBJS,
  Ni as TTFBThresholds,
  Lb as TelemetrySdkLanguageValues,
  Kt as TraceFlags,
  ae as ValueType,
  ZS as WebTracerProvider,
  DL as ZoneContextManager,
  G_ as baggageEntryMetadataFromString,
  HS as browserDetector,
  bE as browserDetectorSync,
  $ as context,
  xr as createContextKey,
  rh as createNoopMeter,
  PS as createTraceState,
  IS as defaultServiceName,
  oh as defaultTextMapGetter,
  ih as defaultTextMapSetter,
  FS as detectResources,
  YS as detectResourcesSync,
  w as diag,
  jS as envDetector,
  wE as envDetectorSync,
  IL as getWebAutoInstrumentations,
  DS as hostDetector,
  US as hostDetectorSync,
  Dn as isSpanContextValid,
  Th as isValidSpanId,
  Ui as isValidTraceId,
  mt as isWrapped,
  xi as metrics,
  BL as onCLS,
  AS as onFCP,
  FL as onFID,
  GL as onINP,
  HL as onLCP,
  jL as onTTFB,
  kS as osDetector,
  xS as osDetectorSync,
  VS as processDetector,
  BS as processDetectorSync,
  Pt as propagation,
  XS as registerInstrumentations,
  bn as safeExecuteInTheMiddle,
  qS as safeExecuteInTheMiddleAsync,
  GS as serviceInstanceIdDetectorSync,
  dt as trace
};
//# sourceMappingURL=telemetry.js.map
